// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAccountContactsByIdData, DeleteAccountContactsByIdErrors, DeleteAccountContactsByIdResponses, DeleteAccountNotesByIdData, DeleteAccountNotesByIdErrors, DeleteAccountNotesByIdResponses, DeleteAccountTagsByIdData, DeleteAccountTagsByIdErrors, DeleteAccountTagsByIdResponses, DeleteAdminPlansByIdData, DeleteAdminPlansByIdResponses, DeleteAdminTenantsByIdData, DeleteAdminTenantsByIdResponses, DeleteAgentBotsByIdData, DeleteAgentBotsByIdErrors, DeleteAgentBotsByIdResponses, DeleteAgentsByIdData, DeleteAgentsByIdErrors, DeleteAgentsByIdRemoveRoleByRoleIdData, DeleteAgentsByIdRemoveRoleByRoleIdErrors, DeleteAgentsByIdRemoveRoleByRoleIdResponses, DeleteAgentsByIdResponses, DeleteAppsByIdData, DeleteAppsByIdInstallByChannelIdData, DeleteAppsByIdInstallByChannelIdResponses, DeleteAppsByIdResponses, DeleteAuthSessionsByIdData, DeleteAuthSessionsByIdErrors, DeleteAuthSessionsByIdResponses, DeleteAutomationsByIdData, DeleteAutomationsByIdErrors, DeleteAutomationsByIdResponses, DeleteBotsFlowsByIdData, DeleteBotsFlowsByIdEdgesByEdgeIdData, DeleteBotsFlowsByIdEdgesByEdgeIdResponses, DeleteBotsFlowsByIdNodesByNodeIdData, DeleteBotsFlowsByIdNodesByNodeIdResponses, DeleteBotsFlowsByIdResponses, DeleteChannelsByIdData, DeleteChannelsByIdErrors, DeleteChannelsByIdMembersByUserIdData, DeleteChannelsByIdMembersByUserIdErrors, DeleteChannelsByIdMembersByUserIdResponses, DeleteChannelsByIdResponses, DeleteFilesByIdData, DeleteFilesByIdErrors, DeleteFilesByIdResponses, DeleteFilesFoldersByIdData, DeleteFilesFoldersByIdErrors, DeleteFilesFoldersByIdResponses, DeleteFilesSharesByIdData, DeleteFilesSharesByIdErrors, DeleteFilesSharesByIdResponses, DeleteInboxChannelsByChannelIdAgentBotData, DeleteInboxChannelsByChannelIdAgentBotErrors, DeleteInboxChannelsByChannelIdAgentBotResponses, DeleteInboxChannelsByIdData, DeleteInboxChannelsByIdResponses, DeleteInboxChannelsByIdTemplatesByTemplateIdData, DeleteInboxChannelsByIdTemplatesByTemplateIdErrors, DeleteInboxChannelsByIdTemplatesByTemplateIdResponses, DeleteInboxContactsByIdData, DeleteInboxContactsByIdResponses, DeleteInboxConversationsByIdNotesByNoteIdData, DeleteInboxConversationsByIdNotesByNoteIdResponses, DeleteIntegrationsAddonsByIdData, DeleteIntegrationsAddonsByIdResponses, DeleteInvitationsByIdData, DeleteInvitationsByIdErrors, DeleteInvitationsByIdResponses, DeleteKanbanCardsByCardIdNotesByNoteIdData, DeleteKanbanCardsByCardIdNotesByNoteIdErrors, DeleteKanbanCardsByCardIdNotesByNoteIdResponses, DeleteKanbanCardsByIdData, DeleteKanbanCardsByIdErrors, DeleteKanbanCardsByIdResponses, DeleteKanbanPipelinesByIdData, DeleteKanbanPipelinesByIdErrors, DeleteKanbanPipelinesByIdResponses, DeleteKanbanStagesByIdData, DeleteKanbanStagesByIdErrors, DeleteKanbanStagesByIdResponses, DeleteMacrosByIdData, DeleteMacrosByIdResponses, DeleteMeetingsByIdData, DeleteMeetingsByIdErrors, DeleteMeetingsByIdResponses, DeleteMessagesByIdData, DeleteMessagesByIdErrors, DeleteMessagesByIdPinData, DeleteMessagesByIdPinErrors, DeleteMessagesByIdPinResponses, DeleteMessagesByIdReactionsByEmojiData, DeleteMessagesByIdReactionsByEmojiErrors, DeleteMessagesByIdReactionsByEmojiResponses, DeleteMessagesByIdResponses, DeleteNotificationsByIdData, DeleteNotificationsByIdErrors, DeleteNotificationsByIdResponses, DeleteNotificationsClearAllData, DeleteNotificationsClearAllErrors, DeleteNotificationsClearAllResponses, DeleteQuickRepliesByIdData, DeleteQuickRepliesByIdResponses, DeleteRecordingsByIdData, DeleteRecordingsByIdErrors, DeleteRecordingsByIdResponses, DeleteRolesByIdData, DeleteRolesByIdErrors, DeleteRolesByIdResponses, DeleteSettingsApiTokensByIdData, DeleteSettingsApiTokensByIdErrors, DeleteSettingsApiTokensByIdResponses, DeleteTagsByIdData, DeleteTagsByIdResponses, DeleteTeamsByIdData, DeleteTeamsByIdErrors, DeleteTeamsByIdMembersByUserIdData, DeleteTeamsByIdMembersByUserIdErrors, DeleteTeamsByIdMembersByUserIdResponses, DeleteTeamsByIdResponses, DeleteUsersByIdData, DeleteUsersByIdErrors, DeleteUsersByIdResponses, DeleteWebhooksByIdData, DeleteWebhooksByIdResponses, GetAccountContactsByIdData, GetAccountContactsByIdErrors, GetAccountContactsByIdResponses, GetAccountContactsData, GetAccountContactsErrors, GetAccountContactsResponses, GetAccountConversationsByIdData, GetAccountConversationsByIdErrors, GetAccountConversationsByIdMessagesData, GetAccountConversationsByIdMessagesErrors, GetAccountConversationsByIdMessagesResponses, GetAccountConversationsByIdNotesData, GetAccountConversationsByIdNotesErrors, GetAccountConversationsByIdNotesResponses, GetAccountConversationsByIdResponses, GetAccountConversationsData, GetAccountConversationsErrors, GetAccountConversationsResponses, GetAccountTagsData, GetAccountTagsErrors, GetAccountTagsResponses, GetAdminAiGatewayHealthData, GetAdminAiGatewayHealthErrors, GetAdminAiGatewayHealthResponses, GetAdminAiGatewayModelsData, GetAdminAiGatewayModelsErrors, GetAdminAiGatewayModelsResponses, GetAdminAiUsageByTenantIdData, GetAdminAiUsageByTenantIdErrors, GetAdminAiUsageByTenantIdResponses, GetAdminAiUsageData, GetAdminAiUsageErrors, GetAdminAiUsageResponses, GetAdminAnalyticsGrowthData, GetAdminAnalyticsGrowthResponses, GetAdminAnalyticsOverviewData, GetAdminAnalyticsOverviewResponses, GetAdminAnalyticsTenantsData, GetAdminAnalyticsTenantsResponses, GetAdminAnalyticsUsageData, GetAdminAnalyticsUsageResponses, GetAdminAuthMeData, GetAdminAuthMeErrors, GetAdminAuthMeResponses, GetAdminInvoicesByIdData, GetAdminInvoicesByIdResponses, GetAdminInvoicesData, GetAdminInvoicesResponses, GetAdminMrrData, GetAdminMrrResponses, GetAdminRevenueData, GetAdminRevenueResponses, GetAdminSubscriptionsByIdData, GetAdminSubscriptionsByIdResponses, GetAdminSubscriptionsData, GetAdminSubscriptionsResponses, GetAdminTenantsByIdAutomationsData, GetAdminTenantsByIdAutomationsErrors, GetAdminTenantsByIdAutomationsResponses, GetAdminTenantsByIdBotsData, GetAdminTenantsByIdBotsErrors, GetAdminTenantsByIdBotsResponses, GetAdminTenantsByIdChannelsData, GetAdminTenantsByIdChannelsErrors, GetAdminTenantsByIdChannelsResponses, GetAdminTenantsByIdData, GetAdminTenantsByIdFeaturesData, GetAdminTenantsByIdFeaturesErrors, GetAdminTenantsByIdFeaturesResponses, GetAdminTenantsByIdInvoicesData, GetAdminTenantsByIdInvoicesResponses, GetAdminTenantsByIdResponses, GetAdminTenantsByIdUsageData, GetAdminTenantsByIdUsageResponses, GetAdminTenantsByIdUsersData, GetAdminTenantsByIdUsersResponses, GetAdminTenantsData, GetAdminTenantsResponses, GetAgentBotsByIdData, GetAgentBotsByIdErrors, GetAgentBotsByIdResponses, GetAgentBotsData, GetAgentBotsErrors, GetAgentBotsResponses, GetAgentBotsWebhookConversationsByIdData, GetAgentBotsWebhookConversationsByIdErrors, GetAgentBotsWebhookConversationsByIdResponses, GetAgentsAvailableData, GetAgentsAvailableErrors, GetAgentsAvailableResponses, GetAgentsByIdActivityData, GetAgentsByIdActivityErrors, GetAgentsByIdActivityResponses, GetAgentsByIdData, GetAgentsByIdErrors, GetAgentsByIdPerformanceData, GetAgentsByIdPerformanceErrors, GetAgentsByIdPerformanceResponses, GetAgentsByIdResponses, GetAgentsData, GetAgentsErrors, GetAgentsOnlineData, GetAgentsOnlineErrors, GetAgentsOnlineResponses, GetAgentsResponses, GetAgentsStatsData, GetAgentsStatsErrors, GetAgentsStatsResponses, GetAiConfigData, GetAiConfigErrors, GetAiConfigResponses, GetAiConversationsByIdAnalysisData, GetAiConversationsByIdAnalysisErrors, GetAiConversationsByIdAnalysisResponses, GetAiConversationsByIdSummaryData, GetAiConversationsByIdSummaryErrors, GetAiConversationsByIdSummaryResponses, GetAiHealthData, GetAiHealthErrors, GetAiHealthResponses, GetAiProvidersData, GetAiProvidersErrors, GetAiProvidersResponses, GetAppsActiveData, GetAppsActiveResponses, GetAppsByIdContextData, GetAppsByIdContextResponses, GetAppsByIdData, GetAppsByIdInstallationsData, GetAppsByIdInstallationsResponses, GetAppsByIdResponses, GetAppsData, GetAppsResponses, GetAuthMeData, GetAuthMeErrors, GetAuthMembershipsData, GetAuthMembershipsErrors, GetAuthMembershipsResponses, GetAuthMeResponses, GetAuthSessionsData, GetAuthSessionsErrors, GetAuthSessionsResponses, GetAutomationsByIdData, GetAutomationsByIdErrors, GetAutomationsByIdExecutionsData, GetAutomationsByIdExecutionsErrors, GetAutomationsByIdExecutionsResponses, GetAutomationsByIdResponses, GetAutomationsData, GetAutomationsErrors, GetAutomationsResponses, GetBotsFlowsByIdAnalyticsData, GetBotsFlowsByIdAnalyticsResponses, GetBotsFlowsByIdData, GetBotsFlowsByIdResponses, GetBotsFlowsByIdStatsData, GetBotsFlowsByIdStatsResponses, GetBotsFlowsData, GetBotsFlowsResponses, GetBotsSessionsByIdData, GetBotsSessionsByIdResponses, GetBotsSessionsByIdVariablesData, GetBotsSessionsByIdVariablesResponses, GetBotsSessionsData, GetBotsSessionsResponses, GetBotsStatsData, GetBotsStatsResponses, GetCallsActiveData, GetCallsActiveErrors, GetCallsActiveResponses, GetCallsByIdTokenData, GetCallsByIdTokenErrors, GetCallsByIdTokenResponses, GetCallsHistoryData, GetCallsHistoryErrors, GetCallsHistoryResponses, GetChannelsByChannelIdMessagesData, GetChannelsByChannelIdMessagesErrors, GetChannelsByChannelIdMessagesResponses, GetChannelsByChannelIdPinnedMessagesData, GetChannelsByChannelIdPinnedMessagesErrors, GetChannelsByChannelIdPinnedMessagesResponses, GetChannelsByIdData, GetChannelsByIdErrors, GetChannelsByIdMembersData, GetChannelsByIdMembersErrors, GetChannelsByIdMembersResponses, GetChannelsByIdResponses, GetChannelsData, GetChannelsErrors, GetChannelsResponses, GetChannelsSearchData, GetChannelsSearchErrors, GetChannelsSearchResponses, GetFilesActivityData, GetFilesActivityErrors, GetFilesActivityResponses, GetFilesByIdData, GetFilesByIdDownloadData, GetFilesByIdDownloadErrors, GetFilesByIdDownloadResponses, GetFilesByIdErrors, GetFilesByIdResponses, GetFilesByTypeByIdActivityData, GetFilesByTypeByIdActivityErrors, GetFilesByTypeByIdActivityResponses, GetFilesByTypeByIdSharesData, GetFilesByTypeByIdSharesErrors, GetFilesByTypeByIdSharesResponses, GetFilesData, GetFilesErrors, GetFilesFoldersByIdData, GetFilesFoldersByIdErrors, GetFilesFoldersByIdPathData, GetFilesFoldersByIdPathErrors, GetFilesFoldersByIdPathResponses, GetFilesFoldersByIdResponses, GetFilesFoldersData, GetFilesFoldersErrors, GetFilesFoldersResponses, GetFilesRecentData, GetFilesRecentErrors, GetFilesRecentResponses, GetFilesResponses, GetFilesSearchData, GetFilesSearchErrors, GetFilesSearchResponses, GetFilesSharedWithMeData, GetFilesSharedWithMeErrors, GetFilesSharedWithMeResponses, GetFilesStarredData, GetFilesStarredErrors, GetFilesStarredResponses, GetFilesStatsData, GetFilesStatsErrors, GetFilesStatsResponses, GetFilesTypeByTypeData, GetFilesTypeByTypeErrors, GetFilesTypeByTypeResponses, GetInboxChannelsByChannelIdAgentBotData, GetInboxChannelsByChannelIdAgentBotErrors, GetInboxChannelsByChannelIdAgentBotResponses, GetInboxChannelsByChannelIdCsatResponsesData, GetInboxChannelsByChannelIdCsatResponsesResponses, GetInboxChannelsByChannelIdCsatStatsData, GetInboxChannelsByChannelIdCsatStatsResponses, GetInboxChannelsByChannelIdWaEventsData, GetInboxChannelsByChannelIdWaEventsErrors, GetInboxChannelsByChannelIdWaEventsResponses, GetInboxChannelsByIdAppsData, GetInboxChannelsByIdAppsResponses, GetInboxChannelsByIdBusinessProfileData, GetInboxChannelsByIdBusinessProfileErrors, GetInboxChannelsByIdBusinessProfileResponses, GetInboxChannelsByIdData, GetInboxChannelsByIdHealthData, GetInboxChannelsByIdHealthResponses, GetInboxChannelsByIdInstagramProfileData, GetInboxChannelsByIdInstagramProfileErrors, GetInboxChannelsByIdInstagramProfileResponses, GetInboxChannelsByIdResponses, GetInboxChannelsByIdTemplatesData, GetInboxChannelsByIdTemplatesErrors, GetInboxChannelsByIdTemplatesResponses, GetInboxChannelsByIdWebhooksData, GetInboxChannelsByIdWebhooksErrors, GetInboxChannelsByIdWebhooksResponses, GetInboxChannelsData, GetInboxChannelsResponses, GetInboxContactsByIdData, GetInboxContactsByIdMergedData, GetInboxContactsByIdMergedResponses, GetInboxContactsByIdResponses, GetInboxContactsByIdStatsData, GetInboxContactsByIdStatsResponses, GetInboxContactsData, GetInboxContactsResponses, GetInboxConversationsByIdAppsData, GetInboxConversationsByIdAppsResponses, GetInboxConversationsByIdData, GetInboxConversationsByIdMessagesData, GetInboxConversationsByIdMessagesResponses, GetInboxConversationsByIdNotesData, GetInboxConversationsByIdNotesResponses, GetInboxConversationsByIdResponses, GetInboxConversationsData, GetInboxConversationsResponses, GetInboxCsatStatsData, GetInboxCsatStatsResponses, GetInboxMessagesByIdEditsData, GetInboxMessagesByIdEditsErrors, GetInboxMessagesByIdEditsResponses, GetInboxProvidersData, GetInboxProvidersResponses, GetInboxStatsData, GetInboxStatsResponses, GetInboxWaEventsUnacknowledgedData, GetInboxWaEventsUnacknowledgedErrors, GetInboxWaEventsUnacknowledgedResponses, GetIntegrationsAddonsByIdData, GetIntegrationsAddonsByIdResponses, GetIntegrationsAddonsData, GetIntegrationsAddonsResponses, GetInvitationsByIdData, GetInvitationsByIdErrors, GetInvitationsByIdResponses, GetInvitationsMyData, GetInvitationsMyErrors, GetInvitationsMyResponses, GetKanbanCardsByCardIdNotesData, GetKanbanCardsByCardIdNotesErrors, GetKanbanCardsByCardIdNotesResponses, GetKanbanCardsByIdData, GetKanbanCardsByIdErrors, GetKanbanCardsByIdHistoryData, GetKanbanCardsByIdHistoryErrors, GetKanbanCardsByIdHistoryResponses, GetKanbanCardsByIdResponses, GetKanbanContactsByIdConversationData, GetKanbanContactsByIdConversationErrors, GetKanbanContactsByIdConversationResponses, GetKanbanContactsByIdPipelineStatusData, GetKanbanContactsByIdPipelineStatusErrors, GetKanbanContactsByIdPipelineStatusResponses, GetKanbanPipelinesByIdCardsData, GetKanbanPipelinesByIdCardsErrors, GetKanbanPipelinesByIdCardsResponses, GetKanbanPipelinesByIdData, GetKanbanPipelinesByIdErrors, GetKanbanPipelinesByIdResponses, GetKanbanPipelinesByIdStagesData, GetKanbanPipelinesByIdStagesErrors, GetKanbanPipelinesByIdStagesResponses, GetKanbanPipelinesByIdStatsData, GetKanbanPipelinesByIdStatsErrors, GetKanbanPipelinesByIdStatsResponses, GetKanbanPipelinesData, GetKanbanPipelinesErrors, GetKanbanPipelinesResponses, GetKanbanStagesByIdData, GetKanbanStagesByIdErrors, GetKanbanStagesByIdResponses, GetMacrosByIdData, GetMacrosByIdResponses, GetMacrosData, GetMacrosResponses, GetMacrosSearchData, GetMacrosSearchResponses, GetMacrosShortcutByShortcutData, GetMacrosShortcutByShortcutResponses, GetMeetingsByIdData, GetMeetingsByIdErrors, GetMeetingsByIdResponses, GetMeetingsByIdTokenData, GetMeetingsByIdTokenErrors, GetMeetingsByIdTokenResponses, GetMeetingsData, GetMeetingsErrors, GetMeetingsResponses, GetMessagesByIdThreadData, GetMessagesByIdThreadErrors, GetMessagesByIdThreadResponses, GetMeUsageData, GetMeUsageErrors, GetMeUsageResponses, GetMigrationChatwootStatusData, GetMigrationChatwootStatusErrors, GetMigrationChatwootStatusResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsRecentData, GetNotificationsRecentErrors, GetNotificationsRecentResponses, GetNotificationsResponses, GetNotificationsSettingsData, GetNotificationsSettingsErrors, GetNotificationsSettingsResponses, GetNotificationsUnreadCountData, GetNotificationsUnreadCountErrors, GetNotificationsUnreadCountResponses, GetOnboardingStatusData, GetOnboardingStatusErrors, GetOnboardingStatusResponses, GetPlansByIdData, GetPlansByIdResponses, GetPlansData, GetPlansResponses, GetPublicCsatByTokenData, GetPublicCsatByTokenResponses, GetPublicMeetingsByTokenData, GetPublicMeetingsByTokenErrors, GetPublicMeetingsByTokenResponses, GetPublicMeetingsByTokenTokenData, GetPublicMeetingsByTokenTokenErrors, GetPublicMeetingsByTokenTokenResponses, GetPublicWidgetByTokenData, GetPublicWidgetByTokenErrors, GetPublicWidgetByTokenResponses, GetPublicWidgetByTokenSessionsBySessionIdMessagesData, GetPublicWidgetByTokenSessionsBySessionIdMessagesErrors, GetPublicWidgetByTokenSessionsBySessionIdMessagesResponses, GetQuickRepliesByIdData, GetQuickRepliesByIdResponses, GetQuickRepliesCategoriesData, GetQuickRepliesCategoriesResponses, GetQuickRepliesCategoryByCategoryData, GetQuickRepliesCategoryByCategoryResponses, GetQuickRepliesData, GetQuickRepliesResponses, GetQuickRepliesSearchData, GetQuickRepliesSearchResponses, GetQuickRepliesShortcutByShortcutData, GetQuickRepliesShortcutByShortcutResponses, GetQuickRepliesStatsData, GetQuickRepliesStatsResponses, GetRecordingsByIdData, GetRecordingsByIdErrors, GetRecordingsByIdResponses, GetRecordingsData, GetRecordingsErrors, GetRecordingsResponses, GetReportsAgentsData, GetReportsAgentsErrors, GetReportsAgentsResponses, GetReportsChannelsData, GetReportsChannelsErrors, GetReportsChannelsResponses, GetReportsCsatData, GetReportsCsatErrors, GetReportsCsatResponses, GetReportsExportData, GetReportsExportErrors, GetReportsExportResponses, GetReportsInboxData, GetReportsInboxErrors, GetReportsInboxResponses, GetReportsOverviewData, GetReportsOverviewErrors, GetReportsOverviewResponses, GetReportsSlaConfigData, GetReportsSlaConfigErrors, GetReportsSlaConfigResponses, GetReportsSlaData, GetReportsSlaErrors, GetReportsSlaResponses, GetReportsTagsData, GetReportsTagsErrors, GetReportsTagsResponses, GetRolesByIdData, GetRolesByIdErrors, GetRolesByIdResponses, GetRolesByIdUsersData, GetRolesByIdUsersErrors, GetRolesByIdUsersResponses, GetRolesData, GetRolesErrors, GetRolesPermissionsCategoriesData, GetRolesPermissionsCategoriesErrors, GetRolesPermissionsCategoriesResponses, GetRolesResponses, GetSearchMessagesData, GetSearchMessagesErrors, GetSearchMessagesResponses, GetSettingsApiTokensByIdData, GetSettingsApiTokensByIdErrors, GetSettingsApiTokensByIdResponses, GetSettingsApiTokensData, GetSettingsApiTokensErrors, GetSettingsApiTokensPermissionsData, GetSettingsApiTokensPermissionsErrors, GetSettingsApiTokensPermissionsResponses, GetSettingsApiTokensResponses, GetStorageFilesByPathData, GetStorageFilesByPathErrors, GetStorageFilesByPathResponses, GetStoragePresignedData, GetStoragePresignedErrors, GetStoragePresignedResponses, GetTagsByIdData, GetTagsByIdResponses, GetTagsData, GetTagsResponses, GetTeamsByIdActivityData, GetTeamsByIdActivityErrors, GetTeamsByIdActivityResponses, GetTeamsByIdChannelsData, GetTeamsByIdChannelsErrors, GetTeamsByIdChannelsResponses, GetTeamsByIdData, GetTeamsByIdErrors, GetTeamsByIdInvitationsData, GetTeamsByIdInvitationsErrors, GetTeamsByIdInvitationsResponses, GetTeamsByIdMembersData, GetTeamsByIdMembersErrors, GetTeamsByIdMembersResponses, GetTeamsByIdResponses, GetTeamsByIdStatsData, GetTeamsByIdStatsErrors, GetTeamsByIdStatsResponses, GetTeamsData, GetTeamsErrors, GetTeamsMyData, GetTeamsMyErrors, GetTeamsMyResponses, GetTeamsResponses, GetTeamsSearchData, GetTeamsSearchErrors, GetTeamsSearchResponses, GetTenantCheckLimitData, GetTenantCheckLimitResponses, GetTenantData, GetTenantErrors, GetTenantResponses, GetTenantUsageData, GetTenantUsageResponses, GetUsersByIdData, GetUsersByIdErrors, GetUsersByIdResponses, GetUsersData, GetUsersDepartmentsData, GetUsersDepartmentsErrors, GetUsersDepartmentsResponses, GetUsersDirectoryData, GetUsersDirectoryErrors, GetUsersDirectoryResponses, GetUsersErrors, GetUsersResponses, GetUsersSearchData, GetUsersSearchErrors, GetUsersSearchResponses, GetWebhooksByIdData, GetWebhooksByIdDeliveriesData, GetWebhooksByIdDeliveriesResponses, GetWebhooksByIdResponses, GetWebhooksData, GetWebhooksEventTypesData, GetWebhooksEventTypesResponses, GetWebhooksInstagramByChannelIdData, GetWebhooksInstagramByChannelIdErrors, GetWebhooksInstagramByChannelIdResponses, GetWebhooksInstagramData, GetWebhooksInstagramErrors, GetWebhooksInstagramResponses, GetWebhooksMessengerByChannelIdData, GetWebhooksMessengerByChannelIdErrors, GetWebhooksMessengerByChannelIdResponses, GetWebhooksMessengerData, GetWebhooksMessengerErrors, GetWebhooksMessengerResponses, GetWebhooksResponses, GetWebhooksWhatsappByChannelIdData, GetWebhooksWhatsappByChannelIdErrors, GetWebhooksWhatsappByChannelIdResponses, GetWebhooksWhatsappData, GetWebhooksWhatsappErrors, GetWebhooksWhatsappResponses, PatchAgentsByIdStatusData, PatchAgentsByIdStatusErrors, PatchAgentsByIdStatusResponses, PatchAutomationsByIdToggleData, PatchAutomationsByIdToggleErrors, PatchAutomationsByIdToggleResponses, PatchFilesByIdData, PatchFilesByIdErrors, PatchFilesByIdResponses, PatchFilesFoldersByIdData, PatchFilesFoldersByIdErrors, PatchFilesFoldersByIdResponses, PatchMeetingsByIdData, PatchMeetingsByIdErrors, PatchMeetingsByIdResponses, PatchNotificationsByIdReadData, PatchNotificationsByIdReadErrors, PatchNotificationsByIdReadResponses, PatchSettingsApiTokensByIdData, PatchSettingsApiTokensByIdErrors, PatchSettingsApiTokensByIdResponses, PatchTeamsByIdData, PatchTeamsByIdErrors, PatchTeamsByIdMembersByUserIdRoleData, PatchTeamsByIdMembersByUserIdRoleErrors, PatchTeamsByIdMembersByUserIdRoleResponses, PatchTeamsByIdResponses, PatchWebhooksByIdData, PatchWebhooksByIdResponses, PostAccountContactsData, PostAccountContactsErrors, PostAccountContactsResponses, PostAccountConversationsByIdAssignData, PostAccountConversationsByIdAssignErrors, PostAccountConversationsByIdAssignResponses, PostAccountConversationsByIdMessagesData, PostAccountConversationsByIdMessagesErrors, PostAccountConversationsByIdMessagesResponses, PostAccountConversationsByIdMuteData, PostAccountConversationsByIdMuteErrors, PostAccountConversationsByIdMuteResponses, PostAccountConversationsByIdNotesData, PostAccountConversationsByIdNotesErrors, PostAccountConversationsByIdNotesResponses, PostAccountConversationsByIdReopenData, PostAccountConversationsByIdReopenErrors, PostAccountConversationsByIdReopenResponses, PostAccountConversationsByIdResolveData, PostAccountConversationsByIdResolveErrors, PostAccountConversationsByIdResolveResponses, PostAccountConversationsByIdUnassignData, PostAccountConversationsByIdUnassignErrors, PostAccountConversationsByIdUnassignResponses, PostAccountConversationsByIdUnmuteData, PostAccountConversationsByIdUnmuteErrors, PostAccountConversationsByIdUnmuteResponses, PostAccountConversationsByIdUnreadData, PostAccountConversationsByIdUnreadErrors, PostAccountConversationsByIdUnreadResponses, PostAccountTagsData, PostAccountTagsErrors, PostAccountTagsResponses, PostAdminAuthLogoutData, PostAdminAuthLogoutErrors, PostAdminAuthLogoutResponses, PostAdminInvoicesByIdRefundData, PostAdminInvoicesByIdRefundResponses, PostAdminPlansData, PostAdminPlansResponses, PostAdminStorageBackfillMediaPreviewData, PostAdminStorageBackfillMediaPreviewErrors, PostAdminStorageBackfillMediaPreviewResponses, PostAdminStorageBackfillMediaRunData, PostAdminStorageBackfillMediaRunErrors, PostAdminStorageBackfillMediaRunResponses, PostAdminSubscriptionsByIdCancelData, PostAdminSubscriptionsByIdCancelResponses, PostAdminTenantsByIdActivateData, PostAdminTenantsByIdActivateResponses, PostAdminTenantsByIdImpersonateData, PostAdminTenantsByIdImpersonateResponses, PostAdminTenantsByIdSuspendData, PostAdminTenantsByIdSuspendResponses, PostAdminTenantsData, PostAdminTenantsResponses, PostAgentBotsByIdRegenerateTokenData, PostAgentBotsByIdRegenerateTokenErrors, PostAgentBotsByIdRegenerateTokenResponses, PostAgentBotsData, PostAgentBotsErrors, PostAgentBotsResponses, PostAgentBotsWebhookHandoffData, PostAgentBotsWebhookHandoffErrors, PostAgentBotsWebhookHandoffResponses, PostAgentBotsWebhookMessagesData, PostAgentBotsWebhookMessagesErrors, PostAgentBotsWebhookMessagesResponses, PostAgentsBulkInviteData, PostAgentsBulkInviteErrors, PostAgentsBulkInviteResponses, PostAgentsByIdAssignRolesData, PostAgentsByIdAssignRolesErrors, PostAgentsByIdAssignRolesResponses, PostAgentsByIdResetPasswordData, PostAgentsByIdResetPasswordErrors, PostAgentsByIdResetPasswordResponses, PostAgentsByIdUploadAvatarData, PostAgentsByIdUploadAvatarErrors, PostAgentsByIdUploadAvatarResponses, PostAgentsData, PostAgentsErrors, PostAgentsResponses, PostAiAnalyzeMessageData, PostAiAnalyzeMessageErrors, PostAiAnalyzeMessageResponses, PostAiClassifyIntentData, PostAiClassifyIntentErrors, PostAiClassifyIntentResponses, PostAiCopilotChatData, PostAiCopilotChatErrors, PostAiCopilotChatResponses, PostAiExtractEntitiesData, PostAiExtractEntitiesErrors, PostAiExtractEntitiesResponses, PostAiGenerateResponseData, PostAiGenerateResponseErrors, PostAiGenerateResponseResponses, PostAiSuggestRepliesData, PostAiSuggestRepliesErrors, PostAiSuggestRepliesResponses, PostAppsByIdInstallData, PostAppsByIdInstallResponses, PostAppsByIdRegenerateKeyData, PostAppsByIdRegenerateKeyResponses, PostAppsByIdSessionData, PostAppsByIdSessionResponses, PostAppsData, PostAppsResponses, PostAuthForgotPasswordData, PostAuthForgotPasswordErrors, PostAuthForgotPasswordResponses, PostAuthLoginData, PostAuthLoginErrors, PostAuthLoginResponses, PostAuthLogoutData, PostAuthLogoutErrors, PostAuthLogoutEverywhereData, PostAuthLogoutEverywhereErrors, PostAuthLogoutEverywhereResponses, PostAuthLogoutResponses, PostAuthRefreshData, PostAuthRefreshErrors, PostAuthRefreshResponses, PostAuthRegisterData, PostAuthRegisterErrors, PostAuthRegisterResponses, PostAuthRequestAccountData, PostAuthRequestAccountErrors, PostAuthRequestAccountResponses, PostAuthResetPasswordData, PostAuthResetPasswordErrors, PostAuthResetPasswordResponses, PostAuthSwitchTenantData, PostAuthSwitchTenantErrors, PostAuthSwitchTenantResponses, PostAutomationsData, PostAutomationsErrors, PostAutomationsResponses, PostBotsCleanupData, PostBotsCleanupResponses, PostBotsFlowsByIdActivateData, PostBotsFlowsByIdActivateResponses, PostBotsFlowsByIdCloneData, PostBotsFlowsByIdCloneResponses, PostBotsFlowsByIdEdgesData, PostBotsFlowsByIdEdgesResponses, PostBotsFlowsByIdNodesData, PostBotsFlowsByIdNodesResponses, PostBotsFlowsByIdPublishData, PostBotsFlowsByIdPublishResponses, PostBotsFlowsData, PostBotsFlowsResponses, PostBotsProcessData, PostBotsProcessResponses, PostBotsSessionsByIdEndData, PostBotsSessionsByIdEndResponses, PostBotsSessionsByIdHandoffData, PostBotsSessionsByIdHandoffResponses, PostBotsSessionsByIdPauseData, PostBotsSessionsByIdPauseResponses, PostBotsSessionsByIdResumeData, PostBotsSessionsByIdResumeResponses, PostBotsSessionsByIdVariablesData, PostBotsSessionsByIdVariablesResponses, PostBotsSessionsData, PostBotsSessionsResponses, PostBotsTriggerData, PostBotsTriggerResponses, PostCallsByIdAnswerData, PostCallsByIdAnswerErrors, PostCallsByIdAnswerResponses, PostCallsByIdEndData, PostCallsByIdEndErrors, PostCallsByIdEndResponses, PostCallsByIdRejectData, PostCallsByIdRejectErrors, PostCallsByIdRejectResponses, PostCallsStartData, PostCallsStartErrors, PostCallsStartResponses, PostChannelsByIdLeaveData, PostChannelsByIdLeaveErrors, PostChannelsByIdLeaveResponses, PostChannelsByIdMembersData, PostChannelsByIdMembersErrors, PostChannelsByIdMembersResponses, PostChannelsByIdReadData, PostChannelsByIdReadErrors, PostChannelsByIdReadResponses, PostChannelsData, PostChannelsErrors, PostChannelsResponses, PostFilesByIdMoveData, PostFilesByIdMoveErrors, PostFilesByIdMoveResponses, PostFilesByIdStarData, PostFilesByIdStarErrors, PostFilesByIdStarResponses, PostFilesFoldersByIdStarData, PostFilesFoldersByIdStarErrors, PostFilesFoldersByIdStarResponses, PostFilesFoldersData, PostFilesFoldersErrors, PostFilesFoldersResponses, PostFilesShareData, PostFilesShareErrors, PostFilesShareResponses, PostFilesUploadData, PostFilesUploadErrors, PostFilesUploadResponses, PostInboxChannelsByIdBusinessProfileUploadPictureData, PostInboxChannelsByIdBusinessProfileUploadPictureErrors, PostInboxChannelsByIdBusinessProfileUploadPictureResponses, PostInboxChannelsByIdRegenerateKeyData, PostInboxChannelsByIdRegenerateKeyResponses, PostInboxChannelsByIdSendData, PostInboxChannelsByIdSendResponses, PostInboxChannelsByIdSyncTemplatesData, PostInboxChannelsByIdSyncTemplatesResponses, PostInboxChannelsByIdTemplatesData, PostInboxChannelsByIdTemplatesErrors, PostInboxChannelsByIdTemplatesResponses, PostInboxChannelsByIdTestData, PostInboxChannelsByIdTestResponses, PostInboxChannelsData, PostInboxChannelsInstagramOauthData, PostInboxChannelsInstagramOauthErrors, PostInboxChannelsInstagramOauthResponses, PostInboxChannelsMessengerOauthData, PostInboxChannelsMessengerOauthErrors, PostInboxChannelsMessengerOauthResponses, PostInboxChannelsResponses, PostInboxChannelsWhatsappData, PostInboxChannelsWhatsappEmbeddedSignupData, PostInboxChannelsWhatsappEmbeddedSignupResponses, PostInboxChannelsWhatsappResponses, PostInboxContactsByIdSendTemplateData, PostInboxContactsByIdSendTemplateResponses, PostInboxContactsData, PostInboxContactsMergeData, PostInboxContactsMergeResponses, PostInboxContactsResponses, PostInboxConversationsBulkAssignData, PostInboxConversationsBulkAssignResponses, PostInboxConversationsBulkResolveData, PostInboxConversationsBulkResolveResponses, PostInboxConversationsBulkTagData, PostInboxConversationsBulkTagResponses, PostInboxConversationsBulkUnassignData, PostInboxConversationsBulkUnassignResponses, PostInboxConversationsByIdActionsInteractiveData, PostInboxConversationsByIdActionsInteractiveErrors, PostInboxConversationsByIdActionsInteractiveResponses, PostInboxConversationsByIdActionsReactionData, PostInboxConversationsByIdActionsReactionErrors, PostInboxConversationsByIdActionsReactionResponses, PostInboxConversationsByIdActionsTemplateData, PostInboxConversationsByIdActionsTemplateErrors, PostInboxConversationsByIdActionsTemplateResponses, PostInboxConversationsByIdAssignData, PostInboxConversationsByIdAssignResponses, PostInboxConversationsByIdAssignTeamData, PostInboxConversationsByIdAssignTeamResponses, PostInboxConversationsByIdCsatSendData, PostInboxConversationsByIdCsatSendResponses, PostInboxConversationsByIdMessagesBatchData, PostInboxConversationsByIdMessagesBatchErrors, PostInboxConversationsByIdMessagesBatchResponses, PostInboxConversationsByIdMessagesData, PostInboxConversationsByIdMessagesResponses, PostInboxConversationsByIdMuteData, PostInboxConversationsByIdMuteResponses, PostInboxConversationsByIdNotesData, PostInboxConversationsByIdNotesResponses, PostInboxConversationsByIdReadData, PostInboxConversationsByIdReadResponses, PostInboxConversationsByIdReopenData, PostInboxConversationsByIdReopenResponses, PostInboxConversationsByIdResolveData, PostInboxConversationsByIdResolveResponses, PostInboxConversationsByIdUnmuteData, PostInboxConversationsByIdUnmuteResponses, PostInboxConversationsByIdUnreadData, PostInboxConversationsByIdUnreadResponses, PostInboxWaEventsByIdAcknowledgeData, PostInboxWaEventsByIdAcknowledgeErrors, PostInboxWaEventsByIdAcknowledgeResponses, PostIntegrationsAddonsData, PostIntegrationsAddonsResponses, PostInvitationsByIdAcceptData, PostInvitationsByIdAcceptErrors, PostInvitationsByIdAcceptResponses, PostInvitationsByIdRejectData, PostInvitationsByIdRejectErrors, PostInvitationsByIdRejectResponses, PostKanbanCardsByCardIdNotesData, PostKanbanCardsByCardIdNotesErrors, PostKanbanCardsByCardIdNotesResponses, PostKanbanCardsData, PostKanbanCardsErrors, PostKanbanCardsResponses, PostKanbanPipelinesByIdStagesData, PostKanbanPipelinesByIdStagesErrors, PostKanbanPipelinesByIdStagesReorderData, PostKanbanPipelinesByIdStagesReorderErrors, PostKanbanPipelinesByIdStagesReorderResponses, PostKanbanPipelinesByIdStagesResponses, PostKanbanPipelinesData, PostKanbanPipelinesErrors, PostKanbanPipelinesResponses, PostMacrosByIdUseData, PostMacrosByIdUseResponses, PostMacrosData, PostMacrosResponses, PostMeetingsByIdEndData, PostMeetingsByIdEndErrors, PostMeetingsByIdEndResponses, PostMeetingsByIdGuestLinkData, PostMeetingsByIdGuestLinkErrors, PostMeetingsByIdGuestLinkResponses, PostMeetingsByIdInviteData, PostMeetingsByIdInviteErrors, PostMeetingsByIdInviteResponses, PostMeetingsByIdJoinData, PostMeetingsByIdJoinErrors, PostMeetingsByIdJoinResponses, PostMeetingsByIdLeaveData, PostMeetingsByIdLeaveErrors, PostMeetingsByIdLeaveResponses, PostMeetingsByIdRecordingStartData, PostMeetingsByIdRecordingStartErrors, PostMeetingsByIdRecordingStartResponses, PostMeetingsByIdRecordingStopData, PostMeetingsByIdRecordingStopErrors, PostMeetingsByIdRecordingStopResponses, PostMeetingsByIdStartData, PostMeetingsByIdStartErrors, PostMeetingsByIdStartResponses, PostMeetingsData, PostMeetingsErrors, PostMeetingsResponses, PostMessagesByIdPinData, PostMessagesByIdPinErrors, PostMessagesByIdPinResponses, PostMessagesByIdReactionsData, PostMessagesByIdReactionsErrors, PostMessagesByIdReactionsResponses, PostMessagesData, PostMessagesErrors, PostMessagesResponses, PostMigrationChatwootCancelData, PostMigrationChatwootCancelErrors, PostMigrationChatwootCancelResponses, PostMigrationChatwootPreviewData, PostMigrationChatwootPreviewErrors, PostMigrationChatwootPreviewResponses, PostMigrationChatwootStartData, PostMigrationChatwootStartErrors, PostMigrationChatwootStartResponses, PostMigrationChatwootValidateData, PostMigrationChatwootValidateErrors, PostMigrationChatwootValidateResponses, PostNotificationsMarkAllReadData, PostNotificationsMarkAllReadErrors, PostNotificationsMarkAllReadResponses, PostNotificationsRegisterDeviceData, PostNotificationsRegisterDeviceErrors, PostNotificationsRegisterDeviceResponses, PostNotificationsTestData, PostNotificationsTestErrors, PostNotificationsTestResponses, PostOnboardingCompleteData, PostOnboardingCompleteErrors, PostOnboardingCompleteResponses, PostPublicCsatByTokenData, PostPublicCsatByTokenResponses, PostPublicMeetingsByTokenJoinData, PostPublicMeetingsByTokenJoinErrors, PostPublicMeetingsByTokenJoinResponses, PostPublicWidgetByTokenSessionsBySessionIdMessagesData, PostPublicWidgetByTokenSessionsBySessionIdMessagesErrors, PostPublicWidgetByTokenSessionsBySessionIdMessagesResponses, PostPublicWidgetByTokenSessionsData, PostPublicWidgetByTokenSessionsErrors, PostPublicWidgetByTokenSessionsResponses, PostQuickRepliesByIdUseData, PostQuickRepliesByIdUseResponses, PostQuickRepliesData, PostQuickRepliesResponses, PostRolesByIdDuplicateData, PostRolesByIdDuplicateErrors, PostRolesByIdDuplicateResponses, PostRolesData, PostRolesErrors, PostRolesResponses, PostRolesValidateNameData, PostRolesValidateNameErrors, PostRolesValidateNameResponses, PostSettingsApiTokensData, PostSettingsApiTokensErrors, PostSettingsApiTokensResponses, PostStorageUploadData, PostStorageUploadErrors, PostStorageUploadResponses, PostTagsBackfillData, PostTagsBackfillErrors, PostTagsBackfillResponses, PostTagsData, PostTagsResponses, PostTeamsByIdChannelsData, PostTeamsByIdChannelsErrors, PostTeamsByIdChannelsResponses, PostTeamsByIdInviteData, PostTeamsByIdInviteErrors, PostTeamsByIdInviteResponses, PostTeamsByIdJoinData, PostTeamsByIdJoinErrors, PostTeamsByIdJoinResponses, PostTeamsByIdLeaveData, PostTeamsByIdLeaveErrors, PostTeamsByIdLeaveResponses, PostTeamsByIdMembersData, PostTeamsByIdMembersErrors, PostTeamsByIdMembersResponses, PostTeamsData, PostTeamsErrors, PostTeamsResponses, PostUsersByIdPasswordData, PostUsersByIdPasswordErrors, PostUsersByIdPasswordResponses, PostWebhooksByIdRegenerateSecretData, PostWebhooksByIdRegenerateSecretResponses, PostWebhooksByIdTestData, PostWebhooksByIdTestResponses, PostWebhooksData, PostWebhooksInstagramByChannelIdData, PostWebhooksInstagramByChannelIdErrors, PostWebhooksInstagramByChannelIdResponses, PostWebhooksInstagramData, PostWebhooksInstagramResponses, PostWebhooksMessengerByChannelIdData, PostWebhooksMessengerByChannelIdErrors, PostWebhooksMessengerByChannelIdResponses, PostWebhooksMessengerData, PostWebhooksMessengerResponses, PostWebhooksResponses, PostWebhooksTelegramByChannelIdData, PostWebhooksTelegramByChannelIdErrors, PostWebhooksTelegramByChannelIdResponses, PostWebhooksWhatsappByChannelIdData, PostWebhooksWhatsappByChannelIdErrors, PostWebhooksWhatsappByChannelIdResponses, PostWebhooksWhatsappData, PostWebhooksWhatsappResponses, PutAccountContactsByIdData, PutAccountContactsByIdErrors, PutAccountContactsByIdResponses, PutAccountNotesByIdData, PutAccountNotesByIdErrors, PutAccountNotesByIdResponses, PutAccountTagsByIdData, PutAccountTagsByIdErrors, PutAccountTagsByIdResponses, PutAdminPlansByIdData, PutAdminPlansByIdResponses, PutAdminSubscriptionsByIdData, PutAdminSubscriptionsByIdResponses, PutAdminTenantsByIdData, PutAdminTenantsByIdResponses, PutAgentBotsByIdData, PutAgentBotsByIdErrors, PutAgentBotsByIdResponses, PutAgentsByIdData, PutAgentsByIdErrors, PutAgentsByIdResponses, PutAiConfigData, PutAiConfigErrors, PutAiConfigResponses, PutAppsByIdData, PutAppsByIdResponses, PutAutomationsByIdData, PutAutomationsByIdErrors, PutAutomationsByIdResponses, PutBotsFlowsByIdData, PutBotsFlowsByIdNodesByNodeIdData, PutBotsFlowsByIdNodesByNodeIdResponses, PutBotsFlowsByIdResponses, PutChannelsByIdData, PutChannelsByIdErrors, PutChannelsByIdResponses, PutInboxChannelsByChannelIdAgentBotData, PutInboxChannelsByChannelIdAgentBotErrors, PutInboxChannelsByChannelIdAgentBotResponses, PutInboxChannelsByIdBusinessProfileData, PutInboxChannelsByIdBusinessProfileErrors, PutInboxChannelsByIdBusinessProfileResponses, PutInboxChannelsByIdData, PutInboxChannelsByIdResponses, PutInboxChannelsByIdTemplatesByTemplateIdData, PutInboxChannelsByIdTemplatesByTemplateIdErrors, PutInboxChannelsByIdTemplatesByTemplateIdResponses, PutInboxContactsByIdData, PutInboxContactsByIdResponses, PutInboxConversationsByIdData, PutInboxConversationsByIdNotesByNoteIdData, PutInboxConversationsByIdNotesByNoteIdResponses, PutInboxConversationsByIdResponses, PutIntegrationsAddonsByIdData, PutIntegrationsAddonsByIdResponses, PutKanbanCardsByCardIdNotesByNoteIdData, PutKanbanCardsByCardIdNotesByNoteIdErrors, PutKanbanCardsByCardIdNotesByNoteIdResponses, PutKanbanCardsByIdData, PutKanbanCardsByIdErrors, PutKanbanCardsByIdMoveData, PutKanbanCardsByIdMoveErrors, PutKanbanCardsByIdMoveResponses, PutKanbanCardsByIdResponses, PutKanbanPipelinesByIdData, PutKanbanPipelinesByIdErrors, PutKanbanPipelinesByIdResponses, PutKanbanStagesByIdData, PutKanbanStagesByIdErrors, PutKanbanStagesByIdResponses, PutMacrosByIdData, PutMacrosByIdResponses, PutMessagesByIdData, PutMessagesByIdErrors, PutMessagesByIdResponses, PutNotificationsSettingsData, PutNotificationsSettingsErrors, PutNotificationsSettingsResponses, PutQuickRepliesByIdData, PutQuickRepliesByIdResponses, PutRolesByIdData, PutRolesByIdErrors, PutRolesByIdResponses, PutTagsByIdData, PutTagsByIdResponses, PutTenantData, PutTenantErrors, PutTenantResponses, PutUsersByIdData, PutUsersByIdErrors, PutUsersByIdResponses, PutUsersByIdRoleData, PutUsersByIdRoleErrors, PutUsersByIdRoleResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * [tenant-api] Lista contacts del tenant
 */
export const getAccountContacts = <ThrowOnError extends boolean = false>(options?: Options<GetAccountContactsData, ThrowOnError>) => (options?.client ?? client).get<GetAccountContactsResponses, GetAccountContactsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/contacts',
    ...options
});

/**
 * [tenant-api] Crea un contact
 */
export const postAccountContacts = <ThrowOnError extends boolean = false>(options: Options<PostAccountContactsData, ThrowOnError>) => (options.client ?? client).post<PostAccountContactsResponses, PostAccountContactsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Elimina un contact
 */
export const deleteAccountContactsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountContactsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAccountContactsByIdResponses, DeleteAccountContactsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/contacts/{id}',
    ...options
});

/**
 * [tenant-api] Obtiene un contact por ID
 */
export const getAccountContactsById = <ThrowOnError extends boolean = false>(options: Options<GetAccountContactsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAccountContactsByIdResponses, GetAccountContactsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/contacts/{id}',
    ...options
});

/**
 * [tenant-api] Actualiza un contact
 */
export const putAccountContactsById = <ThrowOnError extends boolean = false>(options: Options<PutAccountContactsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAccountContactsByIdResponses, PutAccountContactsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/contacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Lista conversations del tenant
 *
 * API publica. Requiere token creado via /settings/api-tokens con permiso read_conversation.
 */
export const getAccountConversations = <ThrowOnError extends boolean = false>(options?: Options<GetAccountConversationsData, ThrowOnError>) => (options?.client ?? client).get<GetAccountConversationsResponses, GetAccountConversationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations',
    ...options
});

/**
 * [tenant-api] Obtiene una conversation por ID
 */
export const getAccountConversationsById = <ThrowOnError extends boolean = false>(options: Options<GetAccountConversationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAccountConversationsByIdResponses, GetAccountConversationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}',
    ...options
});

/**
 * [tenant-api] Asigna una conversation a un user/team
 */
export const postAccountConversationsByIdAssign = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdAssignData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdAssignResponses, PostAccountConversationsByIdAssignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Lista messages de una conversation
 */
export const getAccountConversationsByIdMessages = <ThrowOnError extends boolean = false>(options: Options<GetAccountConversationsByIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetAccountConversationsByIdMessagesResponses, GetAccountConversationsByIdMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/messages',
    ...options
});

/**
 * [tenant-api] Envia un message outbound en una conversation
 *
 * Dispara el flujo normal de outbound (provider adapter -> WhatsApp/etc.).
 */
export const postAccountConversationsByIdMessages = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdMessagesData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdMessagesResponses, PostAccountConversationsByIdMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Silencia notificaciones de una conversation
 *
 * Suprime push/sound/badge para esta conv. NO cambia el estado — la conv sigue abierta. Requiere permiso resolve_conversation (mismo tier — op de gestión de estado).
 */
export const postAccountConversationsByIdMute = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdMuteData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdMuteResponses, PostAccountConversationsByIdMuteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/mute',
    ...options
});

/**
 * [tenant-api] Lista notas internas de una conversation
 */
export const getAccountConversationsByIdNotes = <ThrowOnError extends boolean = false>(options: Options<GetAccountConversationsByIdNotesData, ThrowOnError>) => (options.client ?? client).get<GetAccountConversationsByIdNotesResponses, GetAccountConversationsByIdNotesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/notes',
    ...options
});

/**
 * [tenant-api] Crea una nota interna en una conversation
 */
export const postAccountConversationsByIdNotes = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdNotesData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdNotesResponses, PostAccountConversationsByIdNotesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Reabre una conversation resolved
 */
export const postAccountConversationsByIdReopen = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdReopenData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdReopenResponses, PostAccountConversationsByIdReopenErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/reopen',
    ...options
});

/**
 * [tenant-api] Marca una conversation como resolved
 */
export const postAccountConversationsByIdResolve = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdResolveData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdResolveResponses, PostAccountConversationsByIdResolveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/resolve',
    ...options
});

/**
 * [tenant-api] Quita la asignacion de una conversation
 */
export const postAccountConversationsByIdUnassign = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdUnassignData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdUnassignResponses, PostAccountConversationsByIdUnassignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/unassign',
    ...options
});

/**
 * [tenant-api] Reactiva notificaciones de una conversation
 */
export const postAccountConversationsByIdUnmute = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdUnmuteData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdUnmuteResponses, PostAccountConversationsByIdUnmuteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/unmute',
    ...options
});

/**
 * [tenant-api] Marca una conversation como pendiente
 *
 * Resetea unread_count >= 1 (placeholder visual). NO revierte los read_at individuales — es un "guardar para después" para el agente. Requiere permiso resolve_conversation.
 */
export const postAccountConversationsByIdUnread = <ThrowOnError extends boolean = false>(options: Options<PostAccountConversationsByIdUnreadData, ThrowOnError>) => (options.client ?? client).post<PostAccountConversationsByIdUnreadResponses, PostAccountConversationsByIdUnreadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/conversations/{id}/unread',
    ...options
});

/**
 * [tenant-api] Elimina una nota por ID
 */
export const deleteAccountNotesById = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountNotesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAccountNotesByIdResponses, DeleteAccountNotesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/notes/{id}',
    ...options
});

/**
 * [tenant-api] Actualiza una nota por ID
 */
export const putAccountNotesById = <ThrowOnError extends boolean = false>(options: Options<PutAccountNotesByIdData, ThrowOnError>) => (options.client ?? client).put<PutAccountNotesByIdResponses, PutAccountNotesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/notes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Lista tags del tenant
 */
export const getAccountTags = <ThrowOnError extends boolean = false>(options?: Options<GetAccountTagsData, ThrowOnError>) => (options?.client ?? client).get<GetAccountTagsResponses, GetAccountTagsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/tags',
    ...options
});

/**
 * [tenant-api] Crea un tag
 */
export const postAccountTags = <ThrowOnError extends boolean = false>(options: Options<PostAccountTagsData, ThrowOnError>) => (options.client ?? client).post<PostAccountTagsResponses, PostAccountTagsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * [tenant-api] Elimina un tag
 */
export const deleteAccountTagsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountTagsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAccountTagsByIdResponses, DeleteAccountTagsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/tags/{id}',
    ...options
});

/**
 * [tenant-api] Actualiza un tag
 */
export const putAccountTagsById = <ThrowOnError extends boolean = false>(options: Options<PutAccountTagsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAccountTagsByIdResponses, PutAccountTagsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/account/tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Salud del BlazeAI Gateway
 *
 * Llama a GET /v1/health del gateway upstream y devuelve estado. 503 si el gateway no está configurado en el deployment.
 */
export const getAdminAiGatewayHealth = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAiGatewayHealthData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAiGatewayHealthResponses, GetAdminAiGatewayHealthErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/ai/gateway/health',
    ...options
});

/**
 * Catálogo de modelos del BlazeAI Gateway
 *
 * Llama a GET /v1/models del gateway y devuelve los IDs de modelos disponibles para el cliente actual. 503 si el gateway no está configurado.
 */
export const getAdminAiGatewayModels = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAiGatewayModelsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAiGatewayModelsResponses, GetAdminAiGatewayModelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/ai/gateway/models',
    ...options
});

/**
 * Uso AI global (todos los tenants)
 *
 * Estadisticas agregadas de calls AI en un periodo: totales, por action_type (analysis, generation, suggestion, ...), por provider (blazeai, openai, ...) y top tenants. Solo superadmin.
 */
export const getAdminAiUsage = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAiUsageData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAiUsageResponses, GetAdminAiUsageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/ai/usage',
    ...options
});

/**
 * Uso AI de un tenant especifico
 *
 * Estadisticas agregadas para un tenant concreto en un periodo. Solo superadmin.
 */
export const getAdminAiUsageByTenantId = <ThrowOnError extends boolean = false>(options: Options<GetAdminAiUsageByTenantIdData, ThrowOnError>) => (options.client ?? client).get<GetAdminAiUsageByTenantIdResponses, GetAdminAiUsageByTenantIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/ai/usage/{tenantId}',
    ...options
});

/**
 * Obtener metricas de crecimiento
 *
 * Obtiene metricas de crecimiento de la plataforma
 */
export const getAdminAnalyticsGrowth = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAnalyticsGrowthData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAnalyticsGrowthResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/analytics/growth',
    ...options
});

/**
 * Obtener resumen
 *
 * Obtiene el resumen general de metricas de la plataforma
 */
export const getAdminAnalyticsOverview = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAnalyticsOverviewData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAnalyticsOverviewResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/analytics/overview',
    ...options
});

/**
 * Obtener analiticas de tenants
 *
 * Obtiene metricas detalladas de tenants
 */
export const getAdminAnalyticsTenants = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAnalyticsTenantsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAnalyticsTenantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/analytics/tenants',
    ...options
});

/**
 * Obtener analiticas de uso
 *
 * Obtiene metricas de uso de la plataforma
 */
export const getAdminAnalyticsUsage = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAnalyticsUsageData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAnalyticsUsageResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/analytics/usage',
    ...options
});

/**
 * Logout del admin autenticado
 *
 * JWT es stateless; este endpoint solo devuelve 200 OK. El cliente debe descartar el token localmente.
 */
export const postAdminAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostAdminAuthLogoutData, ThrowOnError>) => (options?.client ?? client).post<PostAdminAuthLogoutResponses, PostAdminAuthLogoutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/auth/logout',
    ...options
});

/**
 * Info del admin autenticado
 *
 * Retorna id, email y role extraidos del JWT de super_admin.
 */
export const getAdminAuthMe = <ThrowOnError extends boolean = false>(options?: Options<GetAdminAuthMeData, ThrowOnError>) => (options?.client ?? client).get<GetAdminAuthMeResponses, GetAdminAuthMeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/auth/me',
    ...options
});

/**
 * Listar facturas
 *
 * Lista todas las facturas con filtros
 */
export const getAdminInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetAdminInvoicesData, ThrowOnError>) => (options?.client ?? client).get<GetAdminInvoicesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/invoices',
    ...options
});

/**
 * Obtener factura
 *
 * Obtiene los detalles de una factura
 */
export const getAdminInvoicesById = <ThrowOnError extends boolean = false>(options: Options<GetAdminInvoicesByIdData, ThrowOnError>) => (options.client ?? client).get<GetAdminInvoicesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/invoices/{id}',
    ...options
});

/**
 * Reembolsar factura
 *
 * Reembolsa una factura pagada
 */
export const postAdminInvoicesByIdRefund = <ThrowOnError extends boolean = false>(options: Options<PostAdminInvoicesByIdRefundData, ThrowOnError>) => (options.client ?? client).post<PostAdminInvoicesByIdRefundResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/invoices/{id}/refund',
    ...options
});

/**
 * Obtener desglose MRR
 *
 * Obtiene el desglose de MRR por plan
 */
export const getAdminMrr = <ThrowOnError extends boolean = false>(options?: Options<GetAdminMrrData, ThrowOnError>) => (options?.client ?? client).get<GetAdminMrrResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/mrr',
    ...options
});

/**
 * Obtener ingresos
 *
 * Obtiene las metricas de ingresos de la plataforma
 */
export const getAdminRevenue = <ThrowOnError extends boolean = false>(options?: Options<GetAdminRevenueData, ThrowOnError>) => (options?.client ?? client).get<GetAdminRevenueResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/revenue',
    ...options
});

/**
 * Listar suscripciones
 *
 * Lista todas las suscripciones con paginacion
 */
export const getAdminSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<GetAdminSubscriptionsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminSubscriptionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/subscriptions',
    ...options
});

/**
 * Obtener suscripcion
 *
 * Obtiene los detalles de una suscripcion
 */
export const getAdminSubscriptionsById = <ThrowOnError extends boolean = false>(options: Options<GetAdminSubscriptionsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAdminSubscriptionsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/subscriptions/{id}',
    ...options
});

/**
 * Actualizar suscripcion
 *
 * Actualiza una suscripcion existente
 */
export const putAdminSubscriptionsById = <ThrowOnError extends boolean = false>(options: Options<PutAdminSubscriptionsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAdminSubscriptionsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/subscriptions/{id}',
    ...options
});

/**
 * Cancelar suscripcion
 *
 * Cancela una suscripcion
 */
export const postAdminSubscriptionsByIdCancel = <ThrowOnError extends boolean = false>(options: Options<PostAdminSubscriptionsByIdCancelData, ThrowOnError>) => (options.client ?? client).post<PostAdminSubscriptionsByIdCancelResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/subscriptions/{id}/cancel',
    ...options
});

/**
 * Listar tenants
 *
 * Lista todos los tenants con filtros y paginacion
 */
export const getAdminTenants = <ThrowOnError extends boolean = false>(options?: Options<GetAdminTenantsData, ThrowOnError>) => (options?.client ?? client).get<GetAdminTenantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants',
    ...options
});

/**
 * Crear tenant
 *
 * Crea un nuevo tenant
 */
export const postAdminTenants = <ThrowOnError extends boolean = false>(options: Options<PostAdminTenantsData, ThrowOnError>) => (options.client ?? client).post<PostAdminTenantsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eliminar tenant
 *
 * Elimina un tenant (soft delete)
 */
export const deleteAdminTenantsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminTenantsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdminTenantsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}',
    ...options
});

/**
 * Obtener tenant
 *
 * Obtiene los detalles de un tenant
 */
export const getAdminTenantsById = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}',
    ...options
});

/**
 * Actualizar tenant
 *
 * Actualiza un tenant existente
 */
export const putAdminTenantsById = <ThrowOnError extends boolean = false>(options: Options<PutAdminTenantsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAdminTenantsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activar tenant
 *
 * Activa un tenant suspendido
 */
export const postAdminTenantsByIdActivate = <ThrowOnError extends boolean = false>(options: Options<PostAdminTenantsByIdActivateData, ThrowOnError>) => (options.client ?? client).post<PostAdminTenantsByIdActivateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/activate',
    ...options
});

/**
 * Lista automations de un tenant con stats
 */
export const getAdminTenantsByIdAutomations = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdAutomationsData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdAutomationsResponses, GetAdminTenantsByIdAutomationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/automations',
    ...options
});

/**
 * Lista bot flows de un tenant con stats
 */
export const getAdminTenantsByIdBots = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdBotsData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdBotsResponses, GetAdminTenantsByIdBotsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/bots',
    ...options
});

/**
 * Lista canales de inbox de un tenant con metricas
 */
export const getAdminTenantsByIdChannels = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdChannelsData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdChannelsResponses, GetAdminTenantsByIdChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/channels',
    ...options
});

/**
 * Metricas agregadas de features de un tenant
 *
 * Retorna counters de canales, bots, automations, etc. para superadmin dashboard.
 */
export const getAdminTenantsByIdFeatures = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdFeaturesData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdFeaturesResponses, GetAdminTenantsByIdFeaturesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/features',
    ...options
});

/**
 * Impersonar tenant
 *
 * Genera un token para acceder como el tenant
 */
export const postAdminTenantsByIdImpersonate = <ThrowOnError extends boolean = false>(options: Options<PostAdminTenantsByIdImpersonateData, ThrowOnError>) => (options.client ?? client).post<PostAdminTenantsByIdImpersonateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/impersonate',
    ...options
});

/**
 * Obtener facturas del tenant
 *
 * Lista las facturas de un tenant especifico
 */
export const getAdminTenantsByIdInvoices = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdInvoicesData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdInvoicesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/invoices',
    ...options
});

/**
 * Suspender tenant
 *
 * Suspende un tenant
 */
export const postAdminTenantsByIdSuspend = <ThrowOnError extends boolean = false>(options: Options<PostAdminTenantsByIdSuspendData, ThrowOnError>) => (options.client ?? client).post<PostAdminTenantsByIdSuspendResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/suspend',
    ...options
});

/**
 * Obtener uso del tenant
 *
 * Obtiene las metricas de uso de un tenant
 */
export const getAdminTenantsByIdUsage = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdUsageData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdUsageResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/usage',
    ...options
});

/**
 * Obtener usuarios del tenant
 *
 * Lista los usuarios de un tenant especifico
 */
export const getAdminTenantsByIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetAdminTenantsByIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetAdminTenantsByIdUsersResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tenants/{id}/users',
    ...options
});

/**
 * Lista agent bots del tenant
 *
 * Bots externos (n8n/Make/custom). webhook_secret viene enmascarado.
 */
export const getAgentBots = <ThrowOnError extends boolean = false>(options?: Options<GetAgentBotsData, ThrowOnError>) => (options?.client ?? client).get<GetAgentBotsResponses, GetAgentBotsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots',
    ...options
});

/**
 * Crea un agent bot
 *
 * Genera un bot externo con webhook_url y api_token para autenticacion inbound.
 */
export const postAgentBots = <ThrowOnError extends boolean = false>(options: Options<PostAgentBotsData, ThrowOnError>) => (options.client ?? client).post<PostAgentBotsResponses, PostAgentBotsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inbound: agent bot obtiene una conversation con sus messages
 *
 * Devuelve el detalle de una conversation (metadata + history de messages) para que el bot externo pueda contextualizar antes de responder. Solo se permite si la conversation esta asignada al bot identificado por el token — si no, 404 (uniformamos vs 403 para no filtrar existencia de conversations entre tenants/bots). Tipico flow: el backend dispara webhook outbound al bot avisando "nueva conversation asignada", el bot llama a este endpoint para obtener history, y luego responde via `POST /agent-bots/webhook/messages`.
 */
export const getAgentBotsWebhookConversationsById = <ThrowOnError extends boolean = false>(options: Options<GetAgentBotsWebhookConversationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAgentBotsWebhookConversationsByIdResponses, GetAgentBotsWebhookConversationsByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Bot-Token', type: 'apiKey' }],
    url: '/agent-bots/webhook/conversations/{id}',
    ...options
});

/**
 * Inbound: agent bot transfiere la conversation a un humano
 *
 * El bot externo lo llama cuando detecta que ya no puede manejar la conversation (intent fuera de scope, frustracion del cliente, peticion explicita de hablar con humano). El service desasigna el bot, pone la conversation en estado `pending` y dispara la regla de auto-asignacion del tenant para mover a un agente humano disponible. Si se manda `assign_to_user_id` en el body, se asigna directo a ese user (override). Ejemplo: `{"conversation_id":"3f8b...","reason":"Cliente pide hablar con humano"}` o con asignacion directa: `{"conversation_id":"3f8b...","assign_to_user_id":"a1b2..."}`.
 */
export const postAgentBotsWebhookHandoff = <ThrowOnError extends boolean = false>(options: Options<PostAgentBotsWebhookHandoffData, ThrowOnError>) => (options.client ?? client).post<PostAgentBotsWebhookHandoffResponses, PostAgentBotsWebhookHandoffErrors, ThrowOnError>({
    security: [{ name: 'X-Bot-Token', type: 'apiKey' }],
    url: '/agent-bots/webhook/handoff',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inbound: agent bot envia un mensaje a una conversation
 *
 * Lo llama un agent-bot externo (no un usuario humano) para postear un mensaje en una conversation que el bot tiene asignada. Requiere `conversation_id` (UUID) y `content` (texto del mensaje). El bot solo puede mandar a conversations que estan asignadas a el — el service rechaza con 401/404 cualquier otra. El mensaje se distribuye al canal correcto (WhatsApp/Messenger/etc.) usando las credenciales del tenant del bot. Ejemplo de body: `{"conversation_id":"3f8b...","content":"Hola, como puedo ayudarte?"}`.
 */
export const postAgentBotsWebhookMessages = <ThrowOnError extends boolean = false>(options: Options<PostAgentBotsWebhookMessagesData, ThrowOnError>) => (options.client ?? client).post<PostAgentBotsWebhookMessagesResponses, PostAgentBotsWebhookMessagesErrors, ThrowOnError>({
    security: [{ name: 'X-Bot-Token', type: 'apiKey' }],
    url: '/agent-bots/webhook/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un agent bot
 */
export const deleteAgentBotsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentBotsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAgentBotsByIdResponses, DeleteAgentBotsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots/{id}',
    ...options
});

/**
 * Obtiene un agent bot por ID
 */
export const getAgentBotsById = <ThrowOnError extends boolean = false>(options: Options<GetAgentBotsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAgentBotsByIdResponses, GetAgentBotsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots/{id}',
    ...options
});

/**
 * Actualiza un agent bot
 */
export const putAgentBotsById = <ThrowOnError extends boolean = false>(options: Options<PutAgentBotsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAgentBotsByIdResponses, PutAgentBotsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenera el api_token del bot
 *
 * Invalida el token anterior. El bot debera usar el nuevo `api_token` para las requests inbound.
 */
export const postAgentBotsByIdRegenerateToken = <ThrowOnError extends boolean = false>(options: Options<PostAgentBotsByIdRegenerateTokenData, ThrowOnError>) => (options.client ?? client).post<PostAgentBotsByIdRegenerateTokenResponses, PostAgentBotsByIdRegenerateTokenErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agent-bots/{id}/regenerate-token',
    ...options
});

/**
 * Lista agents del tenant
 *
 * Lista paginada de agents (usuarios con rol de agent). Soporta filtro por status y busqueda.
 */
export const getAgents = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsResponses, GetAgentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents',
    ...options
});

/**
 * Crea un agent
 *
 * Crea un nuevo usuario con rol de agent. Roles se asignan por UUID.
 */
export const postAgents = <ThrowOnError extends boolean = false>(options: Options<PostAgentsData, ThrowOnError>) => (options.client ?? client).post<PostAgentsResponses, PostAgentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista agents disponibles para nueva conversacion
 *
 * Agents con status online y con capacidad (menos de maxConversations activas).
 */
export const getAgentsAvailable = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsAvailableData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsAvailableResponses, GetAgentsAvailableErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/available',
    ...options
});

/**
 * Invita multiples agents en una operacion (admin-only)
 *
 * Crea N users en el tenant con passwords temporales. Cada item se procesa individualmente — failures NO abortan el batch. Items duplicados (email ya existe global) van a `skipped`. El response incluye el password temporal de cada user creado UNA SOLA VEZ. Si email_sender esta configurado, se envia un email de bienvenida en background. Max 100 invites por request.
 */
export const postAgentsBulkInvite = <ThrowOnError extends boolean = false>(options: Options<PostAgentsBulkInviteData, ThrowOnError>) => (options.client ?? client).post<PostAgentsBulkInviteResponses, PostAgentsBulkInviteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/bulk-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista agents online
 */
export const getAgentsOnline = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsOnlineData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsOnlineResponses, GetAgentsOnlineErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/online',
    ...options
});

/**
 * Stats agregadas de agents del tenant
 *
 * Counters: total, online, available, avg conversations.
 */
export const getAgentsStats = <ThrowOnError extends boolean = false>(options?: Options<GetAgentsStatsData, ThrowOnError>) => (options?.client ?? client).get<GetAgentsStatsResponses, GetAgentsStatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/stats',
    ...options
});

/**
 * Elimina un agent
 */
export const deleteAgentsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAgentsByIdResponses, DeleteAgentsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}',
    ...options
});

/**
 * Obtiene un agent por ID
 */
export const getAgentsById = <ThrowOnError extends boolean = false>(options: Options<GetAgentsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAgentsByIdResponses, GetAgentsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}',
    ...options
});

/**
 * Actualiza un agent
 */
export const putAgentsById = <ThrowOnError extends boolean = false>(options: Options<PutAgentsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAgentsByIdResponses, PutAgentsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Timeline de actividad de un agent
 */
export const getAgentsByIdActivity = <ThrowOnError extends boolean = false>(options: Options<GetAgentsByIdActivityData, ThrowOnError>) => (options.client ?? client).get<GetAgentsByIdActivityResponses, GetAgentsByIdActivityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/activity',
    ...options
});

/**
 * Asigna roles a un agent
 */
export const postAgentsByIdAssignRoles = <ThrowOnError extends boolean = false>(options: Options<PostAgentsByIdAssignRolesData, ThrowOnError>) => (options.client ?? client).post<PostAgentsByIdAssignRolesResponses, PostAgentsByIdAssignRolesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/assign-roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Metricas de performance de un agent
 *
 * Metricas de un agent en el periodo dado: conversations, csat, response time.
 */
export const getAgentsByIdPerformance = <ThrowOnError extends boolean = false>(options: Options<GetAgentsByIdPerformanceData, ThrowOnError>) => (options.client ?? client).get<GetAgentsByIdPerformanceResponses, GetAgentsByIdPerformanceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/performance',
    ...options
});

/**
 * Remueve un role especifico de un agent
 */
export const deleteAgentsByIdRemoveRoleByRoleId = <ThrowOnError extends boolean = false>(options: Options<DeleteAgentsByIdRemoveRoleByRoleIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAgentsByIdRemoveRoleByRoleIdResponses, DeleteAgentsByIdRemoveRoleByRoleIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/remove-role/{roleId}',
    ...options
});

/**
 * Resetea password de un agent (admin-only)
 *
 * Genera un password temporal random (16 chars), lo persiste, e invalida todas las sesiones existentes del agent. El password temporal se devuelve UNA SOLA VEZ en el response — el admin debe entregarlo por canal seguro. Para flow self-service usar POST /auth/forgot-password (email-based).
 */
export const postAgentsByIdResetPassword = <ThrowOnError extends boolean = false>(options: Options<PostAgentsByIdResetPasswordData, ThrowOnError>) => (options.client ?? client).post<PostAgentsByIdResetPasswordResponses, PostAgentsByIdResetPasswordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/reset-password',
    ...options
});

/**
 * Cambia el status de un agent
 */
export const patchAgentsByIdStatus = <ThrowOnError extends boolean = false>(options: Options<PatchAgentsByIdStatusData, ThrowOnError>) => (options.client ?? client).patch<PatchAgentsByIdStatusResponses, PatchAgentsByIdStatusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sube avatar del agent
 *
 * Multipart upload (form field "file"). Max 5MB. Acepta JPEG/PNG/GIF/WebP. El backend sniffea el MIME real (no confia en el header del cliente). El URL S3 resultante queda en users.avatar y se broadcasta como user.updated via Socket.IO. Self-or-admin: el agent puede subir su propio avatar; admins del tenant pueden subir el de cualquier agent.
 */
export const postAgentsByIdUploadAvatar = <ThrowOnError extends boolean = false>(options: Options<PostAgentsByIdUploadAvatarData, ThrowOnError>) => (options.client ?? client).post<PostAgentsByIdUploadAvatarResponses, PostAgentsByIdUploadAvatarErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/agents/{id}/upload-avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Analiza un mensaje via AI
 *
 * Sentiment, tone, language detection. Consume cuota diaria del tenant.
 */
export const postAiAnalyzeMessage = <ThrowOnError extends boolean = false>(options: Options<PostAiAnalyzeMessageData, ThrowOnError>) => (options.client ?? client).post<PostAiAnalyzeMessageResponses, PostAiAnalyzeMessageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/analyze-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clasifica la intencion de un mensaje (query/purchase/complaint/etc.)
 */
export const postAiClassifyIntent = <ThrowOnError extends boolean = false>(options: Options<PostAiClassifyIntentData, ThrowOnError>) => (options.client ?? client).post<PostAiClassifyIntentResponses, PostAiClassifyIntentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/classify-intent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtiene la configuracion de AI del tenant
 */
export const getAiConfig = <ThrowOnError extends boolean = false>(options?: Options<GetAiConfigData, ThrowOnError>) => (options?.client ?? client).get<GetAiConfigResponses, GetAiConfigErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/config',
    ...options
});

/**
 * Actualiza la configuracion de AI del tenant
 */
export const putAiConfig = <ThrowOnError extends boolean = false>(options: Options<PutAiConfigData, ThrowOnError>) => (options.client ?? client).put<PutAiConfigResponses, PutAiConfigErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Analisis AI agregado de una conversacion
 *
 * Concatena los mensajes INBOUND (del cliente) de la conversation y corre AnalyzeMessage para devolver sentiment, intent, urgencia, entidades y tags sugeridos a nivel de conversation completa. Consume cuota.
 */
export const getAiConversationsByIdAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetAiConversationsByIdAnalysisData, ThrowOnError>) => (options.client ?? client).get<GetAiConversationsByIdAnalysisResponses, GetAiConversationsByIdAnalysisErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/conversations/{id}/analysis',
    ...options
});

/**
 * Resumen AI de una conversacion
 *
 * Carga los ultimos N mensajes (default 100) de una conversation tenant-scoped y genera un resumen 2-3 oraciones via el provider configurado. Consume cuota.
 */
export const getAiConversationsByIdSummary = <ThrowOnError extends boolean = false>(options: Options<GetAiConversationsByIdSummaryData, ThrowOnError>) => (options.client ?? client).get<GetAiConversationsByIdSummaryResponses, GetAiConversationsByIdSummaryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/conversations/{id}/summary',
    ...options
});

/**
 * Chat con BlazeAI Copilot (asistente del agente)
 *
 * Endpoint para que un agente conversacionalmente le pregunte al copilot AI sobre la conversacion que esta mirando, le pida resumenes, redaccion de respuestas, analisis de sentimiento, etc. El copilot NO responde al cliente; responde al agente.
 * Soporta multi-turn via `history`. El `conversation_context` (opcional) es el historial reciente con el cliente que se inyecta en el system prompt para dar contexto al copilot.
 * El `model` permite seleccionar entre los proveedores ruteados por BlazeAI Gateway: gpt-4o (default), claude-opus-4-5, llama3.
 */
export const postAiCopilotChat = <ThrowOnError extends boolean = false>(options: Options<PostAiCopilotChatData, ThrowOnError>) => (options.client ?? client).post<PostAiCopilotChatResponses, PostAiCopilotChatErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/copilot/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extrae entidades nombradas de un mensaje (NER)
 */
export const postAiExtractEntities = <ThrowOnError extends boolean = false>(options: Options<PostAiExtractEntitiesData, ThrowOnError>) => (options.client ?? client).post<PostAiExtractEntitiesResponses, PostAiExtractEntitiesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/extract-entities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Genera una respuesta sugerida via AI
 *
 * Toma el historico de una conversation y genera una respuesta en el tono indicado.
 */
export const postAiGenerateResponse = <ThrowOnError extends boolean = false>(options: Options<PostAiGenerateResponseData, ThrowOnError>) => (options.client ?? client).post<PostAiGenerateResponseResponses, PostAiGenerateResponseErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/generate-response',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health-check del BlazeAI Gateway
 *
 * Verifica que el provider configurado este respondiendo. Incluye lista de modelos disponibles si el provider es blazeai.
 */
export const getAiHealth = <ThrowOnError extends boolean = false>(options?: Options<GetAiHealthData, ThrowOnError>) => (options?.client ?? client).get<GetAiHealthResponses, GetAiHealthErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/health',
    ...options
});

/**
 * Lista proveedores de AI disponibles
 *
 * Proveedores registrados (blazeai, openai, anthropic). Retorna modelo y estado.
 */
export const getAiProviders = <ThrowOnError extends boolean = false>(options?: Options<GetAiProvidersData, ThrowOnError>) => (options?.client ?? client).get<GetAiProvidersResponses, GetAiProvidersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/providers',
    ...options
});

/**
 * Sugiere N respuestas cortas para una conversation
 *
 * Ideal para quick-reply UI en el inbox.
 */
export const postAiSuggestReplies = <ThrowOnError extends boolean = false>(options: Options<PostAiSuggestRepliesData, ThrowOnError>) => (options.client ?? client).post<PostAiSuggestRepliesResponses, PostAiSuggestRepliesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/ai/suggest-replies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete onboarding
 *
 * Complete onboarding with company information
 */
export const postOnboardingComplete = <ThrowOnError extends boolean = false>(options: Options<PostOnboardingCompleteData, ThrowOnError>) => (options.client ?? client).post<PostOnboardingCompleteResponses, PostOnboardingCompleteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/onboarding/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get onboarding status
 *
 * Get onboarding status for the current user's tenant
 */
export const getOnboardingStatus = <ThrowOnError extends boolean = false>(options?: Options<GetOnboardingStatusData, ThrowOnError>) => (options?.client ?? client).get<GetOnboardingStatusResponses, GetOnboardingStatusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/onboarding/status',
    ...options
});

/**
 * Get current tenant
 *
 * Get the tenant information for the current user
 */
export const getTenant = <ThrowOnError extends boolean = false>(options?: Options<GetTenantData, ThrowOnError>) => (options?.client ?? client).get<GetTenantResponses, GetTenantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tenant',
    ...options
});

/**
 * Update tenant
 *
 * Update tenant information (admin only)
 */
export const putTenant = <ThrowOnError extends boolean = false>(options: Options<PutTenantData, ThrowOnError>) => (options.client ?? client).put<PutTenantResponses, PutTenantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crear plan
 *
 * Crea un nuevo plan de suscripción
 */
export const postAdminPlans = <ThrowOnError extends boolean = false>(options: Options<PostAdminPlansData, ThrowOnError>) => (options.client ?? client).post<PostAdminPlansResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eliminar plan
 *
 * Elimina un plan existente
 */
export const deleteAdminPlansById = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminPlansByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdminPlansByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/plans/{id}',
    ...options
});

/**
 * Actualizar plan
 *
 * Actualiza un plan existente
 */
export const putAdminPlansById = <ThrowOnError extends boolean = false>(options: Options<PutAdminPlansByIdData, ThrowOnError>) => (options.client ?? client).put<PutAdminPlansByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/plans/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview backfill de media WhatsApp
 *
 * Cuenta y muestra mensajes candidatos a re-descarga desde Meta sin tocar nada. Validar antes de Run.
 */
export const postAdminStorageBackfillMediaPreview = <ThrowOnError extends boolean = false>(options?: Options<PostAdminStorageBackfillMediaPreviewData, ThrowOnError>) => (options?.client ?? client).post<PostAdminStorageBackfillMediaPreviewResponses, PostAdminStorageBackfillMediaPreviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/storage/backfill-media/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Run backfill de media WhatsApp
 *
 * Ejecuta el backfill: detecta candidatos, re-descarga de Meta, sube a storage, actualiza la fila. Si dry_run=true, solo detecta sin modificar.
 */
export const postAdminStorageBackfillMediaRun = <ThrowOnError extends boolean = false>(options?: Options<PostAdminStorageBackfillMediaRunData, ThrowOnError>) => (options?.client ?? client).post<PostAdminStorageBackfillMediaRunResponses, PostAdminStorageBackfillMediaRunErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/storage/backfill-media/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Limpia sesiones antiguas
 *
 * Elimina sesiones expiradas y antiguas del sistema
 */
export const postBotsCleanup = <ThrowOnError extends boolean = false>(options?: Options<PostBotsCleanupData, ThrowOnError>) => (options?.client ?? client).post<PostBotsCleanupResponses, unknown, ThrowOnError>({ url: '/bots/cleanup', ...options });

/**
 * Lista flujos de bot
 *
 * Obtiene todos los flujos de bot del tenant actual
 */
export const getBotsFlows = <ThrowOnError extends boolean = false>(options?: Options<GetBotsFlowsData, ThrowOnError>) => (options?.client ?? client).get<GetBotsFlowsResponses, unknown, ThrowOnError>({ url: '/bots/flows', ...options });

/**
 * Crea un flujo de bot
 *
 * Crea un nuevo flujo de automatizacion de bot
 */
export const postBotsFlows = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsResponses, unknown, ThrowOnError>({
    url: '/bots/flows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un flujo de bot
 *
 * Elimina un flujo de bot y todos sus nodos y aristas
 */
export const deleteBotsFlowsById = <ThrowOnError extends boolean = false>(options: Options<DeleteBotsFlowsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteBotsFlowsByIdResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}', ...options });

/**
 * Obtiene un flujo de bot
 *
 * Obtiene los detalles de un flujo de bot incluyendo nodos y aristas
 */
export const getBotsFlowsById = <ThrowOnError extends boolean = false>(options: Options<GetBotsFlowsByIdData, ThrowOnError>) => (options.client ?? client).get<GetBotsFlowsByIdResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}', ...options });

/**
 * Actualiza un flujo de bot
 *
 * Actualiza los datos de un flujo de bot existente
 */
export const putBotsFlowsById = <ThrowOnError extends boolean = false>(options: Options<PutBotsFlowsByIdData, ThrowOnError>) => (options.client ?? client).put<PutBotsFlowsByIdResponses, unknown, ThrowOnError>({
    url: '/bots/flows/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activa un flujo de bot
 *
 * Activa un flujo publicado para iniciar su ejecucion
 */
export const postBotsFlowsByIdActivate = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsByIdActivateData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsByIdActivateResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/activate', ...options });

/**
 * Obtiene analytics de un flujo
 *
 * Obtiene analytics detalladas de sesiones para un flujo especifico
 */
export const getBotsFlowsByIdAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetBotsFlowsByIdAnalyticsData, ThrowOnError>) => (options.client ?? client).get<GetBotsFlowsByIdAnalyticsResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/analytics', ...options });

/**
 * Clona un flujo de bot
 *
 * Crea una copia de un flujo existente
 */
export const postBotsFlowsByIdClone = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsByIdCloneData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsByIdCloneResponses, unknown, ThrowOnError>({
    url: '/bots/flows/{id}/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Agrega una conexion
 *
 * Crea una conexion entre dos nodos del flujo
 */
export const postBotsFlowsByIdEdges = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsByIdEdgesData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsByIdEdgesResponses, unknown, ThrowOnError>({
    url: '/bots/flows/{id}/edges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina una conexion
 *
 * Elimina una conexion entre nodos
 */
export const deleteBotsFlowsByIdEdgesByEdgeId = <ThrowOnError extends boolean = false>(options: Options<DeleteBotsFlowsByIdEdgesByEdgeIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteBotsFlowsByIdEdgesByEdgeIdResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/edges/{edgeId}', ...options });

/**
 * Agrega un nodo al flujo
 *
 * Crea un nuevo nodo dentro de un flujo de bot
 */
export const postBotsFlowsByIdNodes = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsByIdNodesData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsByIdNodesResponses, unknown, ThrowOnError>({
    url: '/bots/flows/{id}/nodes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un nodo
 *
 * Elimina un nodo y sus conexiones del flujo
 */
export const deleteBotsFlowsByIdNodesByNodeId = <ThrowOnError extends boolean = false>(options: Options<DeleteBotsFlowsByIdNodesByNodeIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteBotsFlowsByIdNodesByNodeIdResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/nodes/{nodeId}', ...options });

/**
 * Actualiza un nodo
 *
 * Actualiza los datos de un nodo existente
 */
export const putBotsFlowsByIdNodesByNodeId = <ThrowOnError extends boolean = false>(options: Options<PutBotsFlowsByIdNodesByNodeIdData, ThrowOnError>) => (options.client ?? client).put<PutBotsFlowsByIdNodesByNodeIdResponses, unknown, ThrowOnError>({
    url: '/bots/flows/{id}/nodes/{nodeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publica un flujo de bot
 *
 * Publica un flujo para que este disponible para ejecucion
 */
export const postBotsFlowsByIdPublish = <ThrowOnError extends boolean = false>(options: Options<PostBotsFlowsByIdPublishData, ThrowOnError>) => (options.client ?? client).post<PostBotsFlowsByIdPublishResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/publish', ...options });

/**
 * Obtiene estadisticas de un flujo
 *
 * Obtiene estadisticas de sesiones para un flujo especifico
 */
export const getBotsFlowsByIdStats = <ThrowOnError extends boolean = false>(options: Options<GetBotsFlowsByIdStatsData, ThrowOnError>) => (options.client ?? client).get<GetBotsFlowsByIdStatsResponses, unknown, ThrowOnError>({ url: '/bots/flows/{id}/stats', ...options });

/**
 * Procesa un mensaje para el bot
 *
 * Procesa un mensaje entrante y ejecuta el flujo de bot correspondiente
 */
export const postBotsProcess = <ThrowOnError extends boolean = false>(options: Options<PostBotsProcessData, ThrowOnError>) => (options.client ?? client).post<PostBotsProcessResponses, unknown, ThrowOnError>({
    url: '/bots/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista sesiones activas
 *
 * Obtiene todas las sesiones de bot activas del tenant
 */
export const getBotsSessions = <ThrowOnError extends boolean = false>(options?: Options<GetBotsSessionsData, ThrowOnError>) => (options?.client ?? client).get<GetBotsSessionsResponses, unknown, ThrowOnError>({ url: '/bots/sessions', ...options });

/**
 * Inicia una sesion de bot
 *
 * Inicia manualmente una sesion de bot para una conversacion
 */
export const postBotsSessions = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsResponses, unknown, ThrowOnError>({
    url: '/bots/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtiene una sesion de bot
 *
 * Obtiene los detalles de una sesion de bot activa
 */
export const getBotsSessionsById = <ThrowOnError extends boolean = false>(options: Options<GetBotsSessionsByIdData, ThrowOnError>) => (options.client ?? client).get<GetBotsSessionsByIdResponses, unknown, ThrowOnError>({ url: '/bots/sessions/{id}', ...options });

/**
 * Finaliza una sesion
 *
 * Finaliza una sesion de bot activa
 */
export const postBotsSessionsByIdEnd = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsByIdEndData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsByIdEndResponses, unknown, ThrowOnError>({ url: '/bots/sessions/{id}/end', ...options });

/**
 * Transfiere sesion a humano
 *
 * Transfiere una sesion de bot a un agente humano
 */
export const postBotsSessionsByIdHandoff = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsByIdHandoffData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsByIdHandoffResponses, unknown, ThrowOnError>({
    url: '/bots/sessions/{id}/handoff',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pausa una sesion
 *
 * Pausa temporalmente una sesion de bot activa
 */
export const postBotsSessionsByIdPause = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsByIdPauseData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsByIdPauseResponses, unknown, ThrowOnError>({ url: '/bots/sessions/{id}/pause', ...options });

/**
 * Reanuda una sesion
 *
 * Reanuda una sesion de bot que estaba pausada
 */
export const postBotsSessionsByIdResume = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsByIdResumeData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsByIdResumeResponses, unknown, ThrowOnError>({ url: '/bots/sessions/{id}/resume', ...options });

/**
 * Obtiene variables de sesion
 *
 * Obtiene todas las variables del contexto de la sesion
 */
export const getBotsSessionsByIdVariables = <ThrowOnError extends boolean = false>(options: Options<GetBotsSessionsByIdVariablesData, ThrowOnError>) => (options.client ?? client).get<GetBotsSessionsByIdVariablesResponses, unknown, ThrowOnError>({ url: '/bots/sessions/{id}/variables', ...options });

/**
 * Establece variable de sesion
 *
 * Establece una variable en el contexto de la sesion
 */
export const postBotsSessionsByIdVariables = <ThrowOnError extends boolean = false>(options: Options<PostBotsSessionsByIdVariablesData, ThrowOnError>) => (options.client ?? client).post<PostBotsSessionsByIdVariablesResponses, unknown, ThrowOnError>({
    url: '/bots/sessions/{id}/variables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtiene estadisticas de bots
 *
 * Obtiene estadisticas de sesiones y flujos de bot
 */
export const getBotsStats = <ThrowOnError extends boolean = false>(options?: Options<GetBotsStatsData, ThrowOnError>) => (options?.client ?? client).get<GetBotsStatsResponses, unknown, ThrowOnError>({ url: '/bots/stats', ...options });

/**
 * Trigger bot for a conversation
 *
 * Manually starts a bot flow for a specific conversation
 */
export const postBotsTrigger = <ThrowOnError extends boolean = false>(options: Options<PostBotsTriggerData, ThrowOnError>) => (options.client ?? client).post<PostBotsTriggerResponses, unknown, ThrowOnError>({
    url: '/bots/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listar canales
 *
 * Retorna los canales conectados del tenant actual
 */
export const getInboxChannels = <ThrowOnError extends boolean = false>(options?: Options<GetInboxChannelsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxChannelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels',
    ...options
});

/**
 * Crear canal
 *
 * Conecta un nuevo canal de comunicación
 */
export const postInboxChannels = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crea canal Instagram via OAuth con Facebook
 *
 * Recibe el code/token devuelto por Facebook OAuth y arma el canal Instagram completo en un paso (en vez del flow Long-form). Frontend lo dispara desde el wizard de "Conectar Instagram".
 */
export const postInboxChannelsInstagramOauth = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsInstagramOauthData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsInstagramOauthResponses, PostInboxChannelsInstagramOauthErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/instagram/oauth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crea canal Messenger via OAuth con Facebook
 *
 * Mismo flow que Instagram pero para Facebook Messenger. Page-level integration.
 */
export const postInboxChannelsMessengerOauth = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsMessengerOauthData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsMessengerOauthResponses, PostInboxChannelsMessengerOauthErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/messenger/oauth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crear canal WhatsApp
 *
 * Conecta un número de WhatsApp Business
 */
export const postInboxChannelsWhatsapp = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsWhatsappData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsWhatsappResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/whatsapp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crear canal WhatsApp con Embedded Signup
 *
 * Conecta un número de WhatsApp Business usando el flujo de registro insertado de Meta
 */
export const postInboxChannelsWhatsappEmbeddedSignup = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsWhatsappEmbeddedSignupData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsWhatsappEmbeddedSignupResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/whatsapp/embedded-signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener respuestas CSAT de canal
 *
 * Obtiene las respuestas de CSAT para un canal específico
 */
export const getInboxChannelsByChannelIdCsatResponses = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByChannelIdCsatResponsesData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByChannelIdCsatResponsesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/csat/responses',
    ...options
});

/**
 * Obtener estadísticas CSAT de canal
 *
 * Obtiene las estadísticas de CSAT para un canal específico
 */
export const getInboxChannelsByChannelIdCsatStats = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByChannelIdCsatStatsData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByChannelIdCsatStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/csat/stats',
    ...options
});

/**
 * Eliminar canal
 *
 * Desconecta y elimina un canal
 */
export const deleteInboxChannelsById = <ThrowOnError extends boolean = false>(options: Options<DeleteInboxChannelsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteInboxChannelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}',
    ...options
});

/**
 * Obtener canal
 *
 * Retorna el detalle de un canal específico
 */
export const getInboxChannelsById = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}',
    ...options
});

/**
 * Actualizar canal
 *
 * Actualiza la configuración de un canal
 */
export const putInboxChannelsById = <ThrowOnError extends boolean = false>(options: Options<PutInboxChannelsByIdData, ThrowOnError>) => (options.client ?? client).put<PutInboxChannelsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener salud del canal
 *
 * Obtiene métricas y estado de salud del canal
 */
export const getInboxChannelsByIdHealth = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdHealthData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdHealthResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/health',
    ...options
});

/**
 * Regenerar API Key
 *
 * Genera una nueva API key para el canal
 */
export const postInboxChannelsByIdRegenerateKey = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdRegenerateKeyData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdRegenerateKeyResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/regenerate-key',
    ...options
});

/**
 * Enviar mensaje
 *
 * Envía un mensaje de texto a través de un canal
 */
export const postInboxChannelsByIdSend = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdSendData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdSendResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sincronizar plantillas
 *
 * Sincroniza plantillas de mensaje con el proveedor
 */
export const postInboxChannelsByIdSyncTemplates = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdSyncTemplatesData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdSyncTemplatesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/sync-templates',
    ...options
});

/**
 * Lista templates WhatsApp del canal (cache local)
 *
 * Devuelve los templates sincronizados desde Meta Business Manager. Usar POST /inbox/channels/{id}/templates/sync para refrescar el cache.
 */
export const getInboxChannelsByIdTemplates = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdTemplatesData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdTemplatesResponses, GetInboxChannelsByIdTemplatesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/templates',
    ...options
});

/**
 * Crea un template WhatsApp en Meta Business
 *
 * Submitea un template para aprobacion de Meta. Status inicial PENDING; eventualmente llega APPROVED/REJECTED via webhook message_template_status_update.
 */
export const postInboxChannelsByIdTemplates = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdTemplatesData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdTemplatesResponses, PostInboxChannelsByIdTemplatesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Probar conexión
 *
 * Verifica que el canal puede conectarse correctamente
 */
export const postInboxChannelsByIdTest = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdTestData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdTestResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/test',
    ...options
});

/**
 * Listar contactos
 *
 * Retorna los contactos del tenant
 */
export const getInboxContacts = <ThrowOnError extends boolean = false>(options?: Options<GetInboxContactsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxContactsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts',
    ...options
});

/**
 * Crear contacto
 *
 * Crea un nuevo contacto de forma manual
 */
export const postInboxContacts = <ThrowOnError extends boolean = false>(options: Options<PostInboxContactsData, ThrowOnError>) => (options.client ?? client).post<PostInboxContactsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Combinar contactos
 *
 * Combina varios contactos en uno principal, transfiriendo conversaciones y datos
 */
export const postInboxContactsMerge = <ThrowOnError extends boolean = false>(options: Options<PostInboxContactsMergeData, ThrowOnError>) => (options.client ?? client).post<PostInboxContactsMergeResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eliminar contacto
 *
 * Elimina un contacto existente
 */
export const deleteInboxContactsById = <ThrowOnError extends boolean = false>(options: Options<DeleteInboxContactsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteInboxContactsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}',
    ...options
});

/**
 * Obtener contacto
 *
 * Retorna el detalle de un contacto
 */
export const getInboxContactsById = <ThrowOnError extends boolean = false>(options: Options<GetInboxContactsByIdData, ThrowOnError>) => (options.client ?? client).get<GetInboxContactsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}',
    ...options
});

/**
 * Actualizar contacto
 *
 * Actualiza los datos de un contacto
 */
export const putInboxContactsById = <ThrowOnError extends boolean = false>(options: Options<PutInboxContactsByIdData, ThrowOnError>) => (options.client ?? client).put<PutInboxContactsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener contactos combinados
 *
 * Retorna los contactos que fueron combinados en el contacto especificado
 */
export const getInboxContactsByIdMerged = <ThrowOnError extends boolean = false>(options: Options<GetInboxContactsByIdMergedData, ThrowOnError>) => (options.client ?? client).get<GetInboxContactsByIdMergedResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}/merged',
    ...options
});

/**
 * Enviar plantilla a contacto
 *
 * Envía un mensaje de plantilla a un contacto, creando conversación si no existe
 */
export const postInboxContactsByIdSendTemplate = <ThrowOnError extends boolean = false>(options: Options<PostInboxContactsByIdSendTemplateData, ThrowOnError>) => (options.client ?? client).post<PostInboxContactsByIdSendTemplateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}/send-template',
    ...options
});

/**
 * Obtener estadísticas de contacto
 *
 * Retorna el conteo de conversaciones, mensajes y última actividad del contacto
 */
export const getInboxContactsByIdStats = <ThrowOnError extends boolean = false>(options: Options<GetInboxContactsByIdStatsData, ThrowOnError>) => (options.client ?? client).get<GetInboxContactsByIdStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/contacts/{id}/stats',
    ...options
});

/**
 * Listar conversaciones
 *
 * Retorna las conversaciones del tenant con filtros.
 *
 * **Campos de asignación en la respuesta** (`ConversationResponse`):
 * - `assigned_user_id`: presente solo si está asignada a un agente individual.
 * - `assigned_team_id`: presente solo si está asignada a un team.
 * - Si AMBOS están AUSENTES del JSON, la conversación está sin asignar.
 *
 * Go `omitempty` en pointers omite la key — los campos NO aparecen como `null`.
 * Para WS events de assignment ver `docs/guides/realtime.md`.
 */
export const getInboxConversations = <ThrowOnError extends boolean = false>(options?: Options<GetInboxConversationsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxConversationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations',
    ...options
});

/**
 * Asignar conversaciones en bloque
 *
 * Asigna múltiples conversaciones a un agente
 */
export const postInboxConversationsBulkAssign = <ThrowOnError extends boolean = false>(options?: Options<PostInboxConversationsBulkAssignData, ThrowOnError>) => (options?.client ?? client).post<PostInboxConversationsBulkAssignResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/bulk/assign',
    ...options
});

/**
 * Resolver conversaciones en bloque
 *
 * Marca múltiples conversaciones como resueltas
 */
export const postInboxConversationsBulkResolve = <ThrowOnError extends boolean = false>(options?: Options<PostInboxConversationsBulkResolveData, ThrowOnError>) => (options?.client ?? client).post<PostInboxConversationsBulkResolveResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/bulk/resolve',
    ...options
});

/**
 * Etiquetar conversaciones en bloque
 *
 * Agrega tags a múltiples conversaciones
 */
export const postInboxConversationsBulkTag = <ThrowOnError extends boolean = false>(options?: Options<PostInboxConversationsBulkTagData, ThrowOnError>) => (options?.client ?? client).post<PostInboxConversationsBulkTagResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/bulk/tag',
    ...options
});

/**
 * Desasignar conversaciones en bloque
 *
 * Quita la asignación de múltiples conversaciones
 */
export const postInboxConversationsBulkUnassign = <ThrowOnError extends boolean = false>(options?: Options<PostInboxConversationsBulkUnassignData, ThrowOnError>) => (options?.client ?? client).post<PostInboxConversationsBulkUnassignResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/bulk/unassign',
    ...options
});

/**
 * Obtener conversación
 *
 * Retorna el detalle de una conversación
 */
export const getInboxConversationsById = <ThrowOnError extends boolean = false>(options: Options<GetInboxConversationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetInboxConversationsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}',
    ...options
});

/**
 * Actualizar conversación
 *
 * Actualiza estado, prioridad o asignación
 */
export const putInboxConversationsById = <ThrowOnError extends boolean = false>(options: Options<PutInboxConversationsByIdData, ThrowOnError>) => (options.client ?? client).put<PutInboxConversationsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asignar conversación
 *
 * Asigna una conversación a un usuario
 */
export const postInboxConversationsByIdAssign = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdAssignData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdAssignResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asignar equipo
 *
 * Asigna una conversación a un equipo de servicio
 */
export const postInboxConversationsByIdAssignTeam = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdAssignTeamData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdAssignTeamResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/assign-team',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enviar encuesta CSAT manualmente
 *
 * Fuerza el envío de la encuesta CSAT al contacto, sin resolver la conversación
 */
export const postInboxConversationsByIdCsatSend = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdCsatSendData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdCsatSendResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/csat/send',
    ...options
});

/**
 * Obtener mensajes
 *
 * Retorna los mensajes de una conversación
 */
export const getInboxConversationsByIdMessages = <ThrowOnError extends boolean = false>(options: Options<GetInboxConversationsByIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetInboxConversationsByIdMessagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/messages',
    ...options
});

/**
 * Enviar mensaje
 *
 * Envía un mensaje en una conversación
 */
export const postInboxConversationsByIdMessages = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdMessagesData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdMessagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enviar batch de mensajes (multi-archivo)
 *
 * Procesa los items uno por uno respetando el orden. Si uno falla, los siguientes igual se intentan; el response incluye success/error por item. Max 10 items por batch para no saturar el rate limit del provider (Meta: 80 msg/seg/numero).
 */
export const postInboxConversationsByIdMessagesBatch = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdMessagesBatchData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdMessagesBatchResponses, PostInboxConversationsByIdMessagesBatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/messages/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Silenciar conversación
 *
 * Suprime push/sound/badge para esta conv. No cambia el estado — la conv sigue abierta en la inbox del agente.
 */
export const postInboxConversationsByIdMute = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdMuteData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdMuteResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/mute',
    ...options
});

/**
 * Listar notas
 *
 * Retorna las notas de una conversación
 */
export const getInboxConversationsByIdNotes = <ThrowOnError extends boolean = false>(options: Options<GetInboxConversationsByIdNotesData, ThrowOnError>) => (options.client ?? client).get<GetInboxConversationsByIdNotesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/notes',
    ...options
});

/**
 * Crear nota
 *
 * Crea una nueva nota para una conversación
 */
export const postInboxConversationsByIdNotes = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdNotesData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdNotesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Eliminar nota
 *
 * Elimina una nota existente
 */
export const deleteInboxConversationsByIdNotesByNoteId = <ThrowOnError extends boolean = false>(options: Options<DeleteInboxConversationsByIdNotesByNoteIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteInboxConversationsByIdNotesByNoteIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/notes/{noteId}',
    ...options
});

/**
 * Actualizar nota
 *
 * Actualiza una nota existente
 */
export const putInboxConversationsByIdNotesByNoteId = <ThrowOnError extends boolean = false>(options: Options<PutInboxConversationsByIdNotesByNoteIdData, ThrowOnError>) => (options.client ?? client).put<PutInboxConversationsByIdNotesByNoteIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/notes/{noteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Marcar como leída
 *
 * Marca todos los mensajes de una conversación como leídos
 */
export const postInboxConversationsByIdRead = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdReadData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdReadResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/read',
    ...options
});

/**
 * Reabrir conversación
 *
 * Reabre una conversación resuelta
 */
export const postInboxConversationsByIdReopen = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdReopenData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdReopenResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/reopen',
    ...options
});

/**
 * Resolver conversación
 *
 * Marca una conversación como resuelta
 */
export const postInboxConversationsByIdResolve = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdResolveData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdResolveResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/resolve',
    ...options
});

/**
 * Quitar silencio de conversación
 */
export const postInboxConversationsByIdUnmute = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdUnmuteData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdUnmuteResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/unmute',
    ...options
});

/**
 * Marcar conversación como no leída
 *
 * Marca la conv como pendiente de procesar (badge "unread"). NO revierte los read_at de mensajes individuales — es un marker visual para que el agente vuelva a la conv.
 */
export const postInboxConversationsByIdUnread = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdUnreadData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdUnreadResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/unread',
    ...options
});

/**
 * Obtener estadísticas CSAT del tenant
 *
 * Obtiene las estadísticas globales de CSAT para el tenant
 */
export const getInboxCsatStats = <ThrowOnError extends boolean = false>(options?: Options<GetInboxCsatStatsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxCsatStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/csat/stats',
    ...options
});

/**
 * Listar providers disponibles
 *
 * Retorna la lista de providers que se pueden conectar
 */
export const getInboxProviders = <ThrowOnError extends boolean = false>(options?: Options<GetInboxProvidersData, ThrowOnError>) => (options?.client ?? client).get<GetInboxProvidersResponses, unknown, ThrowOnError>({ url: '/inbox/providers', ...options });

/**
 * Obtener estadísticas
 *
 * Retorna estadísticas de conversaciones
 */
export const getInboxStats = <ThrowOnError extends boolean = false>(options?: Options<GetInboxStatsData, ThrowOnError>) => (options?.client ?? client).get<GetInboxStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/stats',
    ...options
});

/**
 * Listar macros
 *
 * Retorna los macros del tenant
 */
export const getMacros = <ThrowOnError extends boolean = false>(options?: Options<GetMacrosData, ThrowOnError>) => (options?.client ?? client).get<GetMacrosResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros',
    ...options
});

/**
 * Crear macro
 *
 * Crea un nuevo macro para el tenant
 */
export const postMacros = <ThrowOnError extends boolean = false>(options: Options<PostMacrosData, ThrowOnError>) => (options.client ?? client).post<PostMacrosResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Buscar macros
 *
 * Busca macros por nombre o descripción
 */
export const getMacrosSearch = <ThrowOnError extends boolean = false>(options: Options<GetMacrosSearchData, ThrowOnError>) => (options.client ?? client).get<GetMacrosSearchResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/search',
    ...options
});

/**
 * Obtener macro por atajo
 *
 * Retorna un macro por su atajo
 */
export const getMacrosShortcutByShortcut = <ThrowOnError extends boolean = false>(options: Options<GetMacrosShortcutByShortcutData, ThrowOnError>) => (options.client ?? client).get<GetMacrosShortcutByShortcutResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/shortcut/{shortcut}',
    ...options
});

/**
 * Eliminar macro
 *
 * Elimina un macro existente
 */
export const deleteMacrosById = <ThrowOnError extends boolean = false>(options: Options<DeleteMacrosByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteMacrosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/{id}',
    ...options
});

/**
 * Obtener macro
 *
 * Retorna el detalle de un macro
 */
export const getMacrosById = <ThrowOnError extends boolean = false>(options: Options<GetMacrosByIdData, ThrowOnError>) => (options.client ?? client).get<GetMacrosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/{id}',
    ...options
});

/**
 * Actualizar macro
 *
 * Actualiza un macro existente
 */
export const putMacrosById = <ThrowOnError extends boolean = false>(options: Options<PutMacrosByIdData, ThrowOnError>) => (options.client ?? client).put<PutMacrosByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Incrementar uso de macro
 *
 * Incrementa el contador de uso de un macro
 */
export const postMacrosByIdUse = <ThrowOnError extends boolean = false>(options: Options<PostMacrosByIdUseData, ThrowOnError>) => (options.client ?? client).post<PostMacrosByIdUseResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/macros/{id}/use',
    ...options
});

/**
 * Plan + uso + cuota del tenant actual
 *
 * Self-service endpoint. Tenant resuelto del JWT/api-key. Devuelve el plan asignado, el array de UsageSummary (uno por tipo de límite) y el estado de expiración. Diseñado para que integradores muestren métricas de consumo en su UI.
 */
export const getMeUsage = <ThrowOnError extends boolean = false>(options?: Options<GetMeUsageData, ThrowOnError>) => (options?.client ?? client).get<GetMeUsageResponses, GetMeUsageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/me/usage',
    ...options
});

/**
 * Obtener todos los planes
 *
 * Retorna la lista de planes disponibles
 */
export const getPlans = <ThrowOnError extends boolean = false>(options?: Options<GetPlansData, ThrowOnError>) => (options?.client ?? client).get<GetPlansResponses, unknown, ThrowOnError>({ url: '/plans', ...options });

/**
 * Obtener plan por ID
 *
 * Retorna un plan específico
 */
export const getPlansById = <ThrowOnError extends boolean = false>(options: Options<GetPlansByIdData, ThrowOnError>) => (options.client ?? client).get<GetPlansByIdResponses, unknown, ThrowOnError>({ url: '/plans/{id}', ...options });

/**
 * Obtener encuesta CSAT
 *
 * Obtiene los datos de una encuesta CSAT por su token
 */
export const getPublicCsatByToken = <ThrowOnError extends boolean = false>(options: Options<GetPublicCsatByTokenData, ThrowOnError>) => (options.client ?? client).get<GetPublicCsatByTokenResponses, unknown, ThrowOnError>({ url: '/public/csat/{token}', ...options });

/**
 * Enviar respuesta CSAT
 *
 * Registra la respuesta del cliente a la encuesta CSAT
 */
export const postPublicCsatByToken = <ThrowOnError extends boolean = false>(options: Options<PostPublicCsatByTokenData, ThrowOnError>) => (options.client ?? client).post<PostPublicCsatByTokenResponses, unknown, ThrowOnError>({
    url: '/public/csat/{token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listar respuestas rápidas
 *
 * Retorna las respuestas rápidas del tenant
 */
export const getQuickReplies = <ThrowOnError extends boolean = false>(options?: Options<GetQuickRepliesData, ThrowOnError>) => (options?.client ?? client).get<GetQuickRepliesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies',
    ...options
});

/**
 * Crear respuesta rápida
 *
 * Crea una nueva respuesta rápida para el tenant
 */
export const postQuickReplies = <ThrowOnError extends boolean = false>(options: Options<PostQuickRepliesData, ThrowOnError>) => (options.client ?? client).post<PostQuickRepliesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener categorías
 *
 * Retorna las categorías de respuestas rápidas
 */
export const getQuickRepliesCategories = <ThrowOnError extends boolean = false>(options?: Options<GetQuickRepliesCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetQuickRepliesCategoriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/categories',
    ...options
});

/**
 * Obtener respuestas rápidas por categoría
 *
 * Retorna las respuestas rápidas de una categoría
 */
export const getQuickRepliesCategoryByCategory = <ThrowOnError extends boolean = false>(options: Options<GetQuickRepliesCategoryByCategoryData, ThrowOnError>) => (options.client ?? client).get<GetQuickRepliesCategoryByCategoryResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/category/{category}',
    ...options
});

/**
 * Buscar respuestas rápidas
 *
 * Busca respuestas rápidas por título o contenido
 */
export const getQuickRepliesSearch = <ThrowOnError extends boolean = false>(options: Options<GetQuickRepliesSearchData, ThrowOnError>) => (options.client ?? client).get<GetQuickRepliesSearchResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/search',
    ...options
});

/**
 * Obtener respuesta rápida por atajo
 *
 * Retorna una respuesta rápida por su atajo
 */
export const getQuickRepliesShortcutByShortcut = <ThrowOnError extends boolean = false>(options: Options<GetQuickRepliesShortcutByShortcutData, ThrowOnError>) => (options.client ?? client).get<GetQuickRepliesShortcutByShortcutResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/shortcut/{shortcut}',
    ...options
});

/**
 * Obtener estadísticas
 *
 * Retorna estadísticas de respuestas rápidas
 */
export const getQuickRepliesStats = <ThrowOnError extends boolean = false>(options?: Options<GetQuickRepliesStatsData, ThrowOnError>) => (options?.client ?? client).get<GetQuickRepliesStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/stats',
    ...options
});

/**
 * Eliminar respuesta rápida
 *
 * Elimina una respuesta rápida existente
 */
export const deleteQuickRepliesById = <ThrowOnError extends boolean = false>(options: Options<DeleteQuickRepliesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteQuickRepliesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/{id}',
    ...options
});

/**
 * Obtener respuesta rápida
 *
 * Retorna el detalle de una respuesta rápida
 */
export const getQuickRepliesById = <ThrowOnError extends boolean = false>(options: Options<GetQuickRepliesByIdData, ThrowOnError>) => (options.client ?? client).get<GetQuickRepliesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/{id}',
    ...options
});

/**
 * Actualizar respuesta rápida
 *
 * Actualiza una respuesta rápida existente
 */
export const putQuickRepliesById = <ThrowOnError extends boolean = false>(options: Options<PutQuickRepliesByIdData, ThrowOnError>) => (options.client ?? client).put<PutQuickRepliesByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Incrementar uso de respuesta rápida
 *
 * Incrementa el contador de uso de una respuesta rápida
 */
export const postQuickRepliesByIdUse = <ThrowOnError extends boolean = false>(options: Options<PostQuickRepliesByIdUseData, ThrowOnError>) => (options.client ?? client).post<PostQuickRepliesByIdUseResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/quick-replies/{id}/use',
    ...options
});

/**
 * Listar etiquetas
 *
 * Retorna las etiquetas del tenant
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => (options?.client ?? client).get<GetTagsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags',
    ...options
});

/**
 * Crear etiqueta
 *
 * Crea una nueva etiqueta para el tenant
 */
export const postTags = <ThrowOnError extends boolean = false>(options: Options<PostTagsData, ThrowOnError>) => (options.client ?? client).post<PostTagsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auto-registra tags huérfanos en la library del tenant
 *
 * Escanea todos los nombres de tags presentes en contacts.tags y conversations.tags del tenant, registra los que aún no existen en la tabla tags con un color por hash determinístico de la paleta blaze. Idempotente — no toca tags ya registrados (preserva colores editados manualmente). Útil para limpiar dataset histórico antes de que la UI dependa del lookup name→color.
 */
export const postTagsBackfill = <ThrowOnError extends boolean = false>(options?: Options<PostTagsBackfillData, ThrowOnError>) => (options?.client ?? client).post<PostTagsBackfillResponses, PostTagsBackfillErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/backfill',
    ...options
});

/**
 * Eliminar etiqueta
 *
 * Elimina una etiqueta existente
 */
export const deleteTagsById = <ThrowOnError extends boolean = false>(options: Options<DeleteTagsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteTagsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}',
    ...options
});

/**
 * Obtener etiqueta
 *
 * Retorna el detalle de una etiqueta
 */
export const getTagsById = <ThrowOnError extends boolean = false>(options: Options<GetTagsByIdData, ThrowOnError>) => (options.client ?? client).get<GetTagsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}',
    ...options
});

/**
 * Actualizar etiqueta
 *
 * Actualiza una etiqueta existente
 */
export const putTagsById = <ThrowOnError extends boolean = false>(options: Options<PutTagsByIdData, ThrowOnError>) => (options.client ?? client).put<PutTagsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar límite
 *
 * Verifica si el tenant puede usar un recurso específico
 */
export const getTenantCheckLimit = <ThrowOnError extends boolean = false>(options: Options<GetTenantCheckLimitData, ThrowOnError>) => (options.client ?? client).get<GetTenantCheckLimitResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tenant/check-limit',
    ...options
});

/**
 * Obtener uso del tenant
 *
 * Retorna el uso actual de recursos del tenant
 */
export const getTenantUsage = <ThrowOnError extends boolean = false>(options?: Options<GetTenantUsageData, ThrowOnError>) => (options?.client ?? client).get<GetTenantUsageResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tenant/usage',
    ...options
});

/**
 * Listar webhooks
 *
 * Retorna los webhooks configurados del tenant
 */
export const getWebhooks = <ThrowOnError extends boolean = false>(options?: Options<GetWebhooksData, ThrowOnError>) => (options?.client ?? client).get<GetWebhooksResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks',
    ...options
});

/**
 * Crear webhook
 *
 * Crea un nuevo webhook para el tenant
 */
export const postWebhooks = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listar tipos de evento disponibles
 *
 * Source-of-truth de eventos a los que un webhook puede suscribirse. Solo retorna eventos con emisor real en el código — sin valores zombi. Usar este endpoint en la UI para popular el selector de eventos al crear/editar webhooks.
 */
export const getWebhooksEventTypes = <ThrowOnError extends boolean = false>(options?: Options<GetWebhooksEventTypesData, ThrowOnError>) => (options?.client ?? client).get<GetWebhooksEventTypesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/event-types',
    ...options
});

/**
 * Eliminar webhook
 *
 * Elimina un webhook existente
 */
export const deleteWebhooksById = <ThrowOnError extends boolean = false>(options: Options<DeleteWebhooksByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteWebhooksByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}',
    ...options
});

/**
 * Obtener webhook
 *
 * Retorna el detalle de un webhook
 */
export const getWebhooksById = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksByIdData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}',
    ...options
});

/**
 * Actualizar webhook
 *
 * Actualiza un webhook existente
 */
export const patchWebhooksById = <ThrowOnError extends boolean = false>(options: Options<PatchWebhooksByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchWebhooksByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Historial de entregas
 *
 * Retorna el historial de entregas de un webhook
 */
export const getWebhooksByIdDeliveries = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksByIdDeliveriesData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksByIdDeliveriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}/deliveries',
    ...options
});

/**
 * Regenerar secret
 *
 * Regenera el secret de firma de un webhook
 */
export const postWebhooksByIdRegenerateSecret = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksByIdRegenerateSecretData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksByIdRegenerateSecretResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}/regenerate-secret',
    ...options
});

/**
 * Probar webhook
 *
 * Envia un evento de prueba al webhook
 */
export const postWebhooksByIdTest = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksByIdTestData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksByIdTestResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/webhooks/{id}/test',
    ...options
});

/**
 * Dispara flujo de reset de password via email
 *
 * Respuesta SIEMPRE generica (ni confirma ni niega que el email exista) para evitar user enumeration. Si el email matchea, se envia un link con token single-use valido por 1h a la direccion registrada.
 */
export const postAuthForgotPassword = <ThrowOnError extends boolean = false>(options: Options<PostAuthForgotPasswordData, ThrowOnError>) => (options.client ?? client).post<PostAuthForgotPasswordResponses, PostAuthForgotPasswordErrors, ThrowOnError>({
    url: '/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Autentica usuario y retorna access+refresh tokens
 *
 * Valida credenciales email+password. Retorna JWT access (corto) y refresh (largo). El refresh se persiste en DB; el access es stateless. Rate-limited: 10 req/min/IP y 5 intentos/15min por email (fail-open en outage de Redis).
 */
export const postAuthLogin = <ThrowOnError extends boolean = false>(options: Options<PostAuthLoginData, ThrowOnError>) => (options.client ?? client).post<PostAuthLoginResponses, PostAuthLoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cierra una sesion (este dispositivo) o todas
 *
 * Si el body trae refresh_token, revoca SOLO ese token (logout this device — el resto de browsers/Qt/mobile siguen vivos). Si el body esta vacio, revoca TODOS los refresh tokens del user (legacy behavior, equivalente a /auth/logout-everywhere). Los access tokens ya emitidos siguen validos hasta expirar a menos que sea logout-everywhere — ahi tambien se invalidan via sessioninval.
 */
export const postAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutData, ThrowOnError>) => (options?.client ?? client).post<PostAuthLogoutResponses, PostAuthLogoutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Revoca TODAS las sesiones del usuario
 *
 * Cierra todas las sesiones activas (web, qt, mobile, etc.). Util cuando el user sospecha que perdio un dispositivo. Tambien invalida access tokens vivos via sessioninval.
 */
export const postAuthLogoutEverywhere = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutEverywhereData, ThrowOnError>) => (options?.client ?? client).post<PostAuthLogoutEverywhereResponses, PostAuthLogoutEverywhereErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/logout-everywhere',
    ...options
});

/**
 * Retorna el perfil del usuario autenticado
 *
 * Incluye role, tenant, onboarding status. El frontend/cliente lo usa para hidrar estado inicial tras login o reload.
 */
export const getAuthMe = <ThrowOnError extends boolean = false>(options?: Options<GetAuthMeData, ThrowOnError>) => (options?.client ?? client).get<GetAuthMeResponses, GetAuthMeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/me',
    ...options
});

/**
 * Lista los tenants accesibles por el user activo
 *
 * Retorna primary (users.tenant_id) + cada membership activo. La UI lo usa para el workspace switcher del topbar — si la lista tiene 2+ items, mostrar el dropdown.
 */
export const getAuthMemberships = <ThrowOnError extends boolean = false>(options?: Options<GetAuthMembershipsData, ThrowOnError>) => (options?.client ?? client).get<GetAuthMembershipsResponses, GetAuthMembershipsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/memberships',
    ...options
});

/**
 * Intercambia un refresh token por un nuevo par access+refresh
 *
 * El refresh token DEBE tener Type=refresh (access tokens son rechazados). El token anterior se invalida (token rotation). Si el refresh expiro o fue revocado via password change, retorna 401 y el cliente debe re-loguear.
 */
export const postAuthRefresh = <ThrowOnError extends boolean = false>(options: Options<PostAuthRefreshData, ThrowOnError>) => (options.client ?? client).post<PostAuthRefreshResponses, PostAuthRefreshErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Crea un nuevo tenant + usuario admin
 *
 * El registro SIEMPRE crea un tenant nuevo con el usuario como admin. Usuarios adicionales se agregan via invitacion (POST /admin/tenants/:id/users).
 */
export const postAuthRegister = <ThrowOnError extends boolean = false>(options: Options<PostAuthRegisterData, ThrowOnError>) => (options.client ?? client).post<PostAuthRegisterResponses, PostAuthRegisterErrors, ThrowOnError>({
    url: '/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recibe solicitud de cuenta (formulario publico)
 *
 * Flow de sales/marketing: un prospecto manda sus datos y el equipo responde manualmente. No crea cuenta automaticamente.
 */
export const postAuthRequestAccount = <ThrowOnError extends boolean = false>(options: Options<PostAuthRequestAccountData, ThrowOnError>) => (options.client ?? client).post<PostAuthRequestAccountResponses, PostAuthRequestAccountErrors, ThrowOnError>({
    url: '/auth/request-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Consume el token de reset y aplica nuevo password
 *
 * Single-use: una vez consumido el token queda invalido. Todas las sesiones activas del usuario son revocadas (refresh tokens borrados). Los access tokens anteriores tambien son rechazados (password_changed_at timestamp en Redis).
 */
export const postAuthResetPassword = <ThrowOnError extends boolean = false>(options: Options<PostAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<PostAuthResetPasswordResponses, PostAuthResetPasswordErrors, ThrowOnError>({
    url: '/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista las sesiones activas del usuario
 *
 * Devuelve las sesiones (refresh tokens vivos) con device_label, last_used_at, created_at, expires_at, e is_current=true para la sesion del cliente que llama. Para que is_current funcione, mandar el refresh_token actual via header X-Refresh-Token (opcional). El response viene envuelto: `{sessions: [SessionDTO, ...]}` — no es array top-level.
 */
export const getAuthSessions = <ThrowOnError extends boolean = false>(options?: Options<GetAuthSessionsData, ThrowOnError>) => (options?.client ?? client).get<GetAuthSessionsResponses, GetAuthSessionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/sessions',
    ...options
});

/**
 * Revoca una sesion especifica del usuario
 *
 * Borra el refresh token con el id dado. Solo se permite si la sesion pertenece al user que llama.
 */
export const deleteAuthSessionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAuthSessionsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAuthSessionsByIdResponses, DeleteAuthSessionsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/sessions/{id}',
    ...options
});

/**
 * Cambia de workspace mintando tokens nuevos en el contexto del tenant elegido
 *
 * Acepta DOS shapes de Authorization. (1) intent_token (recibido de /login multi-tenant): identifica al user post-login para que elija tenant antes de tener access tokens reales. (2) access token de una sesión activa: el user con sesión abierta puede cambiar de workspace desde el switcher del topbar sin re-autenticarse. El handler intenta primero como intent_token; si falla, lo prueba como access. Cualquiera de los dos resuelve userID — luego SwitchTenant valida que ese user tenga acceso al tenant_id pedido (primary o membership activo) y mintea access+refresh nuevos.
 */
export const postAuthSwitchTenant = <ThrowOnError extends boolean = false>(options: Options<PostAuthSwitchTenantData, ThrowOnError>) => (options.client ?? client).post<PostAuthSwitchTenantResponses, PostAuthSwitchTenantErrors, ThrowOnError>({
    url: '/auth/switch-tenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista automation rules del tenant
 */
export const getAutomations = <ThrowOnError extends boolean = false>(options?: Options<GetAutomationsData, ThrowOnError>) => (options?.client ?? client).get<GetAutomationsResponses, GetAutomationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations',
    ...options
});

/**
 * Crea una automation rule
 *
 * Crea una regla event-driven (conversation.created, message.received, etc.) con acciones (assign, tag, reply, webhook).
 */
export const postAutomations = <ThrowOnError extends boolean = false>(options: Options<PostAutomationsData, ThrowOnError>) => (options.client ?? client).post<PostAutomationsResponses, PostAutomationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Soft-delete de una automation rule
 */
export const deleteAutomationsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAutomationsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAutomationsByIdResponses, DeleteAutomationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations/{id}',
    ...options
});

/**
 * Obtiene una automation rule por ID
 */
export const getAutomationsById = <ThrowOnError extends boolean = false>(options: Options<GetAutomationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAutomationsByIdResponses, GetAutomationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations/{id}',
    ...options
});

/**
 * Actualiza una automation rule
 */
export const putAutomationsById = <ThrowOnError extends boolean = false>(options: Options<PutAutomationsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAutomationsByIdResponses, PutAutomationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista el historial de ejecuciones de una rule
 */
export const getAutomationsByIdExecutions = <ThrowOnError extends boolean = false>(options: Options<GetAutomationsByIdExecutionsData, ThrowOnError>) => (options.client ?? client).get<GetAutomationsByIdExecutionsResponses, GetAutomationsByIdExecutionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations/{id}/executions',
    ...options
});

/**
 * Toggle enabled/disabled de una rule
 */
export const patchAutomationsByIdToggle = <ThrowOnError extends boolean = false>(options: Options<PatchAutomationsByIdToggleData, ThrowOnError>) => (options.client ?? client).patch<PatchAutomationsByIdToggleResponses, PatchAutomationsByIdToggleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/automations/{id}/toggle',
    ...options
});

/**
 * Retorna la llamada activa del usuario (si la hay)
 *
 * Retorna `data: null` si no hay call activa.
 */
export const getCallsActive = <ThrowOnError extends boolean = false>(options?: Options<GetCallsActiveData, ThrowOnError>) => (options?.client ?? client).get<GetCallsActiveResponses, GetCallsActiveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/active',
    ...options
});

/**
 * Historial de llamadas del usuario
 */
export const getCallsHistory = <ThrowOnError extends boolean = false>(options?: Options<GetCallsHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetCallsHistoryResponses, GetCallsHistoryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/history',
    ...options
});

/**
 * Inicia una llamada voz/video a otro usuario
 *
 * Crea una call y genera tokens LiveKit. Broadcast call.incoming via Socket.IO al callee.
 */
export const postCallsStart = <ThrowOnError extends boolean = false>(options: Options<PostCallsStartData, ThrowOnError>) => (options.client ?? client).post<PostCallsStartResponses, PostCallsStartErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Responde una llamada entrante
 */
export const postCallsByIdAnswer = <ThrowOnError extends boolean = false>(options: Options<PostCallsByIdAnswerData, ThrowOnError>) => (options.client ?? client).post<PostCallsByIdAnswerResponses, PostCallsByIdAnswerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/{id}/answer',
    ...options
});

/**
 * Termina una llamada en curso
 */
export const postCallsByIdEnd = <ThrowOnError extends boolean = false>(options: Options<PostCallsByIdEndData, ThrowOnError>) => (options.client ?? client).post<PostCallsByIdEndResponses, PostCallsByIdEndErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/{id}/end',
    ...options
});

/**
 * Rechaza una llamada entrante
 */
export const postCallsByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostCallsByIdRejectData, ThrowOnError>) => (options.client ?? client).post<PostCallsByIdRejectResponses, PostCallsByIdRejectErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/{id}/reject',
    ...options
});

/**
 * Obtiene un LiveKit token para conectarse a la room de la call
 */
export const getCallsByIdToken = <ThrowOnError extends boolean = false>(options: Options<GetCallsByIdTokenData, ThrowOnError>) => (options.client ?? client).get<GetCallsByIdTokenResponses, GetCallsByIdTokenErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/calls/{id}/token',
    ...options
});

/**
 * Lista channels del usuario autenticado
 *
 * Retorna solo los channels donde el usuario es miembro.
 */
export const getChannels = <ThrowOnError extends boolean = false>(options?: Options<GetChannelsData, ThrowOnError>) => (options?.client ?? client).get<GetChannelsResponses, GetChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels',
    ...options
});

/**
 * Crea un channel de chat interno
 *
 * Crea un canal (public o private). El creador se agrega como miembro. Broadcast channel.created al tenant.
 */
export const postChannels = <ThrowOnError extends boolean = false>(options: Options<PostChannelsData, ThrowOnError>) => (options.client ?? client).post<PostChannelsResponses, PostChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Busqueda por nombre en los channels del usuario
 */
export const getChannelsSearch = <ThrowOnError extends boolean = false>(options: Options<GetChannelsSearchData, ThrowOnError>) => (options.client ?? client).get<GetChannelsSearchResponses, GetChannelsSearchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/search',
    ...options
});

/**
 * Lista mensajes de un channel
 *
 * Soporta cursor-based pagination via `before` (message ID) y `after` (datetime).
 */
export const getChannelsByChannelIdMessages = <ThrowOnError extends boolean = false>(options: Options<GetChannelsByChannelIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetChannelsByChannelIdMessagesResponses, GetChannelsByChannelIdMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{channelId}/messages',
    ...options
});

/**
 * Lista mensajes pinneados de un channel
 */
export const getChannelsByChannelIdPinnedMessages = <ThrowOnError extends boolean = false>(options: Options<GetChannelsByChannelIdPinnedMessagesData, ThrowOnError>) => (options.client ?? client).get<GetChannelsByChannelIdPinnedMessagesResponses, GetChannelsByChannelIdPinnedMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{channelId}/pinned-messages',
    ...options
});

/**
 * Elimina un channel
 *
 * Solo admins del channel. Broadcast channel.deleted al tenant.
 */
export const deleteChannelsById = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteChannelsByIdResponses, DeleteChannelsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}',
    ...options
});

/**
 * Obtiene un channel por ID
 *
 * Solo miembros del channel pueden verlo.
 */
export const getChannelsById = <ThrowOnError extends boolean = false>(options: Options<GetChannelsByIdData, ThrowOnError>) => (options.client ?? client).get<GetChannelsByIdResponses, GetChannelsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}',
    ...options
});

/**
 * Actualiza un channel
 *
 * Solo admins del channel. Broadcast channel.updated al tenant.
 */
export const putChannelsById = <ThrowOnError extends boolean = false>(options: Options<PutChannelsByIdData, ThrowOnError>) => (options.client ?? client).put<PutChannelsByIdResponses, PutChannelsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Abandona un channel
 */
export const postChannelsByIdLeave = <ThrowOnError extends boolean = false>(options: Options<PostChannelsByIdLeaveData, ThrowOnError>) => (options.client ?? client).post<PostChannelsByIdLeaveResponses, PostChannelsByIdLeaveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}/leave',
    ...options
});

/**
 * Lista miembros de un channel
 */
export const getChannelsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetChannelsByIdMembersData, ThrowOnError>) => (options.client ?? client).get<GetChannelsByIdMembersResponses, GetChannelsByIdMembersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}/members',
    ...options
});

/**
 * Agrega miembros a un channel
 *
 * Broadcast channel.member_added.
 */
export const postChannelsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<PostChannelsByIdMembersData, ThrowOnError>) => (options.client ?? client).post<PostChannelsByIdMembersResponses, PostChannelsByIdMembersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remueve un miembro de un channel
 *
 * Broadcast channel.member_removed.
 */
export const deleteChannelsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelsByIdMembersByUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteChannelsByIdMembersByUserIdResponses, DeleteChannelsByIdMembersByUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}/members/{userId}',
    ...options
});

/**
 * Marca todos los mensajes de un channel como leidos
 */
export const postChannelsByIdRead = <ThrowOnError extends boolean = false>(options: Options<PostChannelsByIdReadData, ThrowOnError>) => (options.client ?? client).post<PostChannelsByIdReadResponses, PostChannelsByIdReadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/channels/{id}/read',
    ...options
});

/**
 * Lista archivos de una carpeta (o del root)
 */
export const getFiles = <ThrowOnError extends boolean = false>(options?: Options<GetFilesData, ThrowOnError>) => (options?.client ?? client).get<GetFilesResponses, GetFilesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files',
    ...options
});

/**
 * Actividad reciente del tenant sobre archivos
 */
export const getFilesActivity = <ThrowOnError extends boolean = false>(options?: Options<GetFilesActivityData, ThrowOnError>) => (options?.client ?? client).get<GetFilesActivityResponses, GetFilesActivityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/activity',
    ...options
});

/**
 * Lista carpetas del tenant
 */
export const getFilesFolders = <ThrowOnError extends boolean = false>(options?: Options<GetFilesFoldersData, ThrowOnError>) => (options?.client ?? client).get<GetFilesFoldersResponses, GetFilesFoldersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders',
    ...options
});

/**
 * Crea una carpeta
 */
export const postFilesFolders = <ThrowOnError extends boolean = false>(options: Options<PostFilesFoldersData, ThrowOnError>) => (options.client ?? client).post<PostFilesFoldersResponses, PostFilesFoldersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina una carpeta (incluyendo contenido)
 */
export const deleteFilesFoldersById = <ThrowOnError extends boolean = false>(options: Options<DeleteFilesFoldersByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteFilesFoldersByIdResponses, DeleteFilesFoldersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders/{id}',
    ...options
});

/**
 * Obtiene una carpeta por ID
 */
export const getFilesFoldersById = <ThrowOnError extends boolean = false>(options: Options<GetFilesFoldersByIdData, ThrowOnError>) => (options.client ?? client).get<GetFilesFoldersByIdResponses, GetFilesFoldersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders/{id}',
    ...options
});

/**
 * Actualiza una carpeta
 */
export const patchFilesFoldersById = <ThrowOnError extends boolean = false>(options: Options<PatchFilesFoldersByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchFilesFoldersByIdResponses, PatchFilesFoldersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ruta completa (breadcrumb) de una carpeta
 */
export const getFilesFoldersByIdPath = <ThrowOnError extends boolean = false>(options: Options<GetFilesFoldersByIdPathData, ThrowOnError>) => (options.client ?? client).get<GetFilesFoldersByIdPathResponses, GetFilesFoldersByIdPathErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders/{id}/path',
    ...options
});

/**
 * Marca/desmarca una carpeta como favorita
 */
export const postFilesFoldersByIdStar = <ThrowOnError extends boolean = false>(options: Options<PostFilesFoldersByIdStarData, ThrowOnError>) => (options.client ?? client).post<PostFilesFoldersByIdStarResponses, PostFilesFoldersByIdStarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/folders/{id}/star',
    ...options
});

/**
 * Lista archivos subidos recientemente
 */
export const getFilesRecent = <ThrowOnError extends boolean = false>(options?: Options<GetFilesRecentData, ThrowOnError>) => (options?.client ?? client).get<GetFilesRecentResponses, GetFilesRecentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/recent',
    ...options
});

/**
 * Busqueda por nombre en archivos y carpetas
 */
export const getFilesSearch = <ThrowOnError extends boolean = false>(options: Options<GetFilesSearchData, ThrowOnError>) => (options.client ?? client).get<GetFilesSearchResponses, GetFilesSearchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/search',
    ...options
});

/**
 * Comparte un archivo o carpeta con usuario/team
 */
export const postFilesShare = <ThrowOnError extends boolean = false>(options: Options<PostFilesShareData, ThrowOnError>) => (options.client ?? client).post<PostFilesShareResponses, PostFilesShareErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Items compartidos con el usuario autenticado
 */
export const getFilesSharedWithMe = <ThrowOnError extends boolean = false>(options?: Options<GetFilesSharedWithMeData, ThrowOnError>) => (options?.client ?? client).get<GetFilesSharedWithMeResponses, GetFilesSharedWithMeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/shared-with-me',
    ...options
});

/**
 * Elimina un share
 */
export const deleteFilesSharesById = <ThrowOnError extends boolean = false>(options: Options<DeleteFilesSharesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteFilesSharesByIdResponses, DeleteFilesSharesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/shares/{id}',
    ...options
});

/**
 * Lista archivos y carpetas favoritos
 */
export const getFilesStarred = <ThrowOnError extends boolean = false>(options?: Options<GetFilesStarredData, ThrowOnError>) => (options?.client ?? client).get<GetFilesStarredResponses, GetFilesStarredErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/starred',
    ...options
});

/**
 * Estadisticas de storage del tenant
 *
 * Totales usados por tipo, quota restante, etc.
 */
export const getFilesStats = <ThrowOnError extends boolean = false>(options?: Options<GetFilesStatsData, ThrowOnError>) => (options?.client ?? client).get<GetFilesStatsResponses, GetFilesStatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/stats',
    ...options
});

/**
 * Lista archivos por tipo (images, documents, videos, audio)
 */
export const getFilesTypeByType = <ThrowOnError extends boolean = false>(options: Options<GetFilesTypeByTypeData, ThrowOnError>) => (options.client ?? client).get<GetFilesTypeByTypeResponses, GetFilesTypeByTypeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/type/{type}',
    ...options
});

/**
 * Sube un archivo al storage del tenant
 *
 * Multipart upload. Limite 25 MB por archivo. `folder_id` opcional para asignar a carpeta.
 */
export const postFilesUpload = <ThrowOnError extends boolean = false>(options: Options<PostFilesUploadData, ThrowOnError>) => (options.client ?? client).post<PostFilesUploadResponses, PostFilesUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Elimina un archivo
 */
export const deleteFilesById = <ThrowOnError extends boolean = false>(options: Options<DeleteFilesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteFilesByIdResponses, DeleteFilesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}',
    ...options
});

/**
 * Obtiene metadata de un archivo por ID
 */
export const getFilesById = <ThrowOnError extends boolean = false>(options: Options<GetFilesByIdData, ThrowOnError>) => (options.client ?? client).get<GetFilesByIdResponses, GetFilesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}',
    ...options
});

/**
 * Actualiza metadata de un archivo (nombre, etc.)
 */
export const patchFilesById = <ThrowOnError extends boolean = false>(options: Options<PatchFilesByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchFilesByIdResponses, PatchFilesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Descarga binario de un archivo
 *
 * Retorna el archivo completo con Content-Disposition: attachment.
 */
export const getFilesByIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetFilesByIdDownloadData, ThrowOnError>) => (options.client ?? client).get<GetFilesByIdDownloadResponses, GetFilesByIdDownloadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}/download',
    ...options
});

/**
 * Mueve un archivo a otra carpeta
 */
export const postFilesByIdMove = <ThrowOnError extends boolean = false>(options: Options<PostFilesByIdMoveData, ThrowOnError>) => (options.client ?? client).post<PostFilesByIdMoveResponses, PostFilesByIdMoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Marca/desmarca un archivo como favorito
 */
export const postFilesByIdStar = <ThrowOnError extends boolean = false>(options: Options<PostFilesByIdStarData, ThrowOnError>) => (options.client ?? client).post<PostFilesByIdStarResponses, PostFilesByIdStarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}/star',
    ...options
});

/**
 * Historial de actividad de un item
 */
export const getFilesByTypeByIdActivity = <ThrowOnError extends boolean = false>(options: Options<GetFilesByTypeByIdActivityData, ThrowOnError>) => (options.client ?? client).get<GetFilesByTypeByIdActivityResponses, GetFilesByTypeByIdActivityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{type}/{id}/activity',
    ...options
});

/**
 * Lista shares activos de un archivo o carpeta
 */
export const getFilesByTypeByIdShares = <ThrowOnError extends boolean = false>(options: Options<GetFilesByTypeByIdSharesData, ThrowOnError>) => (options.client ?? client).get<GetFilesByTypeByIdSharesResponses, GetFilesByTypeByIdSharesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{type}/{id}/shares',
    ...options
});

/**
 * Desasocia cualquier bot de un channel de inbox
 */
export const deleteInboxChannelsByChannelIdAgentBot = <ThrowOnError extends boolean = false>(options: Options<DeleteInboxChannelsByChannelIdAgentBotData, ThrowOnError>) => (options.client ?? client).delete<DeleteInboxChannelsByChannelIdAgentBotResponses, DeleteInboxChannelsByChannelIdAgentBotErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/agent-bot',
    ...options
});

/**
 * Obtiene el bot asociado a un channel (si lo hay)
 */
export const getInboxChannelsByChannelIdAgentBot = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByChannelIdAgentBotData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByChannelIdAgentBotResponses, GetInboxChannelsByChannelIdAgentBotErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/agent-bot',
    ...options
});

/**
 * Asocia un agent bot a un channel de inbox
 *
 * Setea agent_bot_id en la config del channel. Mensajes entrantes seran dispatched al bot.
 */
export const putInboxChannelsByChannelIdAgentBot = <ThrowOnError extends boolean = false>(options: Options<PutInboxChannelsByChannelIdAgentBotData, ThrowOnError>) => (options.client ?? client).put<PutInboxChannelsByChannelIdAgentBotResponses, PutInboxChannelsByChannelIdAgentBotErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/agent-bot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista historial de eventos del sistema de WhatsApp para un canal
 *
 * Eventos NO-message del canal (template status updates, phone quality changes, account alerts, etc). Filtra automáticamente por tenant ownership — un caller no puede ver events de un canal de otro tenant aun pasando el channelId. Default limit=100, max 500.
 */
export const getInboxChannelsByChannelIdWaEvents = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByChannelIdWaEventsData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByChannelIdWaEventsResponses, GetInboxChannelsByChannelIdWaEventsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{channelId}/wa-events',
    ...options
});

/**
 * Obtiene el business profile WhatsApp del canal
 *
 * Trae about, address, description, email, websites, vertical, profile picture URL desde Meta. Lo que el usuario ve cuando abre tu chat.
 */
export const getInboxChannelsByIdBusinessProfile = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdBusinessProfileData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdBusinessProfileResponses, GetInboxChannelsByIdBusinessProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/business-profile',
    ...options
});

/**
 * Actualiza el business profile WhatsApp
 *
 * Cambios visibles inmediatos para usuarios que abran el chat. Profile picture se actualiza con UploadProfilePicture aparte.
 */
export const putInboxChannelsByIdBusinessProfile = <ThrowOnError extends boolean = false>(options: Options<PutInboxChannelsByIdBusinessProfileData, ThrowOnError>) => (options.client ?? client).put<PutInboxChannelsByIdBusinessProfileResponses, PutInboxChannelsByIdBusinessProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/business-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sube foto de perfil del business WhatsApp
 *
 * Multipart upload. El backend la sube a S3 + se la pasa a Meta Graph API. Meta cachea agresivamente — el cambio puede tardar hasta 24h en propagarse en clientes WhatsApp.
 */
export const postInboxChannelsByIdBusinessProfileUploadPicture = <ThrowOnError extends boolean = false>(options: Options<PostInboxChannelsByIdBusinessProfileUploadPictureData, ThrowOnError>) => (options.client ?? client).post<PostInboxChannelsByIdBusinessProfileUploadPictureResponses, PostInboxChannelsByIdBusinessProfileUploadPictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/business-profile/upload-picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Obtiene info de la cuenta de Instagram conectada
 *
 * Username, name, profile_picture_url, followers_count, biography. Trae cache local primero, refresca de Meta Graph si esta stale.
 */
export const getInboxChannelsByIdInstagramProfile = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdInstagramProfileData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdInstagramProfileResponses, GetInboxChannelsByIdInstagramProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/instagram-profile',
    ...options
});

/**
 * Borra un template WhatsApp
 *
 * Borrado en Meta es definitivo — el template ID queda quemado, hay que crear uno nuevo con otro nombre. Local cache se invalida automaticamente.
 */
export const deleteInboxChannelsByIdTemplatesByTemplateId = <ThrowOnError extends boolean = false>(options: Options<DeleteInboxChannelsByIdTemplatesByTemplateIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteInboxChannelsByIdTemplatesByTemplateIdResponses, DeleteInboxChannelsByIdTemplatesByTemplateIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/templates/{templateId}',
    ...options
});

/**
 * Edita un template WhatsApp existente
 *
 * Solo Meta permite editar ciertos campos (body sin parametros, footer). Cambios reactivan el flujo de aprobacion.
 */
export const putInboxChannelsByIdTemplatesByTemplateId = <ThrowOnError extends boolean = false>(options: Options<PutInboxChannelsByIdTemplatesByTemplateIdData, ThrowOnError>) => (options.client ?? client).put<PutInboxChannelsByIdTemplatesByTemplateIdResponses, PutInboxChannelsByIdTemplatesByTemplateIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/templates/{templateId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ver ultimos webhooks recibidos (debug)
 *
 * Devuelve los ultimos webhook payloads que entraron al channel — util para debugging cuando una integracion no esta llegando como esperabas. Tenant-scoped (rechaza si el channel pertenece a otro tenant). Pensado para desarrollo, no para flows de produccion.
 */
export const getInboxChannelsByIdWebhooks = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdWebhooksData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdWebhooksResponses, GetInboxChannelsByIdWebhooksErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/channels/{id}/webhooks',
    ...options
});

/**
 * Envia un mensaje interactivo en la conversacion
 *
 * Soporta WhatsApp interactive types: buttons, list, cta_url, location_request. Body shape depende del subtipo (ver `metadata.interactive_type`).
 */
export const postInboxConversationsByIdActionsInteractive = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdActionsInteractiveData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdActionsInteractiveResponses, PostInboxConversationsByIdActionsInteractiveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/actions/interactive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Envia una reaccion (emoji) sobre un mensaje
 *
 * Reactions de WhatsApp/Messenger. Para REMOVER, mandar emoji vacio. Solo funciona sobre mensajes recientes (ventana ~30d en WhatsApp).
 */
export const postInboxConversationsByIdActionsReaction = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdActionsReactionData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdActionsReactionResponses, PostInboxConversationsByIdActionsReactionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/actions/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Envia un mensaje de template (re-engagement fuera de 24h)
 *
 * Para WhatsApp: rompe la ventana de 24h. Template tiene que estar APPROVED en Meta. Frontend debe pasar el template name + variables como `metadata.params`.
 */
export const postInboxConversationsByIdActionsTemplate = <ThrowOnError extends boolean = false>(options: Options<PostInboxConversationsByIdActionsTemplateData, ThrowOnError>) => (options.client ?? client).post<PostInboxConversationsByIdActionsTemplateResponses, PostInboxConversationsByIdActionsTemplateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/conversations/{id}/actions/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Historial de ediciones de un mensaje
 *
 * Versiones previas (ordenadas desc por edited_at) de un inbox_message. Devuelve array vacio si nunca fue editado o si is_edited=false. Tenant-scoped: el service rechaza mensajes que pertenezcan a otro tenant — se uniforma como 404 para no filtrar info entre tenants.
 */
export const getInboxMessagesByIdEdits = <ThrowOnError extends boolean = false>(options: Options<GetInboxMessagesByIdEditsData, ThrowOnError>) => (options.client ?? client).get<GetInboxMessagesByIdEditsResponses, GetInboxMessagesByIdEditsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/messages/{id}/edits',
    ...options
});

/**
 * Lista eventos critical/warn sin leer del tenant (banner topbar)
 *
 * Feed que la UI consume al montar el topbar para mostrar un banner si hay eventos no leídos que requieran atención (account alerts, phone quality LOW, templates rejected). El listener WS inbox:wa_account_event empuja updates en vivo. Solo incluye severity=warn|critical; los info no aparecen en banner.
 */
export const getInboxWaEventsUnacknowledged = <ThrowOnError extends boolean = false>(options?: Options<GetInboxWaEventsUnacknowledgedData, ThrowOnError>) => (options?.client ?? client).get<GetInboxWaEventsUnacknowledgedResponses, GetInboxWaEventsUnacknowledgedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/wa-events/unacknowledged',
    ...options
});

/**
 * Marca un evento como leído (desaparece del banner)
 *
 * El admin/user lo invoca cuando ya vio el alert y no quiere que siga apareciendo en el banner. Persiste acknowledged_at + acknowledged_by para audit. Idempotente: si ya estaba ack, no hace nada (no devuelve error). Tenant-scoped — un user del tenant A no puede ack un evento del tenant B aun con el id.
 */
export const postInboxWaEventsByIdAcknowledge = <ThrowOnError extends boolean = false>(options: Options<PostInboxWaEventsByIdAcknowledgeData, ThrowOnError>) => (options.client ?? client).post<PostInboxWaEventsByIdAcknowledgeResponses, PostInboxWaEventsByIdAcknowledgeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/inbox/wa-events/{id}/acknowledge',
    ...options
});

/**
 * Lista los addon endpoints registrados por el tenant activo
 */
export const getIntegrationsAddons = <ThrowOnError extends boolean = false>(options?: Options<GetIntegrationsAddonsData, ThrowOnError>) => (options?.client ?? client).get<GetIntegrationsAddonsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/addons',
    ...options
});

/**
 * Registra un addon endpoint nuevo
 */
export const postIntegrationsAddons = <ThrowOnError extends boolean = false>(options: Options<PostIntegrationsAddonsData, ThrowOnError>) => (options.client ?? client).post<PostIntegrationsAddonsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/addons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un addon endpoint
 */
export const deleteIntegrationsAddonsById = <ThrowOnError extends boolean = false>(options: Options<DeleteIntegrationsAddonsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteIntegrationsAddonsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/addons/{id}',
    ...options
});

/**
 * Obtiene un addon endpoint por ID
 */
export const getIntegrationsAddonsById = <ThrowOnError extends boolean = false>(options: Options<GetIntegrationsAddonsByIdData, ThrowOnError>) => (options.client ?? client).get<GetIntegrationsAddonsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/addons/{id}',
    ...options
});

/**
 * Actualiza un addon endpoint
 */
export const putIntegrationsAddonsById = <ThrowOnError extends boolean = false>(options: Options<PutIntegrationsAddonsByIdData, ThrowOnError>) => (options.client ?? client).put<PutIntegrationsAddonsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/addons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invitaciones pendientes del usuario autenticado
 */
export const getInvitationsMy = <ThrowOnError extends boolean = false>(options?: Options<GetInvitationsMyData, ThrowOnError>) => (options?.client ?? client).get<GetInvitationsMyResponses, GetInvitationsMyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/invitations/my',
    ...options
});

/**
 * Cancela/elimina una invitacion
 */
export const deleteInvitationsById = <ThrowOnError extends boolean = false>(options: Options<DeleteInvitationsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteInvitationsByIdResponses, DeleteInvitationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/invitations/{id}',
    ...options
});

/**
 * Obtiene una invitacion por ID
 */
export const getInvitationsById = <ThrowOnError extends boolean = false>(options: Options<GetInvitationsByIdData, ThrowOnError>) => (options.client ?? client).get<GetInvitationsByIdResponses, GetInvitationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/invitations/{id}',
    ...options
});

/**
 * Acepta una invitacion pendiente
 */
export const postInvitationsByIdAccept = <ThrowOnError extends boolean = false>(options: Options<PostInvitationsByIdAcceptData, ThrowOnError>) => (options.client ?? client).post<PostInvitationsByIdAcceptResponses, PostInvitationsByIdAcceptErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/invitations/{id}/accept',
    ...options
});

/**
 * Rechaza una invitacion pendiente
 */
export const postInvitationsByIdReject = <ThrowOnError extends boolean = false>(options: Options<PostInvitationsByIdRejectData, ThrowOnError>) => (options.client ?? client).post<PostInvitationsByIdRejectResponses, PostInvitationsByIdRejectErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/invitations/{id}/reject',
    ...options
});

/**
 * Agrega un contacto al pipeline (crea card)
 */
export const postKanbanCards = <ThrowOnError extends boolean = false>(options: Options<PostKanbanCardsData, ThrowOnError>) => (options.client ?? client).post<PostKanbanCardsResponses, PostKanbanCardsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista notas de un card
 */
export const getKanbanCardsByCardIdNotes = <ThrowOnError extends boolean = false>(options: Options<GetKanbanCardsByCardIdNotesData, ThrowOnError>) => (options.client ?? client).get<GetKanbanCardsByCardIdNotesResponses, GetKanbanCardsByCardIdNotesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{cardId}/notes',
    ...options
});

/**
 * Crea una nota en un card
 */
export const postKanbanCardsByCardIdNotes = <ThrowOnError extends boolean = false>(options: Options<PostKanbanCardsByCardIdNotesData, ThrowOnError>) => (options.client ?? client).post<PostKanbanCardsByCardIdNotesResponses, PostKanbanCardsByCardIdNotesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{cardId}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina una nota de un card
 */
export const deleteKanbanCardsByCardIdNotesByNoteId = <ThrowOnError extends boolean = false>(options: Options<DeleteKanbanCardsByCardIdNotesByNoteIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteKanbanCardsByCardIdNotesByNoteIdResponses, DeleteKanbanCardsByCardIdNotesByNoteIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{cardId}/notes/{noteId}',
    ...options
});

/**
 * Actualiza una nota de un card
 */
export const putKanbanCardsByCardIdNotesByNoteId = <ThrowOnError extends boolean = false>(options: Options<PutKanbanCardsByCardIdNotesByNoteIdData, ThrowOnError>) => (options.client ?? client).put<PutKanbanCardsByCardIdNotesByNoteIdResponses, PutKanbanCardsByCardIdNotesByNoteIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{cardId}/notes/{noteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un card del pipeline
 */
export const deleteKanbanCardsById = <ThrowOnError extends boolean = false>(options: Options<DeleteKanbanCardsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteKanbanCardsByIdResponses, DeleteKanbanCardsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{id}',
    ...options
});

/**
 * Obtiene un card por ID
 */
export const getKanbanCardsById = <ThrowOnError extends boolean = false>(options: Options<GetKanbanCardsByIdData, ThrowOnError>) => (options.client ?? client).get<GetKanbanCardsByIdResponses, GetKanbanCardsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{id}',
    ...options
});

/**
 * Actualiza un card
 */
export const putKanbanCardsById = <ThrowOnError extends boolean = false>(options: Options<PutKanbanCardsByIdData, ThrowOnError>) => (options.client ?? client).put<PutKanbanCardsByIdResponses, PutKanbanCardsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Historial de movimientos de un card
 */
export const getKanbanCardsByIdHistory = <ThrowOnError extends boolean = false>(options: Options<GetKanbanCardsByIdHistoryData, ThrowOnError>) => (options.client ?? client).get<GetKanbanCardsByIdHistoryResponses, GetKanbanCardsByIdHistoryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{id}/history',
    ...options
});

/**
 * Mueve un card a otra stage
 *
 * Registra la transicion en el historial.
 */
export const putKanbanCardsByIdMove = <ThrowOnError extends boolean = false>(options: Options<PutKanbanCardsByIdMoveData, ThrowOnError>) => (options.client ?? client).put<PutKanbanCardsByIdMoveResponses, PutKanbanCardsByIdMoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/cards/{id}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Conversation activa del contacto (para abrir desde el kanban)
 */
export const getKanbanContactsByIdConversation = <ThrowOnError extends boolean = false>(options: Options<GetKanbanContactsByIdConversationData, ThrowOnError>) => (options.client ?? client).get<GetKanbanContactsByIdConversationResponses, GetKanbanContactsByIdConversationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/contacts/{id}/conversation',
    ...options
});

/**
 * Estado de pipelines para un contacto
 *
 * Retorna en que pipelines/stages esta el contacto (kanban cards activas).
 */
export const getKanbanContactsByIdPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetKanbanContactsByIdPipelineStatusData, ThrowOnError>) => (options.client ?? client).get<GetKanbanContactsByIdPipelineStatusResponses, GetKanbanContactsByIdPipelineStatusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/contacts/{id}/pipeline-status',
    ...options
});

/**
 * Lista pipelines del tenant
 */
export const getKanbanPipelines = <ThrowOnError extends boolean = false>(options?: Options<GetKanbanPipelinesData, ThrowOnError>) => (options?.client ?? client).get<GetKanbanPipelinesResponses, GetKanbanPipelinesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines',
    ...options
});

/**
 * Crea un pipeline
 */
export const postKanbanPipelines = <ThrowOnError extends boolean = false>(options: Options<PostKanbanPipelinesData, ThrowOnError>) => (options.client ?? client).post<PostKanbanPipelinesResponses, PostKanbanPipelinesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un pipeline (con sus stages y cards)
 */
export const deleteKanbanPipelinesById = <ThrowOnError extends boolean = false>(options: Options<DeleteKanbanPipelinesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteKanbanPipelinesByIdResponses, DeleteKanbanPipelinesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}',
    ...options
});

/**
 * Obtiene un pipeline por ID (incluye stages y stats)
 */
export const getKanbanPipelinesById = <ThrowOnError extends boolean = false>(options: Options<GetKanbanPipelinesByIdData, ThrowOnError>) => (options.client ?? client).get<GetKanbanPipelinesByIdResponses, GetKanbanPipelinesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}',
    ...options
});

/**
 * Actualiza un pipeline
 */
export const putKanbanPipelinesById = <ThrowOnError extends boolean = false>(options: Options<PutKanbanPipelinesByIdData, ThrowOnError>) => (options.client ?? client).put<PutKanbanPipelinesByIdResponses, PutKanbanPipelinesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista cards de un pipeline
 */
export const getKanbanPipelinesByIdCards = <ThrowOnError extends boolean = false>(options: Options<GetKanbanPipelinesByIdCardsData, ThrowOnError>) => (options.client ?? client).get<GetKanbanPipelinesByIdCardsResponses, GetKanbanPipelinesByIdCardsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}/cards',
    ...options
});

/**
 * Lista las stages de un pipeline
 */
export const getKanbanPipelinesByIdStages = <ThrowOnError extends boolean = false>(options: Options<GetKanbanPipelinesByIdStagesData, ThrowOnError>) => (options.client ?? client).get<GetKanbanPipelinesByIdStagesResponses, GetKanbanPipelinesByIdStagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}/stages',
    ...options
});

/**
 * Crea una stage en un pipeline
 */
export const postKanbanPipelinesByIdStages = <ThrowOnError extends boolean = false>(options: Options<PostKanbanPipelinesByIdStagesData, ThrowOnError>) => (options.client ?? client).post<PostKanbanPipelinesByIdStagesResponses, PostKanbanPipelinesByIdStagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}/stages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reordena las stages de un pipeline
 */
export const postKanbanPipelinesByIdStagesReorder = <ThrowOnError extends boolean = false>(options: Options<PostKanbanPipelinesByIdStagesReorderData, ThrowOnError>) => (options.client ?? client).post<PostKanbanPipelinesByIdStagesReorderResponses, PostKanbanPipelinesByIdStagesReorderErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}/stages/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Estadisticas de un pipeline (cards por stage, totales)
 */
export const getKanbanPipelinesByIdStats = <ThrowOnError extends boolean = false>(options: Options<GetKanbanPipelinesByIdStatsData, ThrowOnError>) => (options.client ?? client).get<GetKanbanPipelinesByIdStatsResponses, GetKanbanPipelinesByIdStatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/pipelines/{id}/stats',
    ...options
});

/**
 * Elimina una stage (debe estar vacia)
 */
export const deleteKanbanStagesById = <ThrowOnError extends boolean = false>(options: Options<DeleteKanbanStagesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteKanbanStagesByIdResponses, DeleteKanbanStagesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/stages/{id}',
    ...options
});

/**
 * Obtiene una stage por ID
 */
export const getKanbanStagesById = <ThrowOnError extends boolean = false>(options: Options<GetKanbanStagesByIdData, ThrowOnError>) => (options.client ?? client).get<GetKanbanStagesByIdResponses, GetKanbanStagesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/stages/{id}',
    ...options
});

/**
 * Actualiza una stage
 */
export const putKanbanStagesById = <ThrowOnError extends boolean = false>(options: Options<PutKanbanStagesByIdData, ThrowOnError>) => (options.client ?? client).put<PutKanbanStagesByIdResponses, PutKanbanStagesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/kanban/stages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista meetings del usuario
 */
export const getMeetings = <ThrowOnError extends boolean = false>(options?: Options<GetMeetingsData, ThrowOnError>) => (options?.client ?? client).get<GetMeetingsResponses, GetMeetingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings',
    ...options
});

/**
 * Crea un meeting
 *
 * Tipo `team` (usuarios internos) o `client` (clientes externos via guest link).
 */
export const postMeetings = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsResponses, PostMeetingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancela un meeting programado
 */
export const deleteMeetingsById = <ThrowOnError extends boolean = false>(options: Options<DeleteMeetingsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteMeetingsByIdResponses, DeleteMeetingsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}',
    ...options
});

/**
 * Obtiene un meeting por ID
 */
export const getMeetingsById = <ThrowOnError extends boolean = false>(options: Options<GetMeetingsByIdData, ThrowOnError>) => (options.client ?? client).get<GetMeetingsByIdResponses, GetMeetingsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}',
    ...options
});

/**
 * Actualiza un meeting
 */
export const patchMeetingsById = <ThrowOnError extends boolean = false>(options: Options<PatchMeetingsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchMeetingsByIdResponses, PatchMeetingsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Termina un meeting en curso
 */
export const postMeetingsByIdEnd = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdEndData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdEndResponses, PostMeetingsByIdEndErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/end',
    ...options
});

/**
 * Genera un link de invitacion para guests (sin auth)
 */
export const postMeetingsByIdGuestLink = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdGuestLinkData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdGuestLinkResponses, PostMeetingsByIdGuestLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/guest-link',
    ...options
});

/**
 * Invita usuarios del tenant al meeting
 *
 * Valida que los invitees pertenezcan al mismo tenant.
 */
export const postMeetingsByIdInvite = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdInviteData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdInviteResponses, PostMeetingsByIdInviteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Se une a un meeting como participante
 */
export const postMeetingsByIdJoin = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdJoinData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdJoinResponses, PostMeetingsByIdJoinErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/join',
    ...options
});

/**
 * Abandona un meeting
 */
export const postMeetingsByIdLeave = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdLeaveData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdLeaveResponses, PostMeetingsByIdLeaveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/leave',
    ...options
});

/**
 * Inicia grabacion del meeting en LiveKit (egress)
 */
export const postMeetingsByIdRecordingStart = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdRecordingStartData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdRecordingStartResponses, PostMeetingsByIdRecordingStartErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/recording/start',
    ...options
});

/**
 * Detiene la grabacion del meeting
 */
export const postMeetingsByIdRecordingStop = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdRecordingStopData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdRecordingStopResponses, PostMeetingsByIdRecordingStopErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/recording/stop',
    ...options
});

/**
 * Inicia un meeting programado (cambia status a in_progress)
 */
export const postMeetingsByIdStart = <ThrowOnError extends boolean = false>(options: Options<PostMeetingsByIdStartData, ThrowOnError>) => (options.client ?? client).post<PostMeetingsByIdStartResponses, PostMeetingsByIdStartErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/start',
    ...options
});

/**
 * Obtiene un LiveKit token para conectarse al meeting
 */
export const getMeetingsByIdToken = <ThrowOnError extends boolean = false>(options: Options<GetMeetingsByIdTokenData, ThrowOnError>) => (options.client ?? client).get<GetMeetingsByIdTokenResponses, GetMeetingsByIdTokenErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/meetings/{id}/token',
    ...options
});

/**
 * Envia un mensaje a un channel
 *
 * Crea un mensaje en el channel. Broadcast WS message.new a todos los miembros.
 */
export const postMessages = <ThrowOnError extends boolean = false>(options: Options<PostMessagesData, ThrowOnError>) => (options.client ?? client).post<PostMessagesResponses, PostMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un mensaje
 *
 * Autor o channel admin. Broadcast WS message.delete.
 */
export const deleteMessagesById = <ThrowOnError extends boolean = false>(options: Options<DeleteMessagesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteMessagesByIdResponses, DeleteMessagesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}',
    ...options
});

/**
 * Edita un mensaje
 *
 * Solo el autor puede editar. Broadcast WS message.edit.
 */
export const putMessagesById = <ThrowOnError extends boolean = false>(options: Options<PutMessagesByIdData, ThrowOnError>) => (options.client ?? client).put<PutMessagesByIdResponses, PutMessagesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Quita el pin de un mensaje
 */
export const deleteMessagesByIdPin = <ThrowOnError extends boolean = false>(options: Options<DeleteMessagesByIdPinData, ThrowOnError>) => (options.client ?? client).delete<DeleteMessagesByIdPinResponses, DeleteMessagesByIdPinErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}/pin',
    ...options
});

/**
 * Pin a un mensaje en el channel
 */
export const postMessagesByIdPin = <ThrowOnError extends boolean = false>(options: Options<PostMessagesByIdPinData, ThrowOnError>) => (options.client ?? client).post<PostMessagesByIdPinResponses, PostMessagesByIdPinErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}/pin',
    ...options
});

/**
 * Agrega una reaccion (emoji) a un mensaje
 *
 * Broadcast WS message.reaction (action=add).
 */
export const postMessagesByIdReactions = <ThrowOnError extends boolean = false>(options: Options<PostMessagesByIdReactionsData, ThrowOnError>) => (options.client ?? client).post<PostMessagesByIdReactionsResponses, PostMessagesByIdReactionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}/reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remueve una reaccion (emoji) de un mensaje
 *
 * Broadcast WS message.reaction (action=remove).
 */
export const deleteMessagesByIdReactionsByEmoji = <ThrowOnError extends boolean = false>(options: Options<DeleteMessagesByIdReactionsByEmojiData, ThrowOnError>) => (options.client ?? client).delete<DeleteMessagesByIdReactionsByEmojiResponses, DeleteMessagesByIdReactionsByEmojiErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}/reactions/{emoji}',
    ...options
});

/**
 * Lista replies de un mensaje padre (thread)
 */
export const getMessagesByIdThread = <ThrowOnError extends boolean = false>(options: Options<GetMessagesByIdThreadData, ThrowOnError>) => (options.client ?? client).get<GetMessagesByIdThreadResponses, GetMessagesByIdThreadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/messages/{id}/thread',
    ...options
});

/**
 * Cancela una migracion en curso
 */
export const postMigrationChatwootCancel = <ThrowOnError extends boolean = false>(options?: Options<PostMigrationChatwootCancelData, ThrowOnError>) => (options?.client ?? client).post<PostMigrationChatwootCancelResponses, PostMigrationChatwootCancelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/migration/chatwoot/cancel',
    ...options
});

/**
 * Preview: cuantos contactos/conversaciones/mensajes serian importados
 */
export const postMigrationChatwootPreview = <ThrowOnError extends boolean = false>(options: Options<PostMigrationChatwootPreviewData, ThrowOnError>) => (options.client ?? client).post<PostMigrationChatwootPreviewResponses, PostMigrationChatwootPreviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/migration/chatwoot/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inicia el job de migracion desde Chatwoot
 *
 * Corre en background. Usar /status para consultar progreso.
 */
export const postMigrationChatwootStart = <ThrowOnError extends boolean = false>(options: Options<PostMigrationChatwootStartData, ThrowOnError>) => (options.client ?? client).post<PostMigrationChatwootStartResponses, PostMigrationChatwootStartErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/migration/chatwoot/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Consulta el status del job de migracion en curso
 */
export const getMigrationChatwootStatus = <ThrowOnError extends boolean = false>(options?: Options<GetMigrationChatwootStatusData, ThrowOnError>) => (options?.client ?? client).get<GetMigrationChatwootStatusResponses, GetMigrationChatwootStatusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/migration/chatwoot/status',
    ...options
});

/**
 * Valida credenciales de una instancia Chatwoot
 *
 * Chequea url + api_access_token antes de iniciar la migracion.
 */
export const postMigrationChatwootValidate = <ThrowOnError extends boolean = false>(options: Options<PostMigrationChatwootValidateData, ThrowOnError>) => (options.client ?? client).post<PostMigrationChatwootValidateResponses, PostMigrationChatwootValidateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/migration/chatwoot/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista notificaciones del usuario autenticado
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications',
    ...options
});

/**
 * Elimina todas las notificaciones del usuario
 */
export const deleteNotificationsClearAll = <ThrowOnError extends boolean = false>(options?: Options<DeleteNotificationsClearAllData, ThrowOnError>) => (options?.client ?? client).delete<DeleteNotificationsClearAllResponses, DeleteNotificationsClearAllErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/clear-all',
    ...options
});

/**
 * Marca todas las notificaciones del usuario como leidas
 */
export const postNotificationsMarkAllRead = <ThrowOnError extends boolean = false>(options?: Options<PostNotificationsMarkAllReadData, ThrowOnError>) => (options?.client ?? client).post<PostNotificationsMarkAllReadResponses, PostNotificationsMarkAllReadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/mark-all-read',
    ...options
});

/**
 * Ultimas N notificaciones del usuario
 */
export const getNotificationsRecent = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsRecentData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsRecentResponses, GetNotificationsRecentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/recent',
    ...options
});

/**
 * Registra un device token para push notifications
 *
 * Apps moviles registran su token (FCM/APNS) aqui para recibir push.
 */
export const postNotificationsRegisterDevice = <ThrowOnError extends boolean = false>(options: Options<PostNotificationsRegisterDeviceData, ThrowOnError>) => (options.client ?? client).post<PostNotificationsRegisterDeviceResponses, PostNotificationsRegisterDeviceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/register-device',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtiene la configuracion de notificaciones del usuario
 *
 * Si el usuario no tiene preferencias guardadas, retorna defaults.
 */
export const getNotificationsSettings = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsSettingsResponses, GetNotificationsSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/settings',
    ...options
});

/**
 * Actualiza la configuracion de notificaciones
 */
export const putNotificationsSettings = <ThrowOnError extends boolean = false>(options: Options<PutNotificationsSettingsData, ThrowOnError>) => (options.client ?? client).put<PutNotificationsSettingsResponses, PutNotificationsSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Envia una notificacion de prueba al usuario
 *
 * Util para debugar push/email/in-app delivery.
 */
export const postNotificationsTest = <ThrowOnError extends boolean = false>(options?: Options<PostNotificationsTestData, ThrowOnError>) => (options?.client ?? client).post<PostNotificationsTestResponses, PostNotificationsTestErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/test',
    ...options
});

/**
 * Cantidad de notificaciones no leidas del usuario
 */
export const getNotificationsUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsUnreadCountData, ThrowOnError>) => (options?.client ?? client).get<GetNotificationsUnreadCountResponses, GetNotificationsUnreadCountErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/unread-count',
    ...options
});

/**
 * Elimina una notificacion del usuario
 */
export const deleteNotificationsById = <ThrowOnError extends boolean = false>(options: Options<DeleteNotificationsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteNotificationsByIdResponses, DeleteNotificationsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/{id}',
    ...options
});

/**
 * Marca una notificacion como leida
 */
export const patchNotificationsByIdRead = <ThrowOnError extends boolean = false>(options: Options<PatchNotificationsByIdReadData, ThrowOnError>) => (options.client ?? client).patch<PatchNotificationsByIdReadResponses, PatchNotificationsByIdReadErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notifications/{id}/read',
    ...options
});

/**
 * Valida un guest link y retorna info del meeting
 *
 * Endpoint PUBLICO (sin auth). El token viene del guest link.
 */
export const getPublicMeetingsByToken = <ThrowOnError extends boolean = false>(options: Options<GetPublicMeetingsByTokenData, ThrowOnError>) => (options.client ?? client).get<GetPublicMeetingsByTokenResponses, GetPublicMeetingsByTokenErrors, ThrowOnError>({ url: '/public/meetings/{token}', ...options });

/**
 * Guest se registra para unirse al meeting (sin auth)
 *
 * Endpoint PUBLICO. Registra el guest con un nombre display.
 */
export const postPublicMeetingsByTokenJoin = <ThrowOnError extends boolean = false>(options: Options<PostPublicMeetingsByTokenJoinData, ThrowOnError>) => (options.client ?? client).post<PostPublicMeetingsByTokenJoinResponses, PostPublicMeetingsByTokenJoinErrors, ThrowOnError>({
    url: '/public/meetings/{token}/join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * LiveKit token para guest (sin auth)
 *
 * Endpoint PUBLICO. Requiere que el guest haya llamado primero a /join.
 */
export const getPublicMeetingsByTokenToken = <ThrowOnError extends boolean = false>(options: Options<GetPublicMeetingsByTokenTokenData, ThrowOnError>) => (options.client ?? client).get<GetPublicMeetingsByTokenTokenResponses, GetPublicMeetingsByTokenTokenErrors, ThrowOnError>({ url: '/public/meetings/{token}/token', ...options });

/**
 * Obtiene configuracion publica del widget
 *
 * Endpoint PUBLICO. El token identifica el canal webchat. Valida `Origin` contra allowed_domains.
 */
export const getPublicWidgetByToken = <ThrowOnError extends boolean = false>(options: Options<GetPublicWidgetByTokenData, ThrowOnError>) => (options.client ?? client).get<GetPublicWidgetByTokenResponses, GetPublicWidgetByTokenErrors, ThrowOnError>({ url: '/public/widget/{token}', ...options });

/**
 * Crea o recupera una sesion de visitante
 *
 * Endpoint PUBLICO. Si `visitor_id` no se provee, se genera. Siempre retorna la misma conversation por visitor (single-conversation lock).
 */
export const postPublicWidgetByTokenSessions = <ThrowOnError extends boolean = false>(options: Options<PostPublicWidgetByTokenSessionsData, ThrowOnError>) => (options.client ?? client).post<PostPublicWidgetByTokenSessionsResponses, PostPublicWidgetByTokenSessionsErrors, ThrowOnError>({
    url: '/public/widget/{token}/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista mensajes de la sesion (widget)
 *
 * Endpoint PUBLICO. Retorna los mensajes de la conversation del visitor.
 */
export const getPublicWidgetByTokenSessionsBySessionIdMessages = <ThrowOnError extends boolean = false>(options: Options<GetPublicWidgetByTokenSessionsBySessionIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetPublicWidgetByTokenSessionsBySessionIdMessagesResponses, GetPublicWidgetByTokenSessionsBySessionIdMessagesErrors, ThrowOnError>({ url: '/public/widget/{token}/sessions/{sessionId}/messages', ...options });

/**
 * Visitor envia un mensaje al inbox (widget)
 *
 * Endpoint PUBLICO. Crea un inbound message en la conversation y dispara el flujo de inbox (auto-assign, bots, etc.).
 */
export const postPublicWidgetByTokenSessionsBySessionIdMessages = <ThrowOnError extends boolean = false>(options: Options<PostPublicWidgetByTokenSessionsBySessionIdMessagesData, ThrowOnError>) => (options.client ?? client).post<PostPublicWidgetByTokenSessionsBySessionIdMessagesResponses, PostPublicWidgetByTokenSessionsBySessionIdMessagesErrors, ThrowOnError>({
    url: '/public/widget/{token}/sessions/{sessionId}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista grabaciones de meetings del tenant
 */
export const getRecordings = <ThrowOnError extends boolean = false>(options?: Options<GetRecordingsData, ThrowOnError>) => (options?.client ?? client).get<GetRecordingsResponses, GetRecordingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/recordings',
    ...options
});

/**
 * Elimina una grabacion y su archivo en S3
 */
export const deleteRecordingsById = <ThrowOnError extends boolean = false>(options: Options<DeleteRecordingsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteRecordingsByIdResponses, DeleteRecordingsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/recordings/{id}',
    ...options
});

/**
 * Obtiene una grabacion por ID
 */
export const getRecordingsById = <ThrowOnError extends boolean = false>(options: Options<GetRecordingsByIdData, ThrowOnError>) => (options.client ?? client).get<GetRecordingsByIdResponses, GetRecordingsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/recordings/{id}',
    ...options
});

/**
 * Reporte de performance por agent
 */
export const getReportsAgents = <ThrowOnError extends boolean = false>(options?: Options<GetReportsAgentsData, ThrowOnError>) => (options?.client ?? client).get<GetReportsAgentsResponses, GetReportsAgentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/agents',
    ...options
});

/**
 * Reporte de actividad por channel
 */
export const getReportsChannels = <ThrowOnError extends boolean = false>(options?: Options<GetReportsChannelsData, ThrowOnError>) => (options?.client ?? client).get<GetReportsChannelsResponses, GetReportsChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/channels',
    ...options
});

/**
 * Reporte de scores CSAT
 */
export const getReportsCsat = <ThrowOnError extends boolean = false>(options?: Options<GetReportsCsatData, ThrowOnError>) => (options?.client ?? client).get<GetReportsCsatResponses, GetReportsCsatErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/csat',
    ...options
});

/**
 * Exporta un reporte a CSV/XLSX/PDF
 *
 * El tipo de reporte se indica via `report` query param.
 */
export const getReportsExport = <ThrowOnError extends boolean = false>(options: Options<GetReportsExportData, ThrowOnError>) => (options.client ?? client).get<GetReportsExportResponses, GetReportsExportErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/export',
    ...options
});

/**
 * Reporte de inbox (conversations y distribucion)
 */
export const getReportsInbox = <ThrowOnError extends boolean = false>(options?: Options<GetReportsInboxData, ThrowOnError>) => (options?.client ?? client).get<GetReportsInboxResponses, GetReportsInboxErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/inbox',
    ...options
});

/**
 * Reporte general (dashboard analytics)
 *
 * Metricas agregadas del tenant: conversations, messages, response time, resolution rate, etc.
 */
export const getReportsOverview = <ThrowOnError extends boolean = false>(options?: Options<GetReportsOverviewData, ThrowOnError>) => (options?.client ?? client).get<GetReportsOverviewResponses, GetReportsOverviewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/overview',
    ...options
});

/**
 * Reporte de cumplimiento de SLA
 */
export const getReportsSla = <ThrowOnError extends boolean = false>(options?: Options<GetReportsSlaData, ThrowOnError>) => (options?.client ?? client).get<GetReportsSlaResponses, GetReportsSlaErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/sla',
    ...options
});

/**
 * Obtiene la configuracion de SLA del tenant
 *
 * Thresholds aplicados por el reporter (tiempo de respuesta objetivo, horario, etc.).
 */
export const getReportsSlaConfig = <ThrowOnError extends boolean = false>(options?: Options<GetReportsSlaConfigData, ThrowOnError>) => (options?.client ?? client).get<GetReportsSlaConfigResponses, GetReportsSlaConfigErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/sla/config',
    ...options
});

/**
 * Distribucion de tags sobre conversations
 */
export const getReportsTags = <ThrowOnError extends boolean = false>(options?: Options<GetReportsTagsData, ThrowOnError>) => (options?.client ?? client).get<GetReportsTagsResponses, GetReportsTagsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/reports/tags',
    ...options
});

/**
 * Lista roles del tenant
 *
 * Roles RBAC disponibles en el tenant. Incluye system roles por default.
 */
export const getRoles = <ThrowOnError extends boolean = false>(options?: Options<GetRolesData, ThrowOnError>) => (options?.client ?? client).get<GetRolesResponses, GetRolesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles',
    ...options
});

/**
 * Crea un nuevo role
 *
 * Requiere SettingsManageRoles. `permissions` es el mapa completo de flags.
 */
export const postRoles = <ThrowOnError extends boolean = false>(options: Options<PostRolesData, ThrowOnError>) => (options.client ?? client).post<PostRolesResponses, PostRolesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista las categorias de permisos disponibles
 *
 * Utilizado por la UI de gestion de roles para renderizar los permisos agrupados.
 */
export const getRolesPermissionsCategories = <ThrowOnError extends boolean = false>(options?: Options<GetRolesPermissionsCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetRolesPermissionsCategoriesResponses, GetRolesPermissionsCategoriesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/permissions/categories',
    ...options
});

/**
 * Valida que un nombre de role este disponible
 *
 * Retorna isValid=true si el nombre no esta en uso (excluyendo opcionalmente un role).
 */
export const postRolesValidateName = <ThrowOnError extends boolean = false>(options: Options<PostRolesValidateNameData, ThrowOnError>) => (options.client ?? client).post<PostRolesValidateNameResponses, PostRolesValidateNameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/validate-name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Elimina un role
 *
 * Requiere SettingsManageRoles. No se pueden eliminar system roles.
 */
export const deleteRolesById = <ThrowOnError extends boolean = false>(options: Options<DeleteRolesByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteRolesByIdResponses, DeleteRolesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/{id}',
    ...options
});

/**
 * Obtiene un role por ID
 */
export const getRolesById = <ThrowOnError extends boolean = false>(options: Options<GetRolesByIdData, ThrowOnError>) => (options.client ?? client).get<GetRolesByIdResponses, GetRolesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/{id}',
    ...options
});

/**
 * Actualiza un role
 *
 * Requiere SettingsManageRoles.
 */
export const putRolesById = <ThrowOnError extends boolean = false>(options: Options<PutRolesByIdData, ThrowOnError>) => (options.client ?? client).put<PutRolesByIdResponses, PutRolesByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplica un role existente
 *
 * Crea un nuevo role con los mismos permisos pero nombre/displayName distintos. Requiere SettingsManageRoles.
 */
export const postRolesByIdDuplicate = <ThrowOnError extends boolean = false>(options: Options<PostRolesByIdDuplicateData, ThrowOnError>) => (options.client ?? client).post<PostRolesByIdDuplicateResponses, PostRolesByIdDuplicateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/{id}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista usuarios asignados a un role
 */
export const getRolesByIdUsers = <ThrowOnError extends boolean = false>(options: Options<GetRolesByIdUsersData, ThrowOnError>) => (options.client ?? client).get<GetRolesByIdUsersResponses, GetRolesByIdUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/roles/{id}/users',
    ...options
});

/**
 * Busca mensajes por texto dentro de un channel
 *
 * Full-text search sobre el contenido de los mensajes. Scoped por channel.
 */
export const getSearchMessages = <ThrowOnError extends boolean = false>(options: Options<GetSearchMessagesData, ThrowOnError>) => (options.client ?? client).get<GetSearchMessagesResponses, GetSearchMessagesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/search/messages',
    ...options
});

/**
 * Lista API tokens del tenant
 *
 * Solo admins. Retorna metadata (no el raw token, que solo se muestra en CreateToken).
 */
export const getSettingsApiTokens = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsApiTokensData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsApiTokensResponses, GetSettingsApiTokensErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens',
    ...options
});

/**
 * Crea un API token de tenant
 *
 * Genera un token bearer para integraciones externas. Solo admins. El raw token se devuelve UNICAMENTE aqui; guardalo del lado del caller.
 */
export const postSettingsApiTokens = <ThrowOnError extends boolean = false>(options: Options<PostSettingsApiTokensData, ThrowOnError>) => (options.client ?? client).post<PostSettingsApiTokensResponses, PostSettingsApiTokensErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista los permissions disponibles para API tokens
 *
 * Source-of-truth de permissions válidos al crear/actualizar un token. Igual patrón que /webhooks/event-types — el frontend debe llamar este endpoint para popular el selector de permissions, no hardcodear strings.
 */
export const getSettingsApiTokensPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsApiTokensPermissionsData, ThrowOnError>) => (options?.client ?? client).get<GetSettingsApiTokensPermissionsResponses, GetSettingsApiTokensPermissionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens/permissions',
    ...options
});

/**
 * Revoca un API token (delete)
 */
export const deleteSettingsApiTokensById = <ThrowOnError extends boolean = false>(options: Options<DeleteSettingsApiTokensByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteSettingsApiTokensByIdResponses, DeleteSettingsApiTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens/{id}',
    ...options
});

/**
 * Obtiene un API token por ID (metadata)
 */
export const getSettingsApiTokensById = <ThrowOnError extends boolean = false>(options: Options<GetSettingsApiTokensByIdData, ThrowOnError>) => (options.client ?? client).get<GetSettingsApiTokensByIdResponses, GetSettingsApiTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens/{id}',
    ...options
});

/**
 * Actualiza nombre y permisos de un API token
 */
export const patchSettingsApiTokensById = <ThrowOnError extends boolean = false>(options: Options<PatchSettingsApiTokensByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchSettingsApiTokensByIdResponses, PatchSettingsApiTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/settings/api-tokens/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sirve un archivo del storage directamente (con cache 1 ano)
 *
 * El path debe empezar con el tenantID del caller (anti cross-tenant). Disponible en `/api/v1/storage/files*` y alias legacy `/api/storage/files*`.
 */
export const getStorageFilesByPath = <ThrowOnError extends boolean = false>(options: Options<GetStorageFilesByPathData, ThrowOnError>) => (options.client ?? client).get<GetStorageFilesByPathResponses, GetStorageFilesByPathErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/storage/files/{path}',
    ...options
});

/**
 * Genera una URL firmada temporal (presigned S3 URL)
 *
 * Tenant isolation por prefix. Disponible en `/api/v1/storage/presigned` y alias legacy `/api/storage/presigned`.
 */
export const getStoragePresigned = <ThrowOnError extends boolean = false>(options: Options<GetStoragePresignedData, ThrowOnError>) => (options.client ?? client).get<GetStoragePresignedResponses, GetStoragePresignedErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/storage/presigned',
    ...options
});

/**
 * Upload generico de media a MinIO/S3
 *
 * Multipart upload. Max 25MB. Valida MIME via magic number (rechaza ejecutables). Convierte audio/webm a audio/ogg via ffmpeg para compat WhatsApp. Disponible en `/api/v1/storage/upload` (con @BasePath) y `/api/storage/upload` (alias legacy sin v1).
 */
export const postStorageUpload = <ThrowOnError extends boolean = false>(options: Options<PostStorageUploadData, ThrowOnError>) => (options.client ?? client).post<PostStorageUploadResponses, PostStorageUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/storage/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Lista teams del tenant
 */
export const getTeams = <ThrowOnError extends boolean = false>(options?: Options<GetTeamsData, ThrowOnError>) => (options?.client ?? client).get<GetTeamsResponses, GetTeamsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams',
    ...options
});

/**
 * Crea un team (requiere TeamsCreate)
 */
export const postTeams = <ThrowOnError extends boolean = false>(options: Options<PostTeamsData, ThrowOnError>) => (options.client ?? client).post<PostTeamsResponses, PostTeamsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Teams del usuario autenticado
 */
export const getTeamsMy = <ThrowOnError extends boolean = false>(options?: Options<GetTeamsMyData, ThrowOnError>) => (options?.client ?? client).get<GetTeamsMyResponses, GetTeamsMyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/my',
    ...options
});

/**
 * Busqueda por nombre de teams
 */
export const getTeamsSearch = <ThrowOnError extends boolean = false>(options?: Options<GetTeamsSearchData, ThrowOnError>) => (options?.client ?? client).get<GetTeamsSearchResponses, GetTeamsSearchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/search',
    ...options
});

/**
 * Elimina un team (requiere TeamsCreate)
 */
export const deleteTeamsById = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteTeamsByIdResponses, DeleteTeamsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}',
    ...options
});

/**
 * Obtiene un team por ID
 */
export const getTeamsById = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdResponses, GetTeamsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}',
    ...options
});

/**
 * Actualiza un team (requiere TeamsCreate)
 */
export const patchTeamsById = <ThrowOnError extends boolean = false>(options: Options<PatchTeamsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchTeamsByIdResponses, PatchTeamsByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Actividad reciente de un team
 */
export const getTeamsByIdActivity = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdActivityData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdActivityResponses, GetTeamsByIdActivityErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/activity',
    ...options
});

/**
 * Lista los channels asociados a un team
 */
export const getTeamsByIdChannels = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdChannelsData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdChannelsResponses, GetTeamsByIdChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/channels',
    ...options
});

/**
 * Crea un channel dentro de un team (requiere TeamsManageChannels)
 */
export const postTeamsByIdChannels = <ThrowOnError extends boolean = false>(options: Options<PostTeamsByIdChannelsData, ThrowOnError>) => (options.client ?? client).post<PostTeamsByIdChannelsResponses, PostTeamsByIdChannelsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lista invitaciones pendientes de un team
 */
export const getTeamsByIdInvitations = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdInvitationsData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdInvitationsResponses, GetTeamsByIdInvitationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/invitations',
    ...options
});

/**
 * Envia invitaciones por email a usuarios externos (requiere TeamsInviteMembers)
 */
export const postTeamsByIdInvite = <ThrowOnError extends boolean = false>(options: Options<PostTeamsByIdInviteData, ThrowOnError>) => (options.client ?? client).post<PostTeamsByIdInviteResponses, PostTeamsByIdInviteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * El usuario se une a un team publico
 */
export const postTeamsByIdJoin = <ThrowOnError extends boolean = false>(options: Options<PostTeamsByIdJoinData, ThrowOnError>) => (options.client ?? client).post<PostTeamsByIdJoinResponses, PostTeamsByIdJoinErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/join',
    ...options
});

/**
 * El usuario abandona un team
 */
export const postTeamsByIdLeave = <ThrowOnError extends boolean = false>(options: Options<PostTeamsByIdLeaveData, ThrowOnError>) => (options.client ?? client).post<PostTeamsByIdLeaveResponses, PostTeamsByIdLeaveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/leave',
    ...options
});

/**
 * Lista miembros de un team
 */
export const getTeamsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdMembersData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdMembersResponses, GetTeamsByIdMembersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/members',
    ...options
});

/**
 * Agrega miembros a un team (requiere TeamsInviteMembers)
 */
export const postTeamsByIdMembers = <ThrowOnError extends boolean = false>(options: Options<PostTeamsByIdMembersData, ThrowOnError>) => (options.client ?? client).post<PostTeamsByIdMembersResponses, PostTeamsByIdMembersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remueve un miembro de un team (requiere TeamsInviteMembers)
 */
export const deleteTeamsByIdMembersByUserId = <ThrowOnError extends boolean = false>(options: Options<DeleteTeamsByIdMembersByUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteTeamsByIdMembersByUserIdResponses, DeleteTeamsByIdMembersByUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/members/{userId}',
    ...options
});

/**
 * Actualiza el rol de un miembro (requiere TeamsChangeRoles)
 */
export const patchTeamsByIdMembersByUserIdRole = <ThrowOnError extends boolean = false>(options: Options<PatchTeamsByIdMembersByUserIdRoleData, ThrowOnError>) => (options.client ?? client).patch<PatchTeamsByIdMembersByUserIdRoleResponses, PatchTeamsByIdMembersByUserIdRoleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/members/{userId}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Estadisticas de un team (miembros, actividad, etc.)
 */
export const getTeamsByIdStats = <ThrowOnError extends boolean = false>(options: Options<GetTeamsByIdStatsData, ThrowOnError>) => (options.client ?? client).get<GetTeamsByIdStatsResponses, GetTeamsByIdStatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/teams/{id}/stats',
    ...options
});

/**
 * Lista usuarios del tenant
 *
 * Retorna la lista paginada de usuarios del tenant actual. Filtrada automaticamente por tenant_id.
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users',
    ...options
});

/**
 * Lista los departamentos existentes
 *
 * Lista unica de nombres de departments usados por usuarios del tenant.
 */
export const getUsersDepartments = <ThrowOnError extends boolean = false>(options?: Options<GetUsersDepartmentsData, ThrowOnError>) => (options?.client ?? client).get<GetUsersDepartmentsResponses, GetUsersDepartmentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/departments',
    ...options
});

/**
 * Directorio de la empresa agrupado por departamento
 *
 * Retorna usuarios agrupados por departamento para el directorio interno.
 */
export const getUsersDirectory = <ThrowOnError extends boolean = false>(options?: Options<GetUsersDirectoryData, ThrowOnError>) => (options?.client ?? client).get<GetUsersDirectoryResponses, GetUsersDirectoryErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/directory',
    ...options
});

/**
 * Busca usuarios en el tenant
 *
 * Filtro full-text sobre usuarios + filtros por role, status, department.
 */
export const getUsersSearch = <ThrowOnError extends boolean = false>(options?: Options<GetUsersSearchData, ThrowOnError>) => (options?.client ?? client).get<GetUsersSearchResponses, GetUsersSearchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/search',
    ...options
});

/**
 * Elimina un usuario del tenant
 *
 * Requiere permiso SettingsManageUsers. Revoca acceso del usuario y libera su seat.
 */
export const deleteUsersById = <ThrowOnError extends boolean = false>(options: Options<DeleteUsersByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteUsersByIdResponses, DeleteUsersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options
});

/**
 * Obtiene un usuario por ID
 *
 * Retorna la info del usuario indicado dentro del tenant actual. 404 si el usuario no existe o pertenece a otro tenant.
 */
export const getUsersById = <ThrowOnError extends boolean = false>(options: Options<GetUsersByIdData, ThrowOnError>) => (options.client ?? client).get<GetUsersByIdResponses, GetUsersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options
});

/**
 * Actualiza un usuario
 *
 * Permite modificar campos del usuario. Actualizaciones a `presence` disparan broadcast Socket.IO a todo el tenant.
 */
export const putUsersById = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdData, ThrowOnError>) => (options.client ?? client).put<PutUsersByIdResponses, PutUsersByIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cambia el password del usuario autenticado
 *
 * Un usuario solo puede cambiar su propio password. Invalida sesiones activas.
 */
export const postUsersByIdPassword = <ThrowOnError extends boolean = false>(options: Options<PostUsersByIdPasswordData, ThrowOnError>) => (options.client ?? client).post<PostUsersByIdPasswordResponses, PostUsersByIdPasswordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Asigna un role a un usuario
 *
 * Requiere permiso SettingsManageUsers. Cambia el role del usuario objetivo.
 */
export const putUsersByIdRole = <ThrowOnError extends boolean = false>(options: Options<PutUsersByIdRoleData, ThrowOnError>) => (options.client ?? client).put<PutUsersByIdRoleResponses, PutUsersByIdRoleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener apps
 */
export const getApps = <ThrowOnError extends boolean = false>(options?: Options<GetAppsData, ThrowOnError>) => (options?.client ?? client).get<GetAppsResponses, unknown, ThrowOnError>({ url: '/apps', ...options });

/**
 * Crear app
 */
export const postApps = <ThrowOnError extends boolean = false>(options: Options<PostAppsData, ThrowOnError>) => (options.client ?? client).post<PostAppsResponses, unknown, ThrowOnError>({
    url: '/apps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener apps activas
 */
export const getAppsActive = <ThrowOnError extends boolean = false>(options?: Options<GetAppsActiveData, ThrowOnError>) => (options?.client ?? client).get<GetAppsActiveResponses, unknown, ThrowOnError>({ url: '/apps/active', ...options });

/**
 * Eliminar app
 */
export const deleteAppsById = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAppsByIdResponses, unknown, ThrowOnError>({ url: '/apps/{id}', ...options });

/**
 * Obtener app por ID
 */
export const getAppsById = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdData, ThrowOnError>) => (options.client ?? client).get<GetAppsByIdResponses, unknown, ThrowOnError>({ url: '/apps/{id}', ...options });

/**
 * Actualizar app
 */
export const putAppsById = <ThrowOnError extends boolean = false>(options: Options<PutAppsByIdData, ThrowOnError>) => (options.client ?? client).put<PutAppsByIdResponses, unknown, ThrowOnError>({
    url: '/apps/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener contexto de app
 */
export const getAppsByIdContext = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdContextData, ThrowOnError>) => (options.client ?? client).get<GetAppsByIdContextResponses, unknown, ThrowOnError>({ url: '/apps/{id}/context', ...options });

/**
 * Instalar app en canal
 */
export const postAppsByIdInstall = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdInstallData, ThrowOnError>) => (options.client ?? client).post<PostAppsByIdInstallResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/install',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Desinstalar app de canal
 */
export const deleteAppsByIdInstallByChannelId = <ThrowOnError extends boolean = false>(options: Options<DeleteAppsByIdInstallByChannelIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAppsByIdInstallByChannelIdResponses, unknown, ThrowOnError>({ url: '/apps/{id}/install/{channelId}', ...options });

/**
 * Listar instalaciones de una app
 */
export const getAppsByIdInstallations = <ThrowOnError extends boolean = false>(options: Options<GetAppsByIdInstallationsData, ThrowOnError>) => (options.client ?? client).get<GetAppsByIdInstallationsResponses, unknown, ThrowOnError>({ url: '/apps/{id}/installations', ...options });

/**
 * Regenerar secret key
 */
export const postAppsByIdRegenerateKey = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdRegenerateKeyData, ThrowOnError>) => (options.client ?? client).post<PostAppsByIdRegenerateKeyResponses, unknown, ThrowOnError>({ url: '/apps/{id}/regenerate-key', ...options });

/**
 * Crear sesión iframe de una app
 */
export const postAppsByIdSession = <ThrowOnError extends boolean = false>(options: Options<PostAppsByIdSessionData, ThrowOnError>) => (options.client ?? client).post<PostAppsByIdSessionResponses, unknown, ThrowOnError>({
    url: '/apps/{id}/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Obtener apps a renderizar para un canal
 */
export const getInboxChannelsByIdApps = <ThrowOnError extends boolean = false>(options: Options<GetInboxChannelsByIdAppsData, ThrowOnError>) => (options.client ?? client).get<GetInboxChannelsByIdAppsResponses, unknown, ThrowOnError>({ url: '/inbox/channels/{id}/apps', ...options });

/**
 * Obtener apps a renderizar para una conversación
 */
export const getInboxConversationsByIdApps = <ThrowOnError extends boolean = false>(options: Options<GetInboxConversationsByIdAppsData, ThrowOnError>) => (options.client ?? client).get<GetInboxConversationsByIdAppsResponses, unknown, ThrowOnError>({ url: '/inbox/conversations/{id}/apps', ...options });

/**
 * Verificar webhook Instagram (global / Facebook Login)
 *
 * Endpoint UNICO para todos los channels Instagram conectados via OAuth. Mismo `FB_WEBHOOK_VERIFY_TOKEN` global que WhatsApp y Messenger. URL en App Dashboard → Webhooks → Instagram: `https://api.blazeteams.com/api/webhooks/instagram`.
 */
export const getWebhooksInstagram = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksInstagramData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksInstagramResponses, GetWebhooksInstagramErrors, ThrowOnError>({ url: '/webhooks/instagram', ...options });

/**
 * Procesar webhook Instagram (global / Facebook Login)
 *
 * Entry point para channels Instagram via OAuth. Identifica el channel por `entry[].id` (instagram_account_id) o por `entry[].changes[].value.id` segun el tipo de evento. Signature `X-Hub-Signature-256` validada contra `FB_APP_SECRET`. Siempre 200 + `EVENT_RECEIVED`.
 */
export const postWebhooksInstagram = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksInstagramData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksInstagramResponses, unknown, ThrowOnError>({
    url: '/webhooks/instagram',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar webhook Instagram (per-channel, legacy)
 *
 * Mismo handshake que WhatsApp — alias interno. Para channels OAuth usar `/webhooks/instagram` global.
 */
export const getWebhooksInstagramByChannelId = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksInstagramByChannelIdData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksInstagramByChannelIdResponses, GetWebhooksInstagramByChannelIdErrors, ThrowOnError>({ url: '/webhooks/instagram/{channelId}', ...options });

/**
 * Procesar webhook Instagram (per-channel, legacy)
 *
 * Recibe DMs y reactions de Instagram para un channel especifico. Modo legacy — los nuevos channels se conectan via OAuth (Facebook Login) y usan el endpoint global `/webhooks/instagram`. Signature validada con `X-Hub-Signature-256` contra el app_secret del channel.
 */
export const postWebhooksInstagramByChannelId = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksInstagramByChannelIdData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksInstagramByChannelIdResponses, PostWebhooksInstagramByChannelIdErrors, ThrowOnError>({
    url: '/webhooks/instagram/{channelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar webhook Messenger (global / Facebook Login)
 *
 * Endpoint UNICO para todos los channels conectados via OAuth. Comparte la misma `FB_WEBHOOK_VERIFY_TOKEN` que WhatsApp e Instagram (todos usan la misma Meta App). URL en App Dashboard → Webhooks → Page subscriptions: `https://api.blazeteams.com/api/webhooks/messenger`.
 */
export const getWebhooksMessenger = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksMessengerData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksMessengerResponses, GetWebhooksMessengerErrors, ThrowOnError>({ url: '/webhooks/messenger', ...options });

/**
 * Procesar webhook Messenger (global / Facebook Login)
 *
 * Entry point para channels conectados via OAuth. El handler lee `entry[].id` (page_id) del payload y lo mapea al channel correcto. Signature `X-Hub-Signature-256` se valida contra `FB_APP_SECRET`. Siempre 200 + `EVENT_RECEIVED` para no disparar reintentos de Meta.
 */
export const postWebhooksMessenger = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksMessengerData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksMessengerResponses, unknown, ThrowOnError>({
    url: '/webhooks/messenger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar webhook Messenger (per-channel, legacy)
 *
 * Mismo handshake que WhatsApp — alias interno. Para channels OAuth usar `/webhooks/messenger` global.
 */
export const getWebhooksMessengerByChannelId = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksMessengerByChannelIdData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksMessengerByChannelIdResponses, GetWebhooksMessengerByChannelIdErrors, ThrowOnError>({ url: '/webhooks/messenger/{channelId}', ...options });

/**
 * Procesar webhook Messenger (per-channel, legacy)
 *
 * Recibe mensajes de Facebook Messenger para un channel especifico. Modo legacy — los nuevos channels usan OAuth y entran por el endpoint global. Signature validada con `X-Hub-Signature-256` contra el app_secret del channel.
 */
export const postWebhooksMessengerByChannelId = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksMessengerByChannelIdData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksMessengerByChannelIdResponses, PostWebhooksMessengerByChannelIdErrors, ThrowOnError>({
    url: '/webhooks/messenger/{channelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Procesar webhook Telegram (per-channel)
 *
 * Entry point para Telegram. A diferencia de Meta, Telegram NO usa HMAC — autentica el webhook con un token secreto en el header `X-Telegram-Bot-Api-Secret-Token` que se configura al hacer `setWebhook` con `secret_token`. Devuelve `{"ok": true}` siempre (Telegram requiere JSON con `ok=true` o reintenta). Una sola URL por bot, configurada al crear el channel: `https://api.blazeteams.com/api/webhooks/telegram/<channelId>`.
 */
export const postWebhooksTelegramByChannelId = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksTelegramByChannelIdData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksTelegramByChannelIdResponses, PostWebhooksTelegramByChannelIdErrors, ThrowOnError>({
    url: '/webhooks/telegram/{channelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar webhook WhatsApp (global / Embedded Signup)
 *
 * Endpoint UNICO compartido por todos los channels creados via Embedded Signup. Meta usa una sola URL de webhook por app de Facebook (no se puede configurar una por channel cuando se usa Embedded Signup). Compara `hub.verify_token` contra la env var `FB_WEBHOOK_VERIFY_TOKEN` (constant-time comparison). URL a configurar en Meta App Settings → Webhooks → WhatsApp: `https://api.blazeteams.com/api/webhooks/whatsapp`.
 */
export const getWebhooksWhatsapp = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksWhatsappData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksWhatsappResponses, GetWebhooksWhatsappErrors, ThrowOnError>({ url: '/webhooks/whatsapp', ...options });

/**
 * Procesar webhook WhatsApp (global / Embedded Signup)
 *
 * Entry point UNICO donde Meta envia eventos de TODOS los channels conectados via Embedded Signup. El handler enruta al channel correcto extrayendo `entry[].changes[].value.metadata.phone_number_id` del payload y mapeandolo al channel del tenant. Tambien soporta CoEx webhooks (history sync, smb_app_state_sync) cuando el body trae un campo `event` top-level. La signature `X-Hub-Signature-256` se valida contra `FB_APP_SECRET`. SIEMPRE devolvemos 200 con `EVENT_RECEIVED` (incluso si el processing falla internamente) — Meta reintenta los webhooks que no responden 200, lo que dispara duplicados.
 */
export const postWebhooksWhatsapp = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksWhatsappData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksWhatsappResponses, unknown, ThrowOnError>({
    url: '/webhooks/whatsapp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verificar webhook WhatsApp (per-channel)
 *
 * Handshake de verificacion que Meta dispara una vez al configurar el callback URL en la app de WhatsApp Business. Compara `hub.verify_token` con el `verify_token` guardado en el channel; si coincide, devuelve `hub.challenge` en plain text. NO requiere autenticacion JWT — Meta lo llama desde sus servidores. Para configurar la URL en Meta: `https://api.blazeteams.com/api/webhooks/whatsapp/<channelId>`. Este endpoint es para channels creados manualmente; para Embedded Signup usar `/webhooks/whatsapp` (sin channelId) — ver GLOBAL.
 */
export const getWebhooksWhatsappByChannelId = <ThrowOnError extends boolean = false>(options: Options<GetWebhooksWhatsappByChannelIdData, ThrowOnError>) => (options.client ?? client).get<GetWebhooksWhatsappByChannelIdResponses, GetWebhooksWhatsappByChannelIdErrors, ThrowOnError>({ url: '/webhooks/whatsapp/{channelId}', ...options });

/**
 * Procesar webhook WhatsApp (per-channel)
 *
 * Entry point para channels configurados manualmente (URL `/api/webhooks/whatsapp/<channelId>`). Mismo formato de payload que el global, pero el channel ya viene resuelto en el path. Signature `X-Hub-Signature-256` validada contra el `app_secret` guardado en el channel config. Siempre 200 + `EVENT_RECEIVED` aunque el procesamiento falle, para evitar reintentos de Meta.
 */
export const postWebhooksWhatsappByChannelId = <ThrowOnError extends boolean = false>(options: Options<PostWebhooksWhatsappByChannelIdData, ThrowOnError>) => (options.client ?? client).post<PostWebhooksWhatsappByChannelIdResponses, PostWebhooksWhatsappByChannelIdErrors, ThrowOnError>({
    url: '/webhooks/whatsapp/{channelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
